var quest = (function(self){
	
	//Private properties
	var callbacks 	= [];
	
	//Utility methods
	var trace = self.trace = function() { var count = arguments.length; for(var i = 0; i < count; i++) { try { console.log(arguments[i]); } catch(error) {};};};
	self.GET = (function getURLVariables() { var vars = {}; var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) { vars[key] = value;}); return vars;}())
	
	//Public properties
	self.xml 						= null;
	self.content					= null;
	self.screens					= null;
	self.currentPage 				= null;
	self.firstPage					= null;
	self.previousPage				= null;
	self.retina						= window.devicePixelRatio > 1;
	
	//Public "constants"
	self.APPLICATION_READY 			= "application-ready";
	self.PAGE_LOAD					= "page-load";
	self.PAGE_UNLOAD				= "page-unload";
	self.PAGE_ANIMATION_COMPLETE 	= "page-animation-complete";
	self.PROGRESS_RETRIEVED			= "progress-retrieved";
	self.PROGRESS_STORED			= "progress-stored";
	self.MODE_STATUS				= "mode-status";
	self.ANIMATION_SPEED			= 100;
	self.PROGRAM_LINKS				= "program-links";
	
	self.loadHash					= window.location.hash.substring(1).replace("screen-","");
	
	function initialize()
	{
		self.update(self.APPLICATION_READY,self.xml);
		
		if(!self.firstPage) self.firstPage = $($(".screen")[0]).attr("id");
		$(".screen").attr("aria-hidden","true").hide();
		
		self.loadScreen(self.firstPage);
		
		$(window).bind('hashchange',browserChangeHandler);

		$("#alerts").click(function(event){
			if($("#alerts").hasClass("reload")) 
			{
				window.location.href = "php/logout.php";
				return;
			}
			$("#alerts").hide().find("div").hide();
			if(lastTarget) $("#"+lastTarget).focus();
			$("#alerts").find("iframe").each(function(){
				$(this).attr("src",$(this).attr("src"));
			});
		}).on("keydown",function(e){
			if(e.keyCode == 27) 
			{
				if($("#alerts").hasClass("reload")) return window.location.reload();
				$("#alerts").hide().find("div").hide();
				$("#alerts").find("iframe").each(function(){
				$(this).attr("src",$(this).attr("src"));
			});
			}

		});

		$("#skipnav").click(function(e){
			$("#"+self.currentPage).attr("tabindex","-1").focus();
		}).on("keydown",function(e){
			if(e.keyCode == 13 || e.keyCode == 32) $("#"+self.currentPage).attr("tabindex","-1").focus();
		});
	}

	function loadContent(){
		$.get(content,function(data){
			self.content = $("#quest-container");
			self.screens = {};
			self.xml = data;
			$(data).find("screen").each(storeScreen);
			$('div.screen[data-no-xml="true"]').each(storeScreen);
			initialize();
		});
	}
	
	function applyXSLTTransformation(pContent,pStyles)
	{
		var xml = loadXML(pContent);
		var xsl = loadXML(pStyles);
		
		/*
		if (window.ActiveXObject)
		{
			document.getElementById("quest-container").innerHTML= xml.transformNode(xsl);
		}
		else if (document.implementation && document.implementation.createDocument)
		{
			var processor = new XSLTProcessor();
			processor.importStylesheet(xsl);
			document.getElementById("quest-container").appendChild(processor.transformToFragment(xml,document));
		}
		
		if(navigator.appCodeName == "Mozilla")
		{
			var html = $("#quest-container").html();
			html = html.replace(/&lt;/gim,"<");
			html = html.replace(/&gt;/gim,">");
			$("#quest-container").html(html);
		} */
		
		self.content = $("#quest-container");
		self.screens = {};
		self.xml = xml;
		$(xml).find("screen").each(storeScreen);
		$('div.screen[data-no-xml="true"]').each(storeScreen);
	}
	
	function storeScreen(index)
	{
		var id = $(this).attr("id");
		var display = $("#"+id);
		self.screens[id] = {display:display,content:$(this)};
	}
	
	function loadXML(pPath)
	{
		var request = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
		request.open("GET",pPath,false);
		try {request.responseType = "msxml-document"; } catch (e) { };
		request.send("");
		return request.responseXML;
	}
	
	function browserChangeHandler()
	{
		var screen = window.location.hash.length ? window.location.hash.substring(1).replace("screen-","") : null;
		if(screen == self.currentPage || !screen) return;
		
		self.loadScreen(screen);
	}
	
	function onPageAnimationComplete()
	{
		self.update(self.PAGE_ANIMATION_COMPLETE);
	}
	
	self.update = function(pType,pData)
	{
		for(var i = 0, count = callbacks.length; i < count; i++)
		{
			callbacks[i](pType,pData);
		}
	}

	self.fetchConstructor = function(id)
	{
		var data = self.screens[id];
		return data.content;
	}
	
	self.loadScreen = function(id,sub)
	{
		self.subpage = sub;
		if(self.currentPage == id || !id) return;
		$("#activity-menu").removeClass("active");

		$(".screen:not(#"+id+")").attr("aria-hidden","true").stop().ariaFadeOut();
		
		if(self.currentPage) 
		{
			self.previousPage = self.currentPage;
			self.update(self.PAGE_UNLOAD,{current:self.currentPage,next:id});
			//$("#"+self.currentPage).stop().ariaFadeOut();
			//$("#"+self.currentPage).attr("aria-hidden","true");
		}
		
		var data = self.screens[id];


		self.currentPage = id;
		if (data)
			self.update(self.PAGE_LOAD,{id:id,content:data.content,display:data.display});
		else
			self.update(self.PAGE_LOAD,{id:id,content:null,display:data.display});
		$("#"+id).stop().ariaFadeIn({complete:onPageAnimationComplete});
		$("#"+id).attr("aria-hidden","false");
		$("#skipnav").focus();

		$("#quest-container").attr("class",id);
		
		window.location.hash = "screen-"+self.currentPage;
				// Paul Foos added content for teacher popups
		if ($("#currPg")) {
			var urlFirst = '<a href="/toolkit/island-lesson-plans/';
			var urlLast = '"> Lesson Plans for this section</a>';
			var urlSlug = '';
			var pageSlug = self.currentPage;
			switch (pageSlug) {
			case 'cove':
				urlSlug = 'collegecareer';
				break;
			case 'mountain':
				urlSlug = 'self';
				break;
			case 'sanctuary':
				urlSlug = 'social';
				break;
			default:
				urlFirst = '';
				urlSlug ='';
				urlLast = '';
				break;
			}
				
		$("#currPg").html(urlFirst + urlSlug + urlLast);}
		if($('#studentPortfolio') && self.currentPage != 'portfolio' ) $('#studentPortfolio').remove();

	}

	self.myAccount = function(force) {
		if(quest.login.role === "teacher" && force !== true) 
		{
			$(".teacher-account-name").html(quest.login.tname);
			$(".teacher-account-email").html(quest.login.temail);
			$(".teacher-account-school").html(quest.login.tschool);
			$(".teacher-account").addClass("render");
		}
		else {
			$(".teacher-account").removeClass("render");
			self.loadScreen('avatar-selection');
		}
	};
	self.hideAccount = function() {
		$(".teacher-account").removeClass("render");
	};

	self.resetPassword = function() {
		var $email = $("#email-reset");
		$email.attr("disabled",null);
		$email.val(null);
		$(".reset-result").hide();
		$("#email-submit").show();
		$("#password-reset-form").off("submit",onPasswordSubmit).on("submit",onPasswordSubmit);
		$(".password-reset").addClass("render");
	};
	self.hidePasswordReset = function() {
		$(".password-reset").removeClass("render");
	};

	function onPasswordSubmit(e) {
		var $email = $("#email-reset");
		var text = $email.val();
		$email.attr("disabled","disabled");
		$email.blur();
		e.preventDefault();

		$(".teacher-loading").addClass("render");

		$("#email-submit").hide();

		$.ajax({url:'php/generate-reset-link.php',type:'POST',data:JSON.stringify({email:text}),dataType:'json',
			success:function(result){
				$(".teacher-loading").removeClass("render");
				$(".reset-result").show();
			},
			error:function(result){
				trace("error",result);
		}});

	}

	self.toggleHelp = function(event)
	{
		event.stopImmediatePropagation();
		
		$(".callouts").fadeIn();
		$(".callout."+self.currentPage).ariaFadeIn();
		$(document).on("keydown.callouts",function(e){
			if(e.keyCode === 27) hideCallouts();
		});
		$(document).on("click.callouts",hideCallouts);
	};

	function hideCallouts()
	{
		$(document).off("keydown.callouts");
		$(document).off("click.callouts");
		$('.callouts, .callout').ariaFadeOut();
	}
	
	self.loadURL = function(pURL)
	{
		window.location.href = pURL;
	}
	
	self.registerEventListener = function(callback)
	{
		callbacks.push(callback);
	}

	self.toggleMenu = function(event)
	{
		if(!$("html").hasClass("surveys-complete")) return;
		var menu = $("#activity-menu");
		menu.toggleClass("active");
		event.stopImmediatePropagation();

		if(menu.hasClass("active")) 
		{
			$("body").on("click.item",function(){
				menu.removeClass("active");
				$("body").off("click.item");
			});
		}
	}
	self.toggleRubric = function(event){
		trace("toggling",$("#rubric-modal"));
		$("#rubric-modal").toggleClass("active");
	};
	var lastTarget;
	self.showAlert = function(id,target)
	{
		lastTarget = target;
		trace("requesting function",id,target);
		$(document).on("mousedown.alert",function(e){

			if($("#alerts").hasClass("reload")) 
			{
				window.location.href = "php/logout.php";
				return;
			}

			$("#alerts").hide();
			$(document).off("mousedown.alert");
			$("#alerts").find("iframe").each(function(){
				$(this).attr("src",$(this).attr("src"));
			});

		});

		$("#alerts").show().find("#alert-"+id).show().attr("tabindex","-1").focus();
		if($("#alerts").show().find("#alert-"+id).find("a").hasClass("reload")) $("#alerts").addClass("reload");
		else $("#alerts").removeClass("reload");
	}

	$("html").addClass("js").removeClass("nojs");
	$(document).ready(loadContent);

	return self;
}(quest = quest || {}))

jQuery.fn.ariaHide = function(pConstructor){$(this).attr("aria-hidden","true"); return $(this).stop().hide(pConstructor);}
jQuery.fn.ariaFadeOut = function(pConstructor){$(this).attr("aria-hidden","true"); return $(this).stop().fadeOut(pConstructor);}
jQuery.fn.ariaShow = function(pConstructor){$(this).attr("aria-hidden","false"); return $(this).stop().show(pConstructor);}
jQuery.fn.ariaFadeIn = function(pConstructor){$(this).attr("aria-hidden","false"); return $(this).stop().fadeIn(pConstructor);}



quest.activityManager = (function(quest,self){
	
	var trace 				= quest.trace;

	self.activities = [];

	self.saveActivity = function(activity,callback)
	{
		$.ajax({url:'php/activities.php',type:'POST',data:{id: activity.id, page: activity.page, type: activity.type, data:JSON.stringify(activity.data)},dataType:'json',success:function(data){
			data.data = JSON.parse(data.data);
			storeActivity(data);
			if(callback) callback(data);
		},error:onActivityError});
	}
	self.getActivity = function(type,page)
	{
		for(var i = 0, count = self.activities.length; i < count; i++)
		{
			var activity = self.activities[i];
			if(activity.type == type && activity.page == page) return activity;
		}
		return null;
	}

	function onApplicationUpdate(type,data)
	{	
		if(type == "progress-retrieved")
		{
			for(var i = 0, count = quest.login.activities.length; i < count; i++)
			{
				var activity = quest.login.activities[i];
				activity.data = JSON.parse(activity.data);
				storeActivity(activity);

			}

			quest.update("activities-retrieved",self.activities);
		}
	}

	function storeActivity(activity)
	{
		var exists = activityExists(activity);
		if(!exists) self.activities.push(activity);
		else updateActivity(exists,activity);
	}

	function activityExists(activity)
	{
		for(var i = 0, count = self.activities.length; i < count; i++)
		{
			var existing = self.activities[i];
			if(existing.id == activity.id) return existing;
		}
		return null;
	}
	function updateActivity(existing,source)
	{
		for(var prop in existing) {existing[prop] = source[prop];}
	}

	function onActivityUpdate(data, textStatus, jqXHR)
	{
		storeActivity(data);
	}
	function onActivityError(data, textStatus, jqXHR)
	{
		trace(textStatus,data);
		quest.showAlert("shutdown");
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.activityManager = quest.activityManager || {}))

quest.settings = (function(quest,self){
	
	self.ANIMATION_SPEED 			= 100;
	self.LOGIN_PAGE					= "login";
	self.ACCOUNT_PAGE				= "account";
	self.AVATAR_SELECTION_PAGE		= "avatar-selection";
	self.PORT_PAGE					= "port";
	self.DREAM_BIG_PAGE				= "dream-big";
	self.PORTFOLIO_PAGE				= "portfolio";
	self.GLOSSARY_PAGE				= "glossary";
	self.HUT_PAGE					= "hut";
	self.MAP_PAGE					= "map";
	self.COLLAGE_PAGE				= "collage";
	self.WARDROBE_PAGE				= "wardrobe";
	self.COVE_PAGE					= "cove";
	self.COVE_ACTIVITY_PAGE			= "cove-activity";
	self.MOUNTAIN_PAGE				= "mountain";
	self.MOUNTAIN_ACTIVITY_PAGE		= "mountain-activity";
	self.ORGANIZER_PAGE				= "organizer";
	self.PROMPT_PAGE				= "prompt";
	self.SANCTUARY_PAGE				= "sanctuary";
	self.SANCTUARY_ACTIVITY_PAGE	= "sanctuary-activity";
	self.TEACHER_LANDING_PAGE		= "teacher-landing";
	self.STUDENT_LANDING_PAGE		= "student-landing";
	self.VIDEO_PAGE					= "video";
	self.WHEEL_PAGE					= "wheel";
	self.CLICKABLE_DIALOG			= "clickable-container";
	self.DOWNLOADER_SCRIPT			= "php/downloader.php";
	self.UPLOADER_SCRIPT			= "php/text-uploader.php";
	self.TEACHER_ADMINISTRATION_CONTAINER_PAGE = "teacher-administration-container";


	self.MAX_DREAM_BIG_SELECTIONS	= 4;
	self.MAX_DREAM_BIG_CYCLES		= 8;
	
	self.avatar						= "avatar-2";
	self.mate						= "mate-2";
	self.username					= "quest";
	self.defaultUserName			= "Guest";
	self.mobile						= BrowserDetect.mobile;

	
	return self;
}(quest,quest.settings = quest.settings || {}));

quest.login = (function(quest,self){

	var trace 				= quest.trace;
	var content 			= null;
	var request 			= null;
	var username			= "Guest";
	var headerTemplate		= null;
	var linkClicked 		= false;

	self.userid = 0;
	self.username = "guest";
	self.fname = "Guest";
	self.lname = "User";
	self.avatar = "avatar-2";
	self.mate = "mate-2";
	self.mode = "user";
	self.role = "role"; // Paul Foos added role
	self.activities = [];
	self.yearList = [];

	self.playAsGuest = function()
	{
		return alert("Coming soon!");
		self.mode = "guest";
		quest.update(quest.MODE_STATUS,{status:"guest"});
		$("#header").find("#header-name").html(headerTemplate.replace("${username}",username));
		$("#header").ariaShow();
		quest.loadScreen(quest.settings.AVATAR_SELECTION_PAGE);
	}

	self.createAccount = function()
	{
		var username = $("#account-form").find('input[name="username"]')[0].value;
		var password = $("#account-form").find('input[name="password"]')[0].value;
		var fname = $("#account-form").find('input[name="firstname"]')[0].value;
		var lname = $("#account-form").find('input[name="lastname"]')[0].value;
		var code = $("#account-form").find('input[name="classcode"]')[0].value;
		var assent = $("#assent").find('input[id="assent-yes"]').get(0).checked ? "true" : "false";

		$("#account-form").find(".account-prompt").ariaHide();

		var empty = /\s+/gim;
		if(!username.replace(empty,"").length || !password.replace(empty,"").length || !code.replace(empty,"").length)
		{
			if(!username.replace(empty,"").length) $("#account-form").find("p#username-warning").ariaShow();
			if(!password.replace(empty,"").length) $("#account-form").find("p#password-warning").ariaShow();
			if(!code.replace(empty,"").length) $("#account-form").find("p#classcode-warning").ariaShow();
			return;
		}

		$.ajax({url:'php/account.php',type:'POST',data:{username:username, password:password, assent:assent , firstname:fname, lastname:lname,code:code },dataType:'json',success:accountHandler,error:errorHandler});
	}

	// PF teacher account creation
	self.createTeachaccount = function()
	{
		var username = $("#teachaccount-form").find('input[name="email"]')[0].value;
		var password = $("#teachaccount-form").find('input[name="password"]')[0].value;
		var fname = $("#teachaccount-form").find('input[name="firstname"]')[0].value;
		var lname = $("#teachaccount-form").find('input[name="lastname"]')[0].value;
		var email = $("#teachaccount-form").find('input[name="email"]')[0].value;
		var precode = $("#teachaccount-form").find('input[name="classcode"]')[0].value;
		var code = precode.substr(6);
		var teachverify = precode.substr(0,6);
		var classinfo = $("#teachaccount-form").find('input[name="classinfo"]')[0].value;
		var school = $("#teachaccount-form").find('input[name="school"]')[0].value;
// PF hacking assent
		var assent = 'true';
		$("#teachaccount-form").find(".account-prompt").ariaHide();

		var empty = /\s+/gim;
		if(!password.replace(empty,"").length || !code.replace(empty,"").length || !classinfo.replace(empty,"").length || !school.replace(empty,"").length)
		{
		// PF -- for teachers, use email address as username
	//		if(!username.replace(empty,"").length) $("#teachaccount-form").find("p#username-warning").ariaShow();
			if(!password.replace(empty,"").length) $("#teachaccount-form").find("p#password-warning").ariaShow();
			if(!code.replace(empty,"").length) $("#teachaccount-form").find("p#classcode-warning").ariaShow();
			if(!classinfo.replace(empty,"").length) $("#teachaccount-form").find("p#classinfo-warning").ariaShow();
			if(!school.replace(empty,"").length) $("#teachaccount-form").find("p#schoolname-warning").ariaShow();
			return;
		}
// PF mor assent hacking for teachers
		$.ajax({url:'php/account.php',type:'POST',data:{username:email, password:password, email:email,firstname:fname, lastname:lname,code:code,teachverify:teachverify, school:school,classinfo:classinfo,assent: assent },dataType:'json',success:teachAccountHandler,error:errorHandler});
	}


	self.cancelAccountCreation = function()
	{
		$("#account-form").find('input[name="username"]')[0].value = "";
		$("#account-form").find('input[name="password"]')[0].value = "";
		quest.loadScreen(quest.settings.LOGIN_PAGE);
	}

  // PF added
	self.cancelTeachaccountCreation = function()
	{
		$("#teachaccount-form").find('input[name="email"]')[0].value = "";
		$("#teachaccount-form").find('input[name="password"]')[0].value = "";
		quest.loadScreen(quest.settings.LOGIN_PAGE);
	}

	self.login = function()
	{
		trace("logging in");
		var username = $("#login-form").find('input[name="username"]')[0].value;
		var password = $("#login-form").find('input[name="password"]')[0].value;
		$.ajax({url:'php/login.php',type:'POST',data:{type:"login", username:username, password:password },dataType:'json',success:loginHandler,error:errorHandler});
	}
	self.logout = function()
	{
		$.post("php/login.php", {type:"logout"},logoutHandler);
	}

	function loginHandler(data, textStatus, jqXHR)
	{
		if(!data.authenticated)
		{
			$("#login-form").ariaShow();
			$("#header").find("#header-name").html(headerTemplate.replace("${username}",quest.settings.defaultUserName));
		}
		else
		{
			$("#header").find("#header-name").html(headerTemplate.replace("${username}",data.username));

  			// PF added teacher menu and sso login for toolkit site.
	if(data.role && data.role == 'teacher')
	{
		self.yearList = data.yearList;
		
		// $("body").find("#header").after("<div id=\"teachDrop\"><h4 class=\"closer\" onclick=\"toggleToolkit()\">Teacher Resources</h4><div class=\"popupList\"><img alt=\"Close Window\" class=\"closer closerX\" src=\"images/toolkit/closer.png\" onclick=\"toggleToolkit()\" /><ul><li><a href=\"/toolkit\">Teacher Toolkit</a></li><li><a href=\"/toolkit/island-lesson-plans/\">All Lesson Plans</a></li><li id=\"currPg\">&nbsp;</li><li><a href=\"/toolkit/teacher/administrator/\">Administer Students</a></li></ul></div></div>");
  			//	alert(data.drupallogged);
  			$("body").find("#header").after("<button id='teacher-resources' onclick='quest.loadScreen(\"teacher-landing\")'>Teacher Resources</button>");

  			var rawpassword = $("#login-form").find('input[name="password"]')[0].value;
			var url = '/toolkit/fqilogin/user/login';
			if (rawpassword && rawpassword != '' && data.drupallogged == 'unlogged') {
			 $.post(url, { username: data.username, password: rawpassword }, function(data) {
			     sessName = data.session_name;
			     sessId = data.sessid;

			     $.cookie(sessName, sessId);

			     // Obtain session token.
			     $.ajax({
			       url:"/toolkit/services/session/token",
			       type:"get",
			       dataType:"text",
			       error:function (jqXHR, textStatus, errorThrown) {
			         alert(errorThrown);
			       },
			       success: function (token) {

			         $.ajax({
			           url: '/toolkit/fqilogin/user/token',

			           beforeSend: function (request) {
			             request.setRequestHeader("X-CSRF-Token", token);
			           },
			           error: function (jqXHR, textStatus, errorThrown) {
			             alert(errorThrown);
			           },
			           success: function (data) {
			             alert('Hello user #' + data.user.uid);
			           }
			         });
			       }
			     });
			 });}}
        // end PF added

// PF exempt teachers from assent  duh!
	        if(data.assent === null && data.role != 'teacher')
	        {
	        	$("#assent-modal").show();
	        }

			$("#header").ariaShow();

			quest.settings.username = data.username;
			quest.settings.mate = data.mate;
			quest.settings.avatar = data.avatar;
			quest.settings.role = data.role;
			self.activities = data.activities;
			quest.settings.images = data.support;
			quest.login.userid = 1;
			quest.login.username = data.username;
			quest.login.role = data.role;  // PF added role
			quest.login.completions = data.completions;
			quest.login.fname = data.fname;
			quest.login.lname = data.lname;
			quest.login.tname = data.tname;
			quest.login.tschool = data.tschool;
			quest.login.temail = data.temail;

			quest.update(quest.PROGRESS_RETRIEVED,data.progress);
			quest.update("login");

			if(data.role === "teacher") {
				$("html").addClass("teachermode");
			}

			if(!quest.settings.mate) (quest.loadScreen(quest.settings.AVATAR_SELECTION_PAGE));
			else if(quest.loadHash.length && quest.loadHash != quest.settings.LOGIN_PAGE) quest.loadScreen(quest.loadHash);
			else quest.loadScreen(data.role == "teacher" ? quest.settings.TEACHER_LANDING_PAGE : quest.settings.PORT_PAGE);
		}

		if(data.badAttempt) $("#login-error").ariaShow();
	}
	function accountHandler(data, textStatus, jqXHR)
	{
		if(data.badAttempt)
		{
			if(data.usernameExists) $("#account-form").find("p#username-error").ariaShow();
			if(data.badCode) $("#account-form").find("p#classcode-error").ariaShow();
		}
		else
		{
			$.ajax({url:'php/login.php',type:'POST',data:{type:"login", username:$("#account-form").find('input[name="username"]')[0].value, password:$("#account-form").find('input[name="password"]')[0].value },dataType:'json',success:loginHandler,error:errorHandler});
			/*self.username = $("#account-form").find('input[name="username"]')[0].value;
			quest.settings.username = $("#account-form").find('input[name="username"]')[0].value;
			quest.loadScreen(quest.settings.AVATAR_SELECTION_PAGE);

			$("#header").find("#header-name").html(headerTemplate.replace("${username}",self.username));
			$("#header").ariaShow();
			quest.update("login");*/
		}
	}

  // PF functions for teacher login

	function teachAccountHandler(data, textStatus, jqXHR)
	{
		if(data.badAttempt)
		{
		//	if(data.usernameExists) $("#teachaccount-form").find("p#username-error").ariaShow();
			if(data.badCode) $("#teachaccount-form").find("p#classcode-error").ariaShow();
			if(data.emailExists) $("#teachaccount-form").find("p#emailused-warning").ariaShow();

		if(data.teachercodeExists) $("#teachaccount-form").find("p#teacherused-warning").ariaShow();
	}
		else
		{
			self.username = $("#teachaccount-form").find('input[name="email"]')[0].value;

			quest.settings.username = $("#teachaccount-form").find('input[name="email"]')[0].value;
			quest.loadScreen(quest.settings.AVATAR_SELECTION_PAGE);

			$("#header").find("#header-name").html(headerTemplate.replace("${username}",self.username));
			//$("body").find("#header").after("<div id=\"teachDrop\"><h4 class=\"closer\" onclick=\"toggleToolkit()\">Teacher Resources</h4><div class=\"popupList\"><img alt=\"Close Window\" class=\"closer closerX\" src=\"images/toolkit/closer.png\" onclick=\"toggleToolkit()\" /><ul><li><a href=\"/toolkit\">Teacher Toolkit</a></li><li><a href=\"/toolkit/island-lesson-plans/\">All Lesson Plans</a></li><li id=\"currPg\">&nbsp;</li><li><a href=\"/toolkit/teacher/administrator\">Administer Students</a></li></ul></div></div>");
			$("body").find("#header").after("<button id='teacher-resources' onclick='quest.loadScreen(\"teacher-landing\")'>Teacher Resources</button>");

			var rawpassword = $("#teachaccount-form").find('input[name="password"]')[0].value;
			var username = $("#teachaccount-form").find('input[name="email"]')[0].value;
			var password = $("#teachaccount-form").find('input[name="password"]')[0].value;
			var fname = $("#teachaccount-form").find('input[name="firstname"]')[0].value;
			var lname = $("#teachaccount-form").find('input[name="lastname"]')[0].value;
			var email = $("#teachaccount-form").find('input[name="email"]')[0].value;
			var precode = $("#teachaccount-form").find('input[name="classcode"]')[0].value;
			var code = precode.substr(6);
			var teachverify = precode.substr(0,6);
			var classinfo = $("#teachaccount-form").find('input[name="classinfo"]')[0].value;
			var school = $("#teachaccount-form").find('input[name="school"]')[0].value;

			   var url = '/toolkit/fqilogin/user/register';
				if (rawpassword && rawpassword != '') {
			     $.post(url, { "name": username, "pass": rawpassword,
					"mail": email, "status": 1,
					"field_first_name": {
					"und": {
					"0":{"value":fname }
					}
					},
					"field_last_name": {
					"und": {
					"0":{"value":lname }
					}
					},
					"field_school_name": {
					"und": {
					"0":{"value":school }
					}
					},

					"field_class_information": {
					"und": {
					"0":{"value":classinfo }
					}
					},

					"field_class_code": {
					"und": {
					"0":{"value":code }
					}
					},

					"field_teacher_verification": {
					"und": {
					"0":{"value":teachverify }
					}
					},

					"roles": ["4"],
				  }, function(data) {
			         sessName = data.session_name;
			         sessId = data.sessid;

			         $.cookie(sessName, sessId);

			         // Obtain session token.
			         $.ajax({
			           url:"/toolkit/services/session/token",
			           type:"get",
			           dataType:"text",
			           error:function (jqXHR, textStatus, errorThrown) {
			             alert(errorThrown);
			           },
			           success: function (token) {

			             $.ajax({
			               url: '/toolkit/fqilogin/user/token',

			               beforeSend: function (request) {
			                 request.setRequestHeader("X-CSRF-Token", token);
			               },
			               error: function (jqXHR, textStatus, errorThrown) {
			                 alert(errorThrown);
			               },
			               success: function (data) {
			                 alert('Hello user #' + data.user.uid);
			               }
			             });
			           }
			         });
			     });     }









			$("#header").ariaShow();
	//	setTimeout( function() {loginDrupal(username,rawpassword);}, 5000);
			quest.update("login")

		}
	}



  self.changeTeachpwd = function()
  {

  	var email = $("#teachpwdchange").find('input[name="email"]')[0].value;

  	$("teachpwdchange-form").find(".account-prompt").ariaHide();

  	var empty = /\s+/gim;


  		if(!email.replace(empty,"").length) { $("#teachpwdchange-form").find("p#chemail-warning").ariaShow();

  		return;
  	}



  var url = '/toolkit/fqilogin/user/request_new_password.json';
  if (email) {

   $.post(url, { "name": email,"mail": email }, function(data) {
       sessName = data.session_name;
       sessId = data.sessid;

       $.cookie(sessName, sessId);

       // Obtain session token.
       $.ajax({
         url:"/toolkit/services/session/token",
         type:"get",
         dataType:"text",
         error:function (jqXHR, textStatus, errorThrown) {
           alert(errorThrown);
         },
         success: function (token) {

           $.ajax({
             url: '/toolkit/fqilogin/user/token',

             beforeSend: function (request) {
               request.setRequestHeader("X-CSRF-Token", token);
             },
             error: function (jqXHR, textStatus, errorThrown) {
               alert(errorThrown);
             },
             success: function (data) {
               alert('Hello user #' + data.user.uid);
             }
           });
         }
       });
   });
  }




  }



	function loginDrupal(username,rawpassword)
	{

			// alert(data.username);
		   var url = '/toolkit/fqilogin/user/login';
			if (rawpassword && rawpassword != '') {
		     $.post(url, { username: username, password: rawpassword }, function(data) {
		         sessName = data.session_name;
		         sessId = data.sessid;

		         $.cookie(sessName, sessId);

		         // Obtain session token.
		         $.ajax({
		           url:"/toolkit/services/session/token",
		           type:"get",
		           dataType:"text",
		           error:function (jqXHR, textStatus, errorThrown) {
		             alert(errorThrown);
		           },
		           success: function (token) {

		             $.ajax({
		               url: '/toolkit/fqilogin/user/token',

		               beforeSend: function (request) {
		                 request.setRequestHeader("X-CSRF-Token", token);
		               },
		               error: function (jqXHR, textStatus, errorThrown) {
		                 alert(errorThrown);
		               },
		               success: function (data) {
		                 alert('Hello user #' + data.user.uid);
		               }
		             });
		           }
		         });
		     });     }
	}

	function logoutHandler(data, textStatus, jqXHR)
	{
		window.location = "index.html";
	}

	// Paul Foos added 4/10
	function logoutDrupal()
	{


		   var url = '/toolkit/fqilogin/user/logout';

		   $.ajax({
		    url:"/toolkit/services/session/token",
		    type:"get",
		    dataType:"text",
		    error:function (jqXHR, textStatus, errorThrown) {
		  //   alert(jqXHR);
		  //   alert(textStatus);
		     // alert(errorThrown);
		    },
		    success: function (token) {
		          // Call system connect with session token.
		      $.ajax({

		       url: "/toolkit/fqilogin/user/logout",
		       type: 'post',
		       dataType: 'json',
		           beforeSend: function (request) {
		          request.setRequestHeader("X-CSRF-Token", token);
		        },
		       error: function (jqXHR, textStatus, errorThrown) {
		     //    alert('button_logout - failed to logout');
		     //    alert(JSON.stringify(jqXHR));
		      //  alert(JSON.stringify(textStatus));
		    //     alert(JSON.stringify(errorThrown));
		       },
		       success: function (data) {
		    //   alert("You have been logged out.");
		        window.location = "index.html";
		       }
		   });
		    }
		  });

	}

	function initialize(pXML)
	{
		content = $(pXML).find('screen[id="login"]');
		headerTemplate = $(quest.xml).find('paragraph[id="header-name"]').text();
		quest.firstPage = quest.settings.LOGIN_PAGE;
		$.ajax({url:'php/login.php',type:'POST',data:{type:"login"},dataType:'json',success:loginHandler,error:errorHandler});
	}

	function errorHandler(data, textStatus, jqXHR)
	{
		trace(data,textStatus,jqXHR);
	}

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.APPLICATION_READY) initialize(pData);
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.LOGIN_PAGE) configure();
	}

	function loginEnterHandler(event)
	{
		if(event.keyCode != 13) return;
		self.login();
	}
	function accountEnterHandler(event)
	{
		if(event.keyCode != 13) return;
		self.createAccount();
	}
	function configure()
	{
		$("form#login").find("input[name='password']").keydown(loginEnterHandler);
		//$("form#account").find("input[name='classcode']").keydown(accountEnterHandler);

		$("div#assent-form").find("a.iframe-link").click(onLinkClick);
		$("div.assent-form").find("a.iframe-link").click(onLinkClick);
		$("#iframe-popup").find("a.close-button").click(onCloseWindow);
		$("form#assent").submit(onAssentSubmit);
		$("form#assent-modal").submit(onAssentSubmitModal);
		$("div#assent-form").find("input[type='radio']").on("change",validateChoices);

	}

	function validateChoices(event)
	{
		if($("#assent-yes").get(0).checked && linkClicked)
		{
			$("div#assent-form").find("input[type='submit']").attr("disabled",null);
		}
		else
		{
			$("div#assent-form").find("input[type='submit']").attr("disabled",null); //true
		}

		if($("#assent-yes-modal").get(0).checked && linkClicked)
		{
			$("div.assent-form").find("input[type='submit']").attr("disabled",null);
		}
		else
		{
			$("div.assent-form").find("input[type='submit']").attr("disabled",null); //true
		}
	}
	function onAssentSubmit(event)
	{
		event.preventDefault();
		self.createAccount();
	}
	function onAssentSubmitModal(event)
	{
		event.preventDefault();
		var assent = $("#assent-modal").find('input[id="assent-yes-modal"]').get(0).checked ? "true" : "false";
		$.ajax({url:'php/account.php',type:'POST',data:{assent:assent, assentUpdate:true},dataType:'json',success:function(){
			$("#assent-modal").fadeOut();
		},error:errorHandler});
	}
	function onLinkClick(event)
	{
		$("div#iframe-popup").find("iframe").attr("src",$(this).data("url")).parent().fadeIn();

	}
	function onCloseWindow(event)
	{
		linkClicked = true;
		$("div#iframe-popup").find("iframe").attr("src","").parent().fadeOut();
		validateChoices();
	}

	quest.registerEventListener(onApplicationUpdate);

	return self;
}(quest,quest.login = quest.login || {}))

quest.progress = (function(quest,self){
	
	var trace = quest.trace;
	var bookmarks = {};
	self.currentBookmark = null;


	self.activityComplete = function()
	{
		if(!self.currentBookmark) return;
		self.currentBookmark.complete = true;
		commitProgressToServer();
	}
	
	self.getCompletedBookmarks = function()
	{
		var results = [];
		
		for(var page in bookmarks)
		{
			var bookmark = bookmarks[page];
			if(bookmark.complete) results.push(bookmark);
		}
		
		results.sort(function(a,b){return a.index-b.index})
		
		return results;
	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PROGRESS_RETRIEVED) storeProgress(pData);
		else if(pType == "application-ready") initialize(pData)
		else if(pType == quest.PAGE_ANIMATION_COMPLETE) updateCurrentBookmark();
		else if(pType == quest.MODE_STATUS && pData.status == "guest") enterGuestMode();
	}
	
	function initialize(pData)
	{
		$(".activity-done").click(self.activityComplete());
		$(pData).find("bookmark").each(storeBookmark);
	}
	
	function enterGuestMode()
	{
		for(var page in bookmarks)
		{
			var bookmark = bookmarks[page];
			if(bookmark.autoCompleteForGuest) bookmark.complete = true;
		}
	}
	
	function storeProgress(pData)
	{
		for(var code in pData)
		{
			var remote = JSON.parse(pData[code]);
			var bookmark = fetchBookmarkByCode(code);
			
			bookmark.complete = remote.complete;
			bookmark.data = remote.data;
		}
	}
	
	function updateCurrentBookmark()
	{
		self.currentBookmark = bookmarks[quest.currentPage];
		if(!self.currentBookmark) return;
		
		if(self.currentBookmark.type == "S" && !self.currentBookmark.complete) 
		{
			self.currentBookmark.complete = true;
			commitProgressToServer();
		}
	}
	
	function commitProgressToServer()
	{
		if(quest.login.mode == "guest") return;

		var code = self.currentBookmark.code;
		var type = "store";
		var data = JSON.stringify(self.currentBookmark);
		var username = quest.settings.username;
		
		$.ajax({url:'php/progress.php',type:'POST',data:{username:username,type:type,bookmark:code,data:data},dataType:'json',success:submitHandler,error:errorHandler});
	
	}
	
	function submitHandler(data, textStatus, jqXHR)
	{
		quest.update(quest.PROGRESS_STORED,self.currentBookmark);
	}
	function errorHandler(data, textStatus, jqXHR)
	{
		trace("error",data,textStatus)
	}
	
	function storeBookmark(index)
	{
		var bookmark = {index:index,code: $(this).attr("code"),type:$(this).attr("type"),complete:false,page:$(this).parent().attr("id"),data:{}};
		if(!bookmark.type || !bookmark.type.length) bookmark.type = "S";
		bookmark.autoCompleteForGuest = $(this).attr("autoCompleteForGuest") == "true";
		bookmarks[bookmark.page] = bookmark;
	}
	
	function fetchBookmarkByCode(pCode)
	{
		for(var prop in bookmarks)
		{
			var bookmark = bookmarks[prop];
			if(bookmark.code == pCode) return bookmark;
		}
		return null;
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.progress = quest.progress || {}));

quest.animator = (function(quest,self){
	
	var trace = quest.trace;
	var animations = {};
	var interval = 0;
	var currentAnimations = null;
	
	function initialize(pData)
	{
		$(pData).find("animation").each(storeAnimation);
	}
	
	function storeAnimation(index)
	{
		var id = $(this).attr("id").toString();
		animations[id] = {display: $("#"+id),content: $(this),time:0,loops:0};
	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.APPLICATION_READY) initialize(pData);
		else if(pType == quest.PAGE_UNLOAD) deconfigure(pData);
		else if(pType == quest.PAGE_LOAD) configure(pData);
	}
	
	function configure(pScreen)
	{
		var screen = $("#"+pScreen.id);
		var items = screen.find(".animation");
		if(!items.length) return;
		
		currentAnimations = [];
		
		for(var i = 0, count = items.length; i < count; i++)
		{
			var item = items[i];
			var id = $(item).attr("id").toString();
			currentAnimations.push(animations[$(item).attr("id")]);
		}
		
		interval = setInterval(tick,quest.ANIMATION_SPEED);
	}
	function deconfigure(pScreen)
	{
		clearInterval(interval);
	}
	function tick()
	{
		for(var i = 0,count = currentAnimations.length; i < count; i++)
		{
			var animation = currentAnimations[i];
			var display = animation.display;
			var content = animation.content;
			var loops = parseInt(content.attr("loops")); 
			var start = parseInt(content.attr("timeIn"))
			if(animation.loops >= loops && loops) continue;
			
			var images = display.find("img");
			var sources = content.find("image");
			var duration = parseInt(content.attr("duration"));
			
			animation.time += quest.ANIMATION_SPEED;
			
			if(animation.time < start) continue;
			
			for(var j = images.length - 1; j >= 0; j--)
			{
				var image = $(images[j]);
				var source = $(sources[j]);
				var timeIn = parseInt(source.attr("timeIn"));
				var timeOut = parseInt(source.attr("timeIn")) + parseFloat(source.attr("duration"));
				
				if(animation.time >= timeIn && animation.time <= timeOut) image.show();
				else image.hide();
			}
			
			if(animation.time >= (start + duration)) 
			{
				animation.time = start;
				animation.loops ++;
			}
		}
	}
	
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.animator = quest.animator || {}))

quest.preloader = (function(quest,self){
	
	var trace = quest.trace;
	var images = [];
	var timeout = 0;
	var count = 0;
	function onApplicationUpdate(pType,pData)
	{
		if(pType == "application-ready") preload();
	}
	
	function preload()
	{
		$(document).find("img").each(storeImage);
		$(quest.xml).find("preload").each(storeImage);
		$(images).preload({onComplete:onComplete,onFinish:complete});
		
		timeout = setTimeout(complete,5000);
	}

	function onComplete(data)
	{
		count ++;

		var percent = Math.round(count*100/images.length);
		$("#preloader").attr("aria-valuenow",percent);
	}
	function complete(data)
	{
		clearTimeout(timeout);
		$("#preloader").ariaFadeOut();
	}
	
	function storeImage(index)
	{
		var source = $(this).attr("src")
		var retina = source.indexOf("@2x") > -1;
		if(retina && !quest.retina) return;
		if(images.indexOf(source) > -1) return;
		images.push(source);
	}
	
	quest.registerEventListener(onApplicationUpdate);
	return self;
}(quest,quest.preloader = quest.preloader || {}));

quest.avatars = (function (quest,self){
	
	var trace 			= quest.trace;
	var configured 		= false;
	var avatars			= [];
	var mates			= [];
	var featuredAvatar	= 1;
	var featuredMate	= 1;
	var avatarBackground= null;
	var mateBackground	= null;

	var alt = self.alt = {"1":"boy in blue motorized chair", "2":"boy in blue shirt, brown pants", "3":"african american girl with blue tshirt", "4":"boy in brown shirt", "5":"asian girl in dark green tshirt", "6":"girl in purple shirt", "7":"african american boy in brown shirt", "9":"girl in yellow motorized chair", "10":"boy with blue sunglasses", "11":"girl with yellow mask and red shirt", "12":"boy in red motorized chair", "13":"boy in turquoise motorized chair", "14":"girl in green motorized chair", "15":"african american girl in orange shirt", "16":"tall boy in gray shirt", "17":"tall girl with headset", "18":"short african american boy with green shirt", "19":"short boy with light blue shirt", "20":"girl with green shirt", "21":"boy with yellow shirt"};
	var mateAlt = self.mateAlt = {"1":"First mate: Girl with purse", "2":"First mate: swarthy sea captain in rain coat", "3":"First mate: Boy with trench coat", "4":"First mate: Girl with purse", "5":"First mate: swarthy sea captain in rain coat", "6":"First mate: Boy with trench coat"};
	var offsets = {"avatar-1":-53,"avatar-9":-55,"avatar-12":-46,"avatar-13":-61,"avatar-14":-61};
	var proceedToLanding = true;

	self.assignAltText = assignAltText;

	self.advanceAvatars = function()
	{
		if(featuredAvatar >= avatars.length - 1) return;
		featuredAvatar++;
		
		animateAvatars();
	}
	self.rewindAvatars = function()
	{
		if(featuredAvatar <= 0) return;
		featuredAvatar--;
		
		animateAvatars();
	}
	self.advanceMates = function()
	{
		if(featuredMate >= mates.length - 1) return;
		featuredMate++;
		
		animateMates();
	}
	self.rewindMates = function()
	{
		if(featuredMate <= 0) return;
		featuredMate--;
		
		animateMates();
	}
	
	self.makeSelection = function()
	{
		var data = {avatarid:$(".avatar.featured").attr("id"),mateid:$(".mate.featured").attr("id")};
		quest.settings.avatar = data.avatarid;
		quest.settings.mate = data.mateid;
		
		$.ajax({url:'php/avatars.php',type:'POST',data:data,dataType:'json',success:serverResponseHandler,error:serverResponseHandler});
	}
	self.cancelSelection = function()
	{
		quest.loadScreen(quest.previousPage);
	}
	
	function serverResponseHandler(data, textStatus, jqXHR)
	{
		if(proceedToLanding === true) quest.loadScreen(quest.settings.STUDENT_LANDING_PAGE);
		else quest.loadScreen(quest.previousPage);
	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.AVATAR_SELECTION_PAGE) configure();
	}
	
	function animateAvatars(pQuickSet)
	{
		avatarBackground.stop().hide();
		
		for(var i = 0, count = avatars.length; i < count; i++)
		{
			var avatar = avatars[i];
			var quick = false;
			var offset = (avatar.display.width() + 80) * ((i+1) - featuredAvatar);
			if(offset < -240) 
			{
				quick = true;
				offset = -240;
			}
			if(offset > 720) 
			{
				quick = true;
				offset = 720;
			}
			if(offsets[avatar.id] && i === featuredAvatar) 
			{
				offset += offsets[avatar.id];
			}
			
			avatar.display.removeClass("featured");
			if(pQuickSet || quick) avatar.display.stop().animate({left:offset},{duration:0,complete: i == count - 1 ? showAvatarBackground : featureAvatar});
			else avatar.display.stop().animate({left:offset},{complete: i == count - 1 ? showAvatarBackground : featureAvatar});
		}
	}
	function animateMates(pQuickSet)
	{
		mateBackground.stop().hide();
		
		for(var i = 0, count = mates.length; i < count; i++)
		{
			var avatar = mates[i];
			var quick = false;
			var offset = (avatar.display.width() + 80) * ((i+1) - featuredMate);
			if(offset < -240) 
			{
				quick = true;
				offset = -240;
			}
			if(offset > 720) 
			{
				quick = true;
				offset = 720;
			}

			avatar.display.removeClass("featured");
			if(pQuickSet || quick) avatar.display.stop().animate({left:offset},{duration:0,complete: i == count - 1 ? showMateBackground : featureMate});
			else avatar.display.stop().animate({left:offset},{complete: i == count - 1 ? showMateBackground : featureMate});
		}
	}
	
	function showAvatarBackground()
	{
		avatarBackground.stop().ariaFadeIn();
		featureAvatar($(this));
	}
	function showMateBackground()
	{
		mateBackground.stop().ariaFadeIn();
		featureMate($(this));
	}
	
	function featureAvatar(pTarget)
	{
		var avatar = pTarget ? pTarget : $(this);
		if(avatar.index() - 1 == featuredAvatar) avatar.addClass("featured"); 
	}
	function featureMate(pTarget)
	{
		var mate = pTarget ? pTarget : $(this);
		if(mate.index() - 1 == featuredMate) mate.addClass("featured"); 
	}
	
	function onMateClick(event,ui)
	{
		featuredMate = $(this).index() - 1;
		animateMates();
	}
	function onAvatarClick(event,ui)
	{
		featuredAvatar = $(this).index() - 1;
		animateAvatars();
	}
	
	function configure()
	{
		proceedToLanding = quest.settings.mate ? false : true;
		if(configured) return;
		
		var container = $("#avatar-selection").find("#avatar-selection-wrapper");
		container.find(".avatar").each(initializeAvitar);
		avatarBackground = container.find(".featured-background");
		container = $("#avatar-selection").find("#mate-selection-wrapper");
		container.find(".mate").each(initializeAvitar);
		mateBackground = container.find(".featured-background");
		
		featuredAvatar = quest.settings.avatar ? parseInt(quest.settings.avatar.replace("avatar-",""))-1 : 1;
		featuredMate =quest.settings.mate ? parseInt(quest.settings.mate.replace("mate-",""))-1 : 1;
		animateAvatars(true);
		animateMates(true);


		
		configured = true;
	}
	
	function initializeAvitar(index)
	{
		var target = $(this);
		var mate = $(this).hasClass("mate");
		var data = {id:target.attr("id").toString(),index:index,display:target};
		target.css("left",index * (target.width() + 80) + "px");
		target.show();
		mate ? mates.push(data) : avatars.push(data);
		target.click(mate ? onMateClick : onAvatarClick);

		if(!mate) assignAltText(target);
	}
	var speechIndex = 0;
	function assignAltText(target,program)
	{
		var num = target.attr("id").replace("avatar-","");
		target.attr("aria-describedby","avatar-"+num+"-description");
		target.find("p#avatar-"+num+"-description").remove();
		target.append($("<p id='avatar-"+num+"-description' class='description'>"+alt[num]+"</p>"));
		if(program){
			speechIndex = 0;
			target.off("click",onAvatarClick);
			target.on("click",onAvatarClick);
		}
	}
	function onAvatarClick(event){
		event.stopImmediatePropagation();

		var target = $(this);
		if(target.hasClass("active")) return dismissSpeech();
		target.find(".active").removeClass("active");
		target.addClass("active");
		target.find("p").eq(0).addClass("active");
		speechIndex = 0;

		$(document).on("click",dismissSpeech);
	}
	self.advanceSpeech = function(event){
		event.stopImmediatePropagation();

		var target = $(event.currentTarget).closest(".mate");
		var count = target.find(".speech-bubble").find("p").length;
		trace("find",target.closest(".screen"),target,target.find(".speech-bubble").find("p.active"));
		if(speechIndex < count - 1){
			speechIndex++;
			target.find(".speech-bubble").find("p").removeClass("active");
			target.find(".speech-bubble").find("p").eq(speechIndex).addClass("active");
		}
		else{
			dismissSpeech();
		}
	};

	function dismissSpeech(){
		$(".mate.active").removeClass("active");
		$(document).off("click",dismissSpeech);
	}

	
	quest.registerEventListener(onApplicationUpdate);
	return self;
}(quest,quest.avatars = quest.avatars || {}))

quest.port = (function(quest,self){
	
	var trace 			= quest.trace;
	var configured		= false;
	
	self.launchActivity = function(type)
	{
		var type = type || "cove";
		var container = $("#"+quest.settings.PORT_PAGE);
		quest.dreambig.location = type;
		//if(container && container.hasClass("returning")) return;
		quest.loadScreen(quest.settings.DREAM_BIG_PAGE);
	}
	
	self.setSail = function()
	{
		var accessible = checkPortfolioComplete() || !quest.login.userid;
		if(!accessible) return;
		quest.loadScreen(quest.settings.MAP_PAGE);
	}

	self.northStar = function()
	{	
		trace(quest);
		quest.portfolio.requestedTab = "plan";
		quest.loadScreen(quest.settings.PORTFOLIO_PAGE);
	}	

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.PORT_PAGE) configure();
	}
	
	function configure()
	{
		var container = $("#"+quest.settings.PORT_PAGE);
		
		container.find("div#port-avatar").removeClass(function (index, css) { return (css.match (/\bavatar-\S+/g) || []).join(' ');});
		container.find("div#port-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#port-avatar").addClass(quest.settings.avatar);
		container.find("div#port-mate").addClass(quest.settings.mate);
		configured = true;

		var num = quest.settings.avatar.replace("avatar-","");
		container.find("div#port-avatar").attr("aria-describedby","port-avatar-"+num+"-description");
		container.find("div#port-avatar").html("<p id='port-avatar-"+num+"-description' class='description'>"+quest.avatars.alt[num]+"</p>");

		num = quest.settings.mate.replace("mate-","");
		container.find("div#port-mate").attr("aria-describedby","port-mate-"+num+"-description");
		container.find("div#port-mate").html("<p id='port-mate-"+num+"-description' class='description'>"+quest.avatars.mateAlt[num]+"</p>");
		
		var returning = checkMapComplete();
		if(returning) container.addClass("returning");
	}
	
	function checkMapComplete()
	{
		var bookmarks = quest.progress.getCompletedBookmarks();
		
		for(var i = 0, count = bookmarks.length; i < count; i++)
		{
			var bookmark = bookmarks[i];
			if(bookmark.complete && bookmark.page == quest.settings.MAP_PAGE) return true;
		}
		return false;
	}
	function checkPortfolioComplete()
	{
		return true;
		var bookmarks = quest.progress.getCompletedBookmarks();
		
		for(var i = 0, count = bookmarks.length; i < count; i++)
		{
			var bookmark = bookmarks[i];
			if(bookmark.complete && bookmark.page == quest.settings.DREAM_BIG_PAGE) return true;
		}
		return false;
	}
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.port = quest.port || {}));

quest.ui = (function(quest,self){
	
	var trace 			= quest.trace;
	var hide 			= [quest.settings.ACCOUNT_PAGE,quest.settings.LOGIN_PAGE,quest.settings.AVATAR_SELECTION_PAGE,quest.settings.DREAM_BIG_PAGE,quest.settings.COVE_ACTIVITY_PAGE];
	var controls		= null;
	
	
	self.openGlossary = function()
	{
		quest.loadScreen(quest.settings.GLOSSARY_PAGE);
	}
	self.openMap = function()
	{
		var accessible = checkMapComplete();
		if(!accessible) return;
		
		quest.loadScreen(quest.settings.MAP_PAGE);
	}
	self.openPortfolio = function()
	{
		if(quest.login.mode == "guest") return;
		quest.loadScreen(quest.settings.PORTFOLIO_PAGE);
	}

	self.openWheel = function()
	{
		//if(!quest.survey.noActiveSurveys && !quest.survey.surveyComplete) return quest.showAlert("survey","ui-wheel");
		quest.loadScreen(quest.settings.WHEEL_PAGE);
	}

	self.enableMenu = function()
	{

	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.APPLICATION_READY) initialize(pData);
		if(pType == quest.PAGE_LOAD) configure(pData);
	}
	
	function initialize(pData)
	{
		controls = $("#ui-controls");
		controls.find("a").each(function(){

			var id = $(this).attr("id");
			$(this).hover(function(){
				var clip = "audio/menu" + id.replace("ui-","") + ".mp3";
				quest.audio.playClip(clip);

			},function(){})
		});

		$("#activity-menu").find("a").on("click.menu",function(){

			if($(this).hasClass("collage"))
			{
				quest.collage.spawnGeneric = true;
				quest.collage.location = "extras";
				quest.collage.requestedCollage = $(this).attr("data-collage");
				if(!quest.collage.requestedCollage) return;
				quest.loadScreen("collage");
			}
			if($(this).hasClass("wardrobe"))
			{
				quest.wardrobe.spawnGeneric = true;
				quest.wardrobe.location = "extras";
				quest.wardrobe.requestedCollage = $(this).attr("data-wardrobe");
				if(!quest.wardrobe.requestedCollage) return;
				quest.loadScreen("wardrobe");
			}
			if($(this).hasClass("prompt"))
			{
				quest.prompt.spawnGeneric = true;
				quest.prompt.location = "extras";
				quest.prompt.requestedPrompt = $(this).attr("data-prompt");
				if(!quest.prompt.requestedPrompt) return;
				quest.loadScreen("prompt");
			}
			if($(this).hasClass("organizer"))
			{
				quest.organizer.spawnGeneric = true;
				quest.organizer.location = "extras";
				quest.organizer.requestedTitle = "";
				quest.organizer.requestedOrganizer = $(this).attr("data-organizer");
				if(!quest.organizer.requestedOrganizer) return;
				quest.loadScreen("organizer");
			}
		});
	}
	
	function configure(pData)
	{
		if(hide.indexOf(pData.id) != -1) controls.stop().ariaHide();
		else controls.ariaShow(); 

		if(pData.id == "hut" || pData.id == "avatar-selection" || pData.id == "login" || pData.id == "portfolio" || pData.id == "prompt" || pData.id == "collage" || pData.id == "wardrobe" || pData.id == "organizer" || pData.id == "dream-big") $("#activity-menu-toggle").hide();
		else $("#activity-menu-toggle").show();
	}
	
	function checkMapComplete()
	{
		var bookmarks = quest.progress.getCompletedBookmarks();
		
		for(var i = 0, count = bookmarks.length; i < count; i++)
		{
			var bookmark = bookmarks[i];
			if(bookmark.complete && bookmark.page == quest.settings.MAP_PAGE) return true;
		}
		return false;
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
	
}(quest,quest.ui = quest.ui || {}));
quest.audio = (function(quest,self){
	
	var trace 			= quest.trace;
	var mute			= true;
	var swf				= null;
	var audioPlayer		= null;
	var queuedRequest	= null;
	var queuedLoop		= false;
	var queuedCaption	= null;
	var currentAudio	= null;
	var callbacks 		= {};
	var ready = false;

	var queue = [];
	var configured = false;
	var fcomplete = false;
	
//Note: 2 return statemens added to disable audio

	self.toggleAudio = function() {};
	self.playClip = function(pPath,pLoop,pCaption) {queuedRequest = pPath; queuedLoop = pLoop; queuedCaption = pCaption; if(pCaption && pCaption.length) $("#"+quest.currentPage).find(".speech-bubble").html(pCaption)}
 	self.close = function(){};
	self.soundComplete = function(){};
	self.queueClip = function(){};
	self.loadQueue = function(){};
	self.playMultipleClips = function(){};
	self.muted = true;


	self.flashPlayerReady = function()
	{
		self.toggleAudio = flashToggleAudio;
		self.playClip = flashPlayClip;
		self.close = flashClose;
		self.soundComplete = flashSoundComplete;
		self.queueClip = flashQueueClip;
		self.loadQueue = flashLoadQueue;
		self.muted = true;

		flashToggleAudio(true);
		
		if(queuedRequest) self.playClip(queuedRequest,queuedLoop,queuedCaption);
	}

	self.clearQueue = function() {
		queue = [];
		htmlClose();
		$("#html-audio-player").remove();
		$("audio.queue").remove();
	};

	self.programElementAudio = function(el) {
		el.find("*[data-audio-hover]").each(function(){
				var button = $(this);
				button.on("mouseover",playHoverClip);
		});

		el.find("*[data-audio-click]").each(function(){
			var button = $(this);
			var left = button.attr("data-audio-x") || "-20px";
			var top = button.attr("data-audio-y") || "5px";
			var ahtml = '<a class="global-audio-button sm" href="javascript:void(0)">Toggle Audio</a>';
			button.prepend(ahtml);
			if(button.css("position") !== "absolute") button.css("position","relative");
			button.find(".global-audio-button").css("top",top).css("left",left).click(playClickClip);
		});
	}
	
	self.registerAudioCallback = function(key,callback)
	{
		callbacks[key] = callback;
	}
	
	function flashQueueClip(pPath,pClear)
	{
		audioPlayer.queueClip(pPath,pClear);
	}
	function flashLoadQueue()
	{
		audioPlayer.loadQueue();
	}

	function html5QueueClip(pPath,pClear) {
		if(pClear) queue = [];
		queue.push(pPath);
		
	}

	function html5LoadQueue(forceQueueComplete) {
		fcomplete = forceQueueComplete;
		$("audio.queue").remove();

		queue.forEach(function(e,i){
			var path  = e.replace(/\.mp3/gim,"");
			var html = '<audio id="html-audio-player" class="queue" data-queue="'+i+'"> <source type="audio/mp3" src="'+path+'.mp3"> <source type="audio/ogg" src="'+path+'.ogg"> </audio>';
			queue[i] = i;
			$("body").append(html);
		});

		html5PlayQueue();
	}

	function html5PlayQueue(){

		if((!fcomplete && queue.length <= 1) || fcomplete && queue.length == 0) {
			$("audio.queue").remove()
			var audio = currentAudio;
			var backgroundClip = fetchBackgroundClip(audio);
			if(backgroundClip) self.playClip(backgroundClip.content.attr("src"),true);
			queue = [];
			fcomplete = false;
			return ;
		}

		var clip = queue.shift();
		var index = clip;
		var target = $('audio[data-queue="'+index+'"]').get(0);

		target.load();
		setTimeout(function(){
			if(mute) target.volume = 0;
			target.play();
			target.onended = html5PlayQueue;
		},10);
		
	}


	function flashPlayClip(pPath,pLoop,pCaption)
	{
		if(!audioPlayer.playClip) return;
		audioPlayer.playClip(pPath,pLoop);
		
		if(pCaption && pCaption.length) $("#"+quest.currentPage).find(".speech-bubble").html(pCaption);
	}
	function htmlPlayClip(pPath,pLoop,pCaption)
	{
		fcomplete = false;
		if(!audioPlayer)
		{
			if(pCaption && pCaption.length) $("#"+quest.currentPage).find(".speech-bubble").html(pCaption);
			return;
		}
		var p = $(audioPlayer).get(0).pause();
		if(p) p.catch(function(){});
		$(audioPlayer).remove();
		if(pPath) pPath = pPath.replace(/\.mp3/gim,"");
		$("#html-audio-player").remove();

		var html = '<audio id="html-audio-player" '+(pLoop === true ? 'loop' : '')+'> <source type="audio/mp3" src="'+pPath+'.mp3"> <source type="audio/ogg" src="'+pPath+'.ogg"> </audio>';
		$("body").append(html);
		audioPlayer = $("#html-audio-player").get(0);
		
		if(mute) audioPlayer.volume = 0;
		//audioPlayer.volume = 0.25;
		audioPlayer.onended = html5SoundComplete;
		
		setTimeout(function(){
			var p = audioPlayer.play();
			p.catch(function(e){
				trace("error from audio",e);
			})
			
		},50);
		//$(audioPlayer).find("source").attr("src",pPath);
		
		if(pCaption && pCaption.length) $("#"+quest.currentPage).find(".speech-bubble").html(pCaption);
	}	
	
	function flashToggleAudio(forceMute)
	{
		mute = !mute;	

		if(forceMute) mute = true;	

		self.muted = mute;
		
		if(mute) $("#header-audio").addClass("muted");
		else $("#header-audio").removeClass("muted");
		
		if(mute) audioPlayer.mute();
		else audioPlayer.unmute();

		self.muted = mute;
	}
	
	function flashSoundComplete()
	{
		var audio = currentAudio;
		if(!audio.length) return;
		
		
		
		var backgroundClip = fetchBackgroundClip(audio);
		if(backgroundClip) self.playClip(backgroundClip.content.attr("src"),true);
	}

	function html5SoundComplete(){
		var audio = currentAudio;
		if(!audio.length) return;
		
		var backgroundClip = fetchBackgroundClip(audio);
		if(backgroundClip) self.playClip(backgroundClip.content.attr("src"),true);
	}
	
	function htmlToggleAudio()
	{
		mute = !mute;		
		
		if(mute) $("#header-audio").addClass("muted");
		else $("#header-audio").removeClass("muted");
		
		self.muted = mute;

		if(mute) audioPlayer.pause();
		else audioPlayer.play();
	}
	
	function flashClose()
	{
		if(!audioPlayer.close) return;
		audioPlayer.close();
	}
	function htmlClose()
	{
		try {audioPlayer.stop()}
		catch(ignore){}
	}
	
	function createSWF()
	{
		swf = 'AudioPlayer';
		var so = new SWFObject('swf/audio.swf', 'AudioPlayer', 1, 1, "10.3", "#ffffff");
		so.addParam("allowScriptAccess", "always");	
		so.addParam("swliveconnect", "true");
		so.addParam("allowFullScreen","false");
		so.addParam("wmode", "transparent");
		so.addParam("scale","noscale");
		so.write("audio-player");
	} 

	function getSWF(movieName) 
	{
		if (navigator.appName.indexOf("Microsoft") != -1) return window[movieName];
		return document[movieName];
	} 
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.APPLICATION_READY) initialize(pData);
		if(pType == quest.PAGE_LOAD) configure(pData);
	}
	
	function configure(pData)
	{
		if(!configured) {
			$("*[data-audio-hover]").each(function(){
				var button = $(this);
				button.on("mouseover",playHoverClip);
			});

			$("*[data-audio-click]").each(function(){
				var button = $(this);
				var left = button.attr("data-audio-x") || "-20px";
				var top = button.attr("data-audio-y") || "5px";
				var ahtml = '<a class="global-audio-button sm" href="javascript:void(0)">Toggle Audio</a>';
				button.prepend(ahtml);
				if(button.css("position") !== "absolute") button.css("position","relative");
				button.find(".global-audio-button").css("top",top).css("left",left).click(playClickClip);
			});
		}
		configured = true;
		self.close();
		self.clearQueue();

		var audio = currentAudio = pData.content.find("audio");
		if(!audio.length) return;
		
		var bookmarks = quest.progress.getCompletedBookmarks();
		
		var audioClip = null;
		var backgroundClip = null;
		
		for(var i = 0, count = audio.length; i < count; i++)
		{
			var audioContent = $(audio[i]);
			var clip = {content:audioContent, src: audioContent.attr("src"), text: audioContent.text(),priority:parseInt(audioContent.attr("priority")),prerequisite:audioContent.attr("prerequisite"),background:audioContent.attr("background") == "true"};
			var qualifies = checkIfQualifyingClip(clip.content,bookmarks);

			if(qualifies && !audioClip) audioClip = clip;
			if(qualifies && clip.priority > audioClip.priority) audioClip = clip;
			if(audioClip && !qualifies) break;
		}
		
		if(!audioClip) backgroundClip = fetchBackgroundClip(audio);
		
		if(audioClip) 
		{
			var multiple = audioClip.content.attr("src").split(",").length > 1;
			var clips = audioClip.content.attr("src").split(",");

			if(multiple)
			{
				for(var j = 0, numClips = clips.length; j < numClips; j++)
				{
					quest.audio.queueClip(clips[j]);
				}
				quest.audio.loadQueue();
			}
			else
			{
				self.playClip(audioClip.content.attr("src"),false,audioClip.text);
			}

			//quest.audio.queueClip('audio/32_FQI_FutureForecast.mp3');
			//quest.audio.queueClip('audio/33_FQI_FutureForecast.mp3');
			//quest.audio.loadQueue();

			
		}
		if(backgroundClip) self.playClip(backgroundClip.content.attr("src"),true,backgroundClip.text);
	}
	
	function fetchBackgroundClip(audio)
	{
		for(var i = 0, count = audio.length; i < count; i++)
		{
			var audioContent = $(audio[i]);
			if(audioContent.attr("background") == "true") return {content:audioContent};
		}
		return null;
	}
	
	function checkIfQualifyingClip(clip,bookmarks)
	{
		var prerequisite = clip.attr("prerequisite");
		var qualifies = false;
		var callback = clip.attr("callback");
		
		if(callback) 
		{
			return callbacks[callback](clip.attr("callbackData"));
		}
		
		if(clip.attr("background") == "true") return false;
		if(prerequisite == "none") return true;
		
		for(var i = 0, count = bookmarks.length; i < count; i++)
		{
			var bookmark = bookmarks[i];
			if(bookmark.code == prerequisite) qualifies = true;
		}
		return qualifies;
	}
	
	function initialize(pData)
	{
		quest.settings.mobile = true;
		if(quest.settings.mobile)
		{
			audioPlayer = $("#html-audio-player")[0];
			self.toggleAudio = htmlToggleAudio;
			self.playClip = htmlPlayClip;
			self.close = htmlClose;
			self.queueClip = html5QueueClip;
			self.loadQueue = html5LoadQueue;
		}
		else
		{
			createSWF();
			audioPlayer = getSWF(swf);
		}

	}

	function playHoverClip(e) {
		var target = $(e.target);
		if(!target.attr("data-audio-hover")) return;
		self.clearQueue();
		self.playClip("audio/"+$(this).attr("data-audio-hover"));
	}
	function playClickClip(e) {
		var target = $(e.currentTarget).parent();
		if(!target.attr("data-audio-click")) return;
		self.clearQueue();
		self.playClip("audio/"+target.attr("data-audio-click"));
	}
	
	quest.registerEventListener(onApplicationUpdate);
	return self;
}(quest,quest.audio = quest.audio || {}));

quest.portfolio = (function(quest,self){

	var trace 				= quest.trace;
	var configured 			= false;
	var ready 				= false;
	var currentActivity 	= "dream-big";

	var activities			= null;
	var screenData			= {};
	var itemLookup			= {};
	var listing 			= [];

	var launchIndex			= -1;
	var listLength			= 0;
	var currentList			= null;
	var _assignment 		= null;

	var passport = ["organizer-1","organizer-2","organizer-4","organizer-5","collage-11","collage-12","prompt-9","collage-13","collage-14","collage-8","prompt-6"];

	self.requestedTab = null;

	self.viewStudentWork = function(assignment){
		_assignment = assignment;
		onPortfolioItemClick(null,assignment);
	};

	self.changeImage = function()
	{
		$("#file").click()
	}

	self.close = function()
	{

		if(quest.previousPage && quest.previousPage != quest.settings.LOGIN_PAGE) quest.loadScreen(quest.previousPage);
		else quest.loadScreen(quest.settings.PORT_PAGE);
	};

	self.hidePrintView = function()
	{
		$("html").removeClass("printing");
	};

	self.printPassport = function()
	{
		var plan = screenData["plan"];
		$("html").addClass("printing");
		$("#print-container").find(".printable,#printable-footer").remove();

		plan.forEach(function(element,index){
			var info = element.data;

			if(info.type === "organizer") generateOrganizer(element,index,info);
			else if(info.type === "collage") generateCollage(element,index,info);
			else if(info.type === "prompt") generatePrompt(element,index,info);
		});

		$("#print-container").append($("#footer").clone().attr("id","printable-footer"));
		$("#print-container").find("#printable-footer").prepend($("<img src='images/portfolio/printable-footer.png'>"));

		function generatePrompt(element,index)
		{

			var info = element.data;
			var html = $("<div id='prompt-"+index+"' class='portfolio-prompt printable'>" +  quest.prompt.regenerate(info.screen,info.data) + "</div>");
			$("#print-container").append(html);

			var lightbox = $("#print-container").find("#prompt-"+index);


			//var title = info.data.title || "";
			var title = getTitleForActivity(info);
			lightbox.append(html);

			if(quest.prompt.getMulti()) lightbox.addClass("multi");

			if(quest.prompt.getMulti())
			{
				lightbox.find("textarea").each(function(index){
					$(this).val(info.data.prompts[index].replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"))
				}) //.val(target.data.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			}
			else
			{
				lightbox.find("#prompt-title").find("input").val(title);
				lightbox.find("textarea").val(info.data.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
			}

			lightbox.find('input[type="submit"]').hide();
		}

		function generateCollage(element,index)
		{
			var info = element.data;

			var html = $("<div id='collage-"+index+"' class='portfolio-collage printable'>" +  quest.collage.regenerate(info.screen,info.data) + "</div>");
			$("#print-container").append(html);

			var lightbox = $("#print-container").find("#collage-"+index);
			var title = getTitleForActivity(info);
			lightbox.append(html);
			lightbox.find("#collage-activity").hide();
			lightbox.find("#collage-modifiers").hide();
			lightbox.find("#collage-selection").show();
			lightbox.find('input[type="submit"]').hide();
			lightbox.find("#collage-title").find("input").val(title);
			lightbox.find("textarea").val(" ");

		}
		function generateOrganizer(element,index)
		{
			var info = element.data;
			var html = $("<div id='organizer-"+index+"' class='portfolio-organizer printable'>" +  quest.organizer.regenerate(info.screen,info.data) + "</div>");
			$("#print-container").append(html);

			var lightbox = $("#print-container").find("#organizer-"+index);

			var title = getTitleForActivity(info);
			var data = info.data;
			var goal = data.goal;
			var tasks = data.tasks;

			lightbox.find("#title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));

			lightbox.find("#goals").find("textarea").val(goal.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			for(var i = 1; i <= 3; i++)
			{
				var task = tasks[i-1];
				lightbox.find("#task-input-"+i).val(task.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#date-input-"+i).val(task.date.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#date-input-"+i+"b").val(task.date2.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			}

			lightbox.find('input[type="submit"]').hide();
		}
	};
	// PF--added setTab result argument to handle direct access to portfolio items from toolkit
	self.setTab = function(location,result)
	{

		var container = $("#"+ quest.settings.PORTFOLIO_PAGE);
		container.find(".tab").addClass("disabled");
		$("#portfolio-"+location).removeClass("disabled");
		container.find(".active").removeClass("active");
		currentActivity = location;
		container.find("#portfolio-activity-title-"+currentActivity).addClass("active");

		$("#portfolio").attr("class","screen " + location);

		itemLookup = {};

		var activities = screenData[location];

		if(!activities) return $("#portfolio-items").html("");
		$("#portfolio-items").attr("class",location);
		var html = $("<form/>");
		html.append("<fieldset/>");
		html.find("fieldset").append("<legend style='position:absolute; left: -9999px;'>Check your favorites to add them to your summary page.</legend>");
		html.find("fieldset").append("<div class='form-container'/>");

		var form = html.find(".form-container");
		var lastTitle;

		for(var i = 0, count = activities.length; i < count; i++)
		{
			var activity = activities[i];
			var info = activity.data;
			var id = info.screen;
			var key = "item-"+i;
			var checked = info.feature ? "checked" : "";
			itemLookup[key]= info;
			var formrow = $("<div class='formrow "+info.type+"'/>");
			var title = getTitleForLocation(activity.location);

			var label = getLabelForActivity(info);
			//trace(info);

			formrow.append("<input id='"+id+"_input' type='checkbox' data-key='"+key+"' data-type='"+info.type+"' value='"+info.id+ "' "+checked+"/>");
			formrow.append("<label for='"+id+"_input'><a href='javascript:void(0)' data-target='"+id+"' data-lookup-key='"+key+"'>"+label || activity.item.text()+"</a></label>");


			if(title != lastTitle)
			{
				form.append("<h3>"+title+"</h3>");
				lastTitle = title;
			}
			form.append(formrow);
		}

		$("#portfolio-items").html(html);
    if(result && result.adminItem) {
      onAdminItem(result);
  }
		$("#portfolio-items").find("a").click(onPortfolioItemClick);
		$("#portfolio-items").find("input").bind("change",onPortfolioFeature);


	}

	function getLabelForActivity(info)
	{
		if(info.type == "forecast") return "Future Forecast";
		if(info.type == "prompt" || info.type == "collage" || info.type == "organizer")
		{
			var label = $(quest.xml).find("#"+info.screen).find("savetitle").text();
			if(label && label.length) return label;
			return info.data.title;
		}
		if (info.type == "wardrobe")
		{
			return info.data.title;
		}
		return "Unlabeled";
	}
	function getTitleForActivity(info)
	{
		if(info.type == "forecast") return "Future Forecast";
		if(info.type == "prompt" || info.type == "collage" || info.type == "organizer")
		{
			var title =  $(quest.xml).find("#"+info.screen).find("title").text();
			if(title && title.length) return title;
			return info.data.title;
		}
		return "Unlabeled";
	}

	function getTitleForLocation(location)
	{
		switch(location)
		{
			case "cove":
				return "College and Career Cove";
			break;
			case "sanctuary":
				return "Social Sanctuary";
			break;
			case "mountain":
				return "About Me Mountain";
			break;
			case "extras":
				return "Extras";
			break;
			case "path":
				return "My Path";
			break;
			default:
		}
		return "";
	}

	function onPortfolioFeature(event)
	{
		var uid = $(this).val();
		var type = $(this).attr("data-type");
		var feature = this.checked ? "true" : "false";
		var key = $(this).attr("data-key");
		var activity = itemLookup[key];
		activity.feature = this.checked;

		screenData["summary"] = [];

		var added = [];

		for(var i = 0, count = listing.length; i < count; i++)
		{
			var item = listing[i];
			if(item.data.feature && added.indexOf(item.data.screen) == -1)
			{
				screenData["summary"].push({data:item.data,text:item.data.data.title});
				added.push(item.data.screen);
			}
		}

		$.ajax({url:"php/portfolio.php", type:'POST',data:{request:"feature",id:uid,type:type,feature:feature},dataType:'json',success:function(){},error:errorHandler});

	}


	function onPortfolioItemClick(event,data)
{
		var item = $(this);
		var location = item.attr("data-target");
		var target = data ? data : itemLookup[item.attr("data-lookup-key")];

		var constructor = target.data;
		var container = $("#"+ quest.settings.PORTFOLIO_PAGE);

		var lightbox = $("<div class='lightbox "+target.type+"'/>");
		var arrows = $("<div class='arrows'><a class='left arrow' href='javascript:void(0)'>left</a><a class='right arrow' href='javascript:void(0)'>right</a></div>");

		if(data) {
			location = data.location;
			if(location && !location.match(/\d{1,2}/gim)) location = data.label;
		}

		launchIndex = $(this).closest(".formrow").index() - 1;
		listLength = $(this).closest(".formrow").parent().find(".formrow").length;
		currentList = $(this).closest(".form-container");

		if(target.type == "prompt")
		{
			var title = getTitleForActivity(target);//target.data.title || $(this).text();
			var html = $("<div class='portfolio-prompt'>" +  quest.prompt.regenerate(location,target.data) + "</div>");
			lightbox.append(html);
			if(quest.prompt.getMulti()) lightbox.find(".portfolio-prompt").addClass("multi");

			if(quest.prompt.getMulti())
			{
				lightbox.find("textarea").each(function(index){
					$(this).val(target.data.prompts[index].replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"))
				}) //.val(target.data.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#prompt-title").find("input").val(title);
			}
			else
			{
				lightbox.find("#prompt-title").find("input").val(title);
				lightbox.find("textarea").val(target.data.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
			}

			lightbox.find(".portfolio-prompt").append(arrows);

			lightbox.find('input[type="submit"]').hide();
		}
		else if (target.type == "collage")
		{
			var html = $("<div class='portfolio-collage'>" +  quest.collage.regenerate(location,target.data) + "</div>");
			var title = getTitleForActivity(target);
			//var title = target.data.title || $(this).text();
			lightbox.append(html);
			lightbox.find("#collage-activity").hide();
			lightbox.find("#collage-modifiers").hide();
			lightbox.find("#collage-selection").show();
			lightbox.find('input[type="submit"]').hide();
			lightbox.find("#collage-title").find("input").val(title);
			lightbox.find("textarea").val(" ");
			lightbox.find(".portfolio-collage").append(arrows);
		}
		else if (target.type == "organizer")
		{
			var html = $("<div class='portfolio-organizer'>" +  quest.organizer.regenerate(location,target.data) + "</div>");
			lightbox.append(html);

			//var title = target.data.title || $(this).text();
			var title = getTitleForActivity(target);
			var data = target.data;
			var goal = data.goal;
			var tasks = data.tasks;

			lightbox.find("#title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));

			lightbox.find("#goals").find("textarea").val(goal.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			for(var i = 1; i <= 3; i++)
			{
				var task = tasks[i-1];
				lightbox.find("#task-input-"+i).val(task.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#date-input-"+i).val(task.date.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#date-input-"+i+"b").val(task.date2.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			}

			lightbox.find('input[type="submit"]').hide();
			lightbox.find(".portfolio-organizer").append(arrows);
		}
		else if (target.type == "forecast")
		{
			var html = $("<div class='portfolio-forecast'><h3>Future Forecast Results</h3> <p>" +  target.data + "</p></div>");
			lightbox.append(html);
			lightbox.find(".portfolio-forecast").append(arrows);

		}
		/*MD: Career Outfitters*/
		else if (target.type == "wardrobe")
		{
			var html = $("<div class='portfolio-wardrobe'>" +  quest.wardrobe.regenerate(location,target.data) + "</div>");
			var title = target.data.title || $(this).text();
			lightbox.append(html);
			lightbox.find(".portfolio-wardrobe").append(arrows);

			lightbox.find(".portfolio-wardrobe #showWriting").show();
			lightbox.find(".portfolio-wardrobe #wardrobe-prompt").show();
			lightbox.find(".portfolio-wardrobe #all-professions").hide();
			lightbox.find(".portfolio-wardrobe #all-accessory-description").hide();
			lightbox.find(".portfolio-wardrobe #showWardrobe").addClass("selected");
			lightbox.find(".portfolio-wardrobe #showWriting").removeClass("selected");
			lightbox.find("textarea#wardrobe-prompt-input").val(target.data.description); // this doesn't stay!
		}

		var buttons = $("<div class='buttons'><a class='edit button' href='javascript:void(0)'>EDIT</a><a class='print button' href='javascript:void(0)'>PRINT</a><a class='close button' href='javascript:void(0)'>CLOSE</a></div>")
		if(target.type == "forecast") buttons.find(".edit").remove();

		lightbox.append(buttons);

		$("body").append(lightbox);
		if(event) event.stopPropagation();

		var comment = quest.comments.activeComments[target.screen];
		if(data) comment = {id:data.comment,comment:data.commentText || "",rating:data.rating  || 0};
		
		var starContainer = lightbox.find("div.star-rating");
		if(starContainer.length)
		{
			starContainer.get(0).className = starContainer.get(0).className.replace(/star\d{1}/gim,"");
			starContainer.find("p").html("");

			if(comment)
			{
				starContainer.addClass("star"+(comment.rating ? comment.rating : 0));
				starContainer.find("p").html(comment.comment.length > 1 ? comment.comment : "Enter comment here");
			}

			if(quest.settings.role == "teacher")
			{
				if(!comment)
				{
					starContainer.addClass("star0");
					starContainer.find("p").html("Enter comment here");
				}
				starContainer.click(function(e){
					e.stopPropagation();
					e.preventDefault();
				});
				starContainer.find("p.comments").attr("contenteditable","true").click(function(e){
					e.stopPropagation();
					e.preventDefault();
				});//.blur(saveComments.bind({display:lightbox,"screen":target.screen,table:target.type + "s"}));
				starContainer.find("a.star-check").click(function(e){
					saveComments.bind({display:lightbox,"screen":target.screen,table:target.type + "s"})();
				});
				starContainer.find("a.star-cancel").click(function(e){
					lightbox.click();
				});
				starContainer.find("button").click(function(e){
					var rating = $(this).index()+1;
					e.stopPropagation();
					e.preventDefault();
					starContainer.get(0).className = starContainer.get(0).className.replace(/star\d{1}/gim,"");
					starContainer.addClass("star"+($(this).index()+1));
				});


			}
		}



		lightbox.find("a.print").click(function(event){
			event.stopPropagation();
			window.print();
		});
		lightbox.find("a.close").click(function(event){
			event.stopPropagation();
			lightbox.remove();
		});
		lightbox.find("a.edit").click(function(event){
			event.stopPropagation();

			if(target.type == "prompt")
			{
				quest.prompt.requestedPrompt = target.screen;
				quest.loadScreen("prompt");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}
			if(target.type == "collage")
			{
				quest.collage.requestedCollage = target.screen;
				quest.loadScreen("collage");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}
			if(target.type == "organizer")
			{
				quest.organizer.requestedOrganizer = target.screen;
				quest.loadScreen("organizer");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}
			if(target.type == "wardrobe")
			{
				quest.wardrobe.requestedWardrobe = target.screen;
				quest.loadScreen("wardrobe");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}

		})

		lightbox.find("a.left,a.right").click(function(e){
			var left = $(this).hasClass("left");
			e.stopPropagation();
			lightbox.remove();
			$(document).unbind("click.lightbox");
			if(left && launchIndex > 0) currentList.find(".formrow").eq(launchIndex -1).find("a").click();
			else if(!left && launchIndex < listLength - 1) currentList.find(".formrow").eq(launchIndex + 1).find("a").click();
		});

		$(document).bind("click.lightbox",function(event){
			lightbox.remove();
			$(document).unbind("click.lightbox");
			if(data && quest.settings.role == "teacher") quest.loadScreen(quest.settings.TEACHER_ADMINISTRATION_CONTAINER_PAGE);
		})

	}

// modification of onPortfolioItemClick to handle direct viewing of portfolio item from teacher toolkit --PF

  	function onAdminItem(result)
  {

    var item = $("a[data-target='" + result.adminItem + "']");
		var target = itemLookup[item.attr("data-lookup-key")];

		var constructor = target.data;
		var container = $("#"+ quest.settings.PORTFOLIO_PAGE);

		var lightbox = $("<div class='lightbox "+target.type+"'/>");
		var arrows = $("<div class='arrows'><a class='left arrow' href='javascript:void(0)'>left</a><a class='right arrow' href='javascript:void(0)'>right</a></div>");


		launchIndex = $("a[data-target='" + result.adminItem + "']").closest(".formrow").index() - 1;
		listLength = $("a[data-target='" + result.adminItem + "']").closest(".formrow").parent().find(".formrow").length;
		currentList = $("a[data-target='" + result.adminItem + "']").closest(".form-container");

		if(target.type == "prompt")
		{
			var title = getTitleForActivity(target);//target.data.title || $("a[data-target='" + result.adminItem + "']").text();
			var html = $("<div class='portfolio-prompt'>" +  quest.prompt.regenerate(item.attr("data-target"),target.data) + "</div>");
			lightbox.append(html);
			if(quest.prompt.getMulti()) lightbox.find(".portfolio-prompt").addClass("multi");

			if(quest.prompt.getMulti())
			{
				lightbox.find("textarea").each(function(index){
					$("a[data-target='" + result.adminItem + "']").val(target.data.prompts[index].replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"))
				}) //.val(target.data.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#prompt-title").find("input").val(title);
			}
			else
			{
				lightbox.find("#prompt-title").find("input").val(title);
				lightbox.find("textarea").val(target.data.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
			}

			lightbox.find(".portfolio-prompt").append(arrows);

			lightbox.find('input[type="submit"]').hide();
		}
		else if (target.type == "collage")
		{
			var html = $("<div class='portfolio-collage'>" +  quest.collage.regenerate(item.attr("data-target"),target.data) + "</div>");
			var title = getTitleForActivity(target);
			//var title = target.data.title || $("a[data-target='" + result.adminItem + "']").text();
			lightbox.append(html);
			lightbox.find("#collage-activity").hide();
			lightbox.find("#collage-modifiers").hide();
			lightbox.find("#collage-selection").show();
			lightbox.find('input[type="submit"]').hide();
			lightbox.find("#collage-title").find("input").val(title);
			lightbox.find("textarea").val(" ");
			lightbox.find(".portfolio-collage").append(arrows);
		}
		else if (target.type == "organizer")
		{
			var html = $("<div class='portfolio-organizer'>" +  quest.organizer.regenerate(item.attr("data-target"),target.data) + "</div>");
			lightbox.append(html);

			//var title = target.data.title || $("a[data-target='" + result.adminItem + "']").text();
			var title = getTitleForActivity(target);
			var data = target.data;
			var goal = data.goal;
			var tasks = data.tasks;

			lightbox.find("#title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));

			lightbox.find("#goals").find("textarea").val(goal.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			for(var i = 1; i <= 3; i++)
			{
				var task = tasks[i-1];
				lightbox.find("#task-input-"+i).val(task.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#date-input-"+i).val(task.date.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				lightbox.find("#date-input-"+i+"b").val(task.date2.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			}

			lightbox.find('input[type="submit"]').hide();
			lightbox.find(".portfolio-organizer").append(arrows);
		}
		else if (target.type == "forecast")
		{
			var html = $("<div class='portfolio-forecast'><h3>Future Forecast Results</h3> <p>" +  target.data + "</p></div>");
			lightbox.append(html);
			lightbox.find(".portfolio-forecast").append(arrows);

		}
		/*MD: Career Outfitters*/
		else if (target.type == "wardrobe")
		{
			var html = $("<div class='portfolio-wardrobe'>" +  quest.wardrobe.regenerate(item.attr("data-target"),target.data) + "</div>");
			var title = target.data.title || $("a[data-target='" + result.adminItem + "']").text();
			lightbox.append(html);
			lightbox.find(".portfolio-wardrobe").append(arrows);

			lightbox.find(".portfolio-wardrobe #showWriting").show();
			lightbox.find(".portfolio-wardrobe #wardrobe-prompt").show();
			lightbox.find(".portfolio-wardrobe #all-professions").hide();
			lightbox.find(".portfolio-wardrobe #all-accessory-description").hide();
			lightbox.find(".portfolio-wardrobe #showWardrobe").addClass("selected");
			lightbox.find(".portfolio-wardrobe #showWriting").removeClass("selected");
			lightbox.find("textarea#wardrobe-prompt-input").val(target.data.description); // this doesn't stay!
		}

		var buttons = $("<div class='buttons'><a class='edit button' href='javascript:void(0)'>EDIT</a><a class='print button' href='javascript:void(0)'>PRINT</a><a class='close button' href='javascript:void(0)'>CLOSE</a></div>")
		if(target.type == "forecast") buttons.find(".edit").remove();

		lightbox.append(buttons);

		$("body").append(lightbox);
	//	stopPropagation();

		var comment = quest.comments.activeComments[target.screen];
		var starContainer = lightbox.find("div.star-rating");
		if(starContainer.length)
		{
			starContainer.get(0).className = starContainer.get(0).className.replace(/star\d{1}/gim,"");
			starContainer.find("p").html("");

			if(comment)
			{
				starContainer.addClass("star"+(comment.rating ? comment.rating : 0));
				starContainer.find("p").html(comment.comment.length > 1 ? comment.comment : "Enter comment here");
			}

			if(quest.settings.role == "teacher")
			{
				if(!comment)
				{
					starContainer.addClass("star0");
					starContainer.find("p").html("Enter comment here");
				}
				starContainer.click(function(e){
					e.stopPropagation();
					e.preventDefault();
				});
				starContainer.find("p.comments").attr("contenteditable","true").click(function(e){
					e.stopPropagation();
					e.preventDefault();
				});//.blur(saveComments.bind({display:lightbox,"screen":target.screen,table:target.type + "s"}));
				starContainer.find("a.star-check").click(function(e){
					saveComments.bind({display:lightbox,"screen":target.screen,table:target.type + "s"})();
				});
				starContainer.find("a.star-cancel").click(function(e){
		lightbox.click();
	});
				starContainer.find("button").click(function(e){
					var rating = $(this).index()+1;
					e.stopPropagation();
					e.preventDefault();
					starContainer.get(0).className = starContainer.get(0).className.replace(/star\d{1}/gim,"");
					starContainer.addClass("star"+($(this).index()+1));
				});


			}
		}



		lightbox.find("a.print").click(function(event){
			event.stopPropagation();
			window.print();
		});
		lightbox.find("a.close").click(function(event){
			event.stopPropagation();
			lightbox.remove();
		});
		lightbox.find("a.edit").click(function(event){
			event.stopPropagation();

			if(target.type == "prompt")
			{
				quest.prompt.requestedPrompt = target.screen;
				quest.loadScreen("prompt");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}
			if(target.type == "collage")
			{
				quest.collage.requestedCollage = target.screen;
				quest.loadScreen("collage");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}
			if(target.type == "organizer")
			{
				quest.organizer.requestedOrganizer = target.screen;
				quest.loadScreen("organizer");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}
			if(target.type == "wardrobe")
			{
				quest.wardrobe.requestedWardrobe = target.screen;
				quest.loadScreen("wardrobe");
				quest.previousPage = "map";
				lightbox.remove();
				$(document).unbind("click.lightbox");
			}

		})

		lightbox.find("a.left,a.right").click(function(e){
			var left = $(this).hasClass("left");
			e.stopPropagation();
			lightbox.remove();
			$(document).unbind("click.lightbox");
			if(left && launchIndex > 0) currentList.find(".formrow").eq(launchIndex -1).find("a").click();
			else if(!left && launchIndex < listLength - 1) currentList.find(".formrow").eq(launchIndex + 1).find("a").click();
		});

		$(document).bind("click.lightbox",function(event){
			lightbox.remove();
			$(document).unbind("click.lightbox");
		})

	}

	function saveComments()
	{
		this.rating = this.display.find(".star-rating").get(0).className.replace(/^.*?star(\d{1}).*?$/gim,"$1");
		this.comment = this.display.find(".star-rating").find("p").text();
		quest.comments.activeComments[this.screen] = this.comment;
		$(".lightbox").remove();
		$(document).unbind("click.lightbox");
		if(_assignment) {
			_assignment.commentText = this.comment;
			_assignment.rating = this.rating;
			_assignment.coins = Math.max(this.rating - 1,0) * 3;
			_assignment.status = "complete";
			if(!_assignment.comment) _assignment.comment = 1;
			_assignment.update(function(){});

		}

		$.ajax({url:"php/comments.php", type:'POST',data:{request:"save","screen": (_assignment && _assignment.label) ? _assignment.label : this.screen, userID: _assignment ? _assignment.userid : null,table:this.table,comment:this.comment,rating:this.rating},dataType:'json',success:quest.comments.successHandler.bind(_assignment ? _assignment : this),error:errorHandler});
	}

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.PORTFOLIO_PAGE) configure();
		if(pType == quest.PROGRESS_STORED && pData.page == quest.settings.PORTFOLIO_PAGE && ready) submitForm();
	}

	function portfolioHandler(result)
	{
   // alert(result.adminItem + " " + result.setLocation);
		var prompts = $('a[data-prompt*="prompt"],span[data-activity-id*="prompt"]');
		var collages = $('a[data-collage*="collage"],span[data-activity-id*="collage"]');
		var wardrobes = $('a[data-wardrobe*="wardrobe"],span[data-activity-id*="wardrobe"]'); //MD
		var i, count, activity,location;
		activities = result;
		listing = [];
		screenData = {"summary":[],"plan":[]};

		if(result.studentrealname && result.dropdown_teacher_classes)	{ var studentdisplayname = result.studentrealname;
      var classarray = result.dropdown_teacher_classes;
      var parsed = JSON.parse(classarray);

      var newarr = [];

      for(var x in parsed){
        newarr.push(parsed[x]);
      }
      var classinputs = "";
      for (var i = 0; i < newarr.length; i++) {
         classinputs += "<input type=\"hidden\" value=\"" + newarr[i] +" \" name=\"dropdown_teacher_classes[" + i + "]\" />";

      }
			$("body").find("#ui-controls").after("<div id=\"studentPortfolio\">Portfolio of " + studentdisplayname + "&nbsp;&nbsp;| &nbsp;&nbsp;<form name=\"backtoAdmin\" method=\"post\" action=\"/toolkit/teacher/admin" + result.tabloc + "\"><input type=\"hidden\" value=\"" + result.prev_op + "\" name=\"op\"><input type=\"hidden\" value=\"" + result.prev_form_build_id + "\" name=\"form_build_id\"><input type=\"hidden\" value=\"" + result.prev_form_token + "\" name=\"form_token\"><input type=\"hidden\" value=\"" + result.prev_form_id + "\" name=\"form_id\">" + classinputs + "<input type=\"submit\" value=\"View another student portfolio\" /></form></div>" );


      }

		for(i = 0, count = activities.prompts.length; i < count; i++)
		{
			activity = activities.prompts[i];
			location = activity.location;
			if(!screenData[location]) screenData[location] = [];
			screenData[location].push({data:activity,text:activity.data.title});
			listing.push({data:activity});
			if(passport.indexOf(activity.screen) != -1) screenData["plan"].push({data:activity,text:activity.data.title});
			if(activity.feature) screenData["summary"].push({data:activity,location:location,text:activity.data.title});
		}
		for(i = 0, count = activities.collages.length; i < count; i++)
		{
			activity = activities.collages[i];
			location = activity.location;
			if(!screenData[location]) screenData[location] = [];
			screenData[location].push({data:activity,text:activity.data.title});
			listing.push({data:activity});
			if(passport.indexOf(activity.screen) != -1) screenData["plan"].push({data:activity,text:activity.data.title});
			if(activity.feature) screenData["summary"].push({data:activity,location:location,text:activity.data.title});
		}
		for(i = 0, count = activities.organizers.length; i < count; i++)
		{
			activity = activities.organizers[i];
			location = activity.location;
			if(!screenData[location]) screenData[location] = [];
			screenData[location].push({data:activity,text:activity.data.title});
			listing.push({data:activity});
			if(passport.indexOf(activity.screen) != -1) screenData["plan"].push({data:activity,text:activity.data.title});
			if(activity.feature) screenData["summary"].push({data:activity,location:location,text:activity.data.title});
		}

		for(i = 0, count = activities.forecasts.length; i < count; i++)
		{
			activity = activities.forecasts[i];
			location = "cove";

			if(!screenData[location]) screenData[location] = [];
			screenData[location].push({data:activity,text:"Future Forecast"});
			listing.push({data:activity,text:"Future Forecast"});

			if(activity.feature) screenData["summary"].push({data:activity,location:location,text:"Future Forecast"});

		}

		/*MD: adding career outfitters*/
		for(i = 0, count = activities.wardrobes.length; i < count; i++)
		{
			activity = activities.wardrobes[i];
			location = "cove";

			if(!screenData[location]) screenData[location] = [];
			screenData[location].push({data:activity,text:activity.data.title});
			listing.push({data:activity,text:activity.data.title});

			if(activity.feature) screenData["summary"].push({data:activity,location:location,text:activity.data.title});
		}

		screenData["summary"].sort(function(a,b){

			var titleA = getTitleForLocation(a.location);
			var titleB = getTitleForLocation(b.location);
			if(titleA > titleB) return 1;
			return -1;
		});

		self.setTab(self.requestedTab ? self.requestedTab : (result.setLocation ? result.setLocation : "summary"),result);

		self.requestedTab = null;

		function addToScreen(activity)
		{
			var type = activity.type;
			var screen = activity.screen;

			var source = type == "prompt" ? prompts : (type == "collage" ? collages : wardrobes);
			if(type == "forecast")
			{
				if(!screenData["cove"]) screenData["cove"] = [];
				var obj = {data:activity,item:{text:function(){return "Future Forecast"}}}
				screenData["cove"].push(obj);
				listing.push(obj);
				if(activity.feature) screenData["summary"].push(obj);
			}

			for(var j = 0, itemCount = source.length; j < itemCount; j++)
			{
				var item = $(source[j]);
				if(!screenData[location]) screenData[location] = [];
				screenData[location].push({data:activity,item:item});
				listing.push({data:activity,item:item});
				if(activity.feature) screenData["summary"].push({data:activity,item:item});
			}

		}
	}
	function getText(id,type,location)
	{
		var xml = $(quest.xml);
		var node = xml.find("screen#"+type).find("#"+id).find("abbrev");
		if(type == "forecast") return "Future Forecast";
		//trace(id,type,location);
		if(type == "organizer" && (location == "extras" || location == "summary" || !location)) return $("#activity-menu").find("a.organizer").text();
		if(type == "organizer") return $("#chest-popup").find('a[data-organizer="'+id+'"]').text();
		return node.text();
		//$(quest.xml).find("screen#"+ currentActivityType).find("#"+ currentActivityID);
	}

	function configure()
	{
		var username = quest.settings.username;
		$.ajax({url:"php/portfolio.php", type:'POST',data:{request:"fetch"},dataType:'json',success:portfolioHandler,error:errorHandler});

		var container = $("#"+ quest.settings.PORTFOLIO_PAGE);
		container.find("div#portfolio-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#portfolio-mate").addClass(quest.settings.mate);

		var num = quest.settings.mate.replace("mate-","");
		container.find("div#portfolio-mate").attr("aria-describedby","portfolio-mate-"+num+"-description");
		quest.avatars.assignAltText(container.find("div#portfolio-mate"),true);
		_assignment = null;
		return;
		//$.ajax({url:quest.settings.DOWNLOADER_SCRIPT,type:'POST',data:{username:username, activity:"dream-big"},dataType:'json',success:downloadHandler,error:errorHandler});
		ready = false;


		container.find(".tab").addClass("disabled");
		container.find(".tab").eq(4).removeClass("disabled");
		container.find(".active").removeClass("active");
		container.find("#portfolio-activity-title-dream-big").addClass("active");

		if(configured) return;

		$("#"+ quest.settings.PORTFOLIO_PAGE).find("#file").change(fileSelectHandler);
		configured = true;

		container.find("div#portfolio-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#portfolio-mate").addClass(quest.settings.mate);

		var num = quest.settings.mate.replace("mate-","");
		container.find("div#portfolio-mate").attr("aria-describedby","portfolio-mate-"+num+"-description");
		quest.avatars.assignAltText(container.find("div#portfolio-mate"),true);
	}

	function fileSelectHandler(pEvent)
	{
		var path = $("#"+ quest.settings.PORTFOLIO_PAGE).find("#file")[0].value;
		var file = path.match(/([\w\d_-]*)\.?[^\\\/]*$/i)[0];
		$("#"+ quest.settings.PORTFOLIO_PAGE).find("#filepath")[0].value = file;
		$("#"+ quest.settings.PORTFOLIO_PAGE).find("#username")[0].value = quest.settings.username;
		$("#"+ quest.settings.PORTFOLIO_PAGE).find("#redirect")[0].value = window.location;
		$("#"+ quest.settings.PORTFOLIO_PAGE).find("#filepath")[0].value = file;

		ready = true;

		quest.progress.activityComplete();
	}

	function submitForm()
	{
		$("#"+ quest.settings.PORTFOLIO_PAGE).find("form").submit();
	}

	function downloadHandler(data, textStatus, jqXHR)
	{
		var html;
		if(data.type == "doc" || data.type == "docx" || data.type == "txt")
		{
			if(data.type == "txt") html = formatText(data.text);
			else html = "<img src='images/portfolio/word-icon.jpg' alt='Microsoft Word Icon'/>";
			$("#"+quest.settings.PORTFOLIO_PAGE).find("#portfolio-file").html(html);
			$("#"+ quest.settings.PORTFOLIO_PAGE).find("#filepath")[0].value = data.filename;
		}
		else if (data.src)
		{
			html = "<img src='"+data.src+"'/>";
			$("#"+quest.settings.PORTFOLIO_PAGE).find("#portfolio-file").html(html);
			$("#"+ quest.settings.PORTFOLIO_PAGE).find("#filepath")[0].value = data.filename;
		}
		else if(!data.fileExists)
		{
			html = "";
			$("#"+quest.settings.PORTFOLIO_PAGE).find("#portfolio-file").html(html);
			$("#"+ quest.settings.PORTFOLIO_PAGE).find("#filepath")[0].value = "";
		}

	}

	function formatText(pText)
	{
		//note for dream big only currently

		var html = "<h4>Your Future Forecast</h4>";
		html += "<p>"+pText.replace("Your Future Forecast","").replace(/\./gim,".<br/><br/>")+"</p>";
		return html;
	}


	function errorHandler(data, textStatus, jqXHR)
	{
		//trace("error")
		trace("error",data,textStatus);
		quest.showAlert("shutdown");
	}

	quest.registerEventListener(onApplicationUpdate);

	return self;

}(quest,quest.portfolio = quest.portfolio || {}));

quest.map = (function(quest,self){
	
	var trace = quest.trace;
	var configured = false;
	var timeout;
	
	self.launchCove = function()
	{
		clearTimeout(timeout);
		var container = $("#"+quest.settings.MAP_PAGE);
		container.find(".path").css("opacity",0);
		container.find("#path-cove").animate({opacity:1});
		timeout = setTimeout(launchCovePage,3000);
	}
	self.launchMountain = function()
	{
		clearTimeout(timeout);
		var container = $("#"+quest.settings.MAP_PAGE);
		container.find(".path").css("opacity",0);
		container.find("#path-mountain").animate({opacity:1});
		timeout = setTimeout(launchMountainPage,3000);
	}
	
	self.launchSanctuary = function()
	{
		clearTimeout(timeout);
		var container = $("#"+quest.settings.MAP_PAGE);
		container.find(".path").css("opacity",0);
		container.find("#path-sanctuary").animate({opacity:1});
		timeout = setTimeout(launchSanctuaryPage,3000);
	}


	self.launchCave = function()
	{
		
		clearTimeout(timeout);
		var container = $("#"+quest.settings.MAP_PAGE);
		container.find(".path").css("opacity",0);
		container.find("#path-cave").animate({opacity:1});
		timeout = setTimeout(launchCavePage,3000);
	}
	
	self.launchPort = function()
	{	
		clearTimeout(timeout);
		quest.loadScreen(quest.settings.PORT_PAGE);
	}
	self.launchHut = function()
	{
		clearTimeout(timeout);
		var container = $("#"+quest.settings.MAP_PAGE);
		container.find(".path").css("opacity",0);
		container.find("#path-hut").animate({opacity:1});
		timeout = setTimeout(launchHutPage,3000);
	}
	
	
	function launchCovePage()
	{
		quest.loadScreen(quest.settings.COVE_PAGE);
	}
	function launchMountainPage()
	{
		quest.loadScreen(quest.settings.MOUNTAIN_PAGE);
	}
	function launchSanctuaryPage()
	{
		quest.loadScreen(quest.settings.SANCTUARY_PAGE);
	}
	function launchCavePage()
	{
		quest.loadScreen(quest.settings.VIDEO_PAGE);
	}
	function launchHutPage()
	{
		quest.loadScreen(quest.settings.HUT_PAGE);
	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.MAP_PAGE) configure();
	}
	function configure()
	{
		var container = $("#"+quest.settings.MAP_PAGE);
		container.find(".path").css("opacity",0);

		container.find("div#map-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#map-mate").addClass(quest.settings.mate);

		var num = quest.settings.mate.replace("mate-","");
		container.find("div#map-mate").attr("aria-describedby","map-mate-"+num+"-description");
		quest.avatars.assignAltText(container.find("div#map-mate"),true);
	}
	
	function visitCheck(data)
	{
		var completed = 0;
		var checks = [quest.settings.COVE_PAGE,quest.settings.MOUNTAIN_PAGE,quest.settings.VIDEO_PAGE,quest.settings.SANCTUARY_PAGE];
		var bookmarks = quest.progress.getCompletedBookmarks();
		
		for(var i = 0, count = bookmarks.length; i < count; i++)
		{
			var bookmark = bookmarks[i];
			if(checks.indexOf(bookmark.page) != -1) completed ++;
		}
		
		data = parseInt(data);
		
		if(completed == data) return true;
		else if(completed >= 3 && data == 3) return true;
		return false;
	}
	
	quest.audio.registerAudioCallback("mapVisitCheck",visitCheck);
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.map = quest.map || {}))

quest.cove = (function(quest,self){
	
	var trace = quest.trace;
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.COVE_PAGE) configure();
	}
	
	function configure()
	{
		var container = $("#"+quest.settings.COVE_PAGE);
		
		container.find("div#cove-avatar").removeClass(function (index, css) { return (css.match (/\bavatar-\S+/g) || []).join(' ');});
		container.find("div#cove-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#cove-avatar").addClass(quest.settings.avatar);
		container.find("div#cove-mate").addClass(quest.settings.mate);

		var num = quest.settings.avatar.replace("avatar-","");
		container.find("div#cove-avatar").attr("aria-describedby","#cove-avatar-"+num+"-description");
		container.find("div#cove-avatar").html("<p id='#cove-avatar-"+num+"-description' class='description'>"+quest.avatars.alt[num]+"</p>");

		num = quest.settings.mate.replace("mate-","");
		container.find("div#cove-mate").attr("aria-describedby","cove-mate-"+num+"-description");
		quest.avatars.assignAltText(container.find("div#cove-mate"),true);
		//container.find("div#cove-mate").html("<p id='cove-mate-"+num+"-description' class='description'>"+quest.avatars.mateAlt[num]+"</p>");
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest, quest.cove = quest.cove || {}))

quest.mountain = (function(quest,self){
	
	var trace = quest.trace;
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.MOUNTAIN_PAGE) configure();
	}
	
	function configure()
	{
		var container = $("#"+quest.settings.MOUNTAIN_PAGE);
		
		container.find("div#mountain-avatar").removeClass(function (index, css) { return (css.match (/\bavatar-\S+/g) || []).join(' ');});
		container.find("div#mountain-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#mountain-avatar").addClass(quest.settings.avatar);
		container.find("div#mountain-mate").addClass(quest.settings.mate);

		var num = quest.settings.avatar.replace("avatar-","");
		container.find("div#mountain-avatar").attr("aria-describedby","#mountain-avatar-"+num+"-description");
		container.find("div#mountain-avatar").html("<p id='#mountain-avatar-"+num+"-description' class='description'>"+quest.avatars.alt[num]+"</p>");

		num = quest.settings.mate.replace("mate-","");
		container.find("div#mountain-mate").attr("aria-describedby","mountain-mate-"+num+"-description");
		quest.avatars.assignAltText(container.find("div#mountain-mate"),true);
		//container.find("div#mountain-mate").html("<p id='mountain-mate-"+num+"-description' class='description'>"+quest.avatars.mateAlt[num]+"</p>");
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest, quest.mountain = quest.mountain || {}))

quest.sanctuary = (function(quest,self){
	
	var trace = quest.trace;
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.SANCTUARY_PAGE) configure();
	}
	
	function configure()
	{
		var container = $("#"+quest.settings.SANCTUARY_PAGE);
		
		container.find("div#sanctuary-avatar").removeClass(function (index, css) { return (css.match (/\bavatar-\S+/g) || []).join(' ');});
		container.find("div#sanctuary-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#sanctuary-avatar").addClass(quest.settings.avatar);
		container.find("div#sanctuary-mate").addClass(quest.settings.mate);

		var num = quest.settings.avatar.replace("avatar-","");
		container.find("div#sanctuary-avatar").attr("aria-describedby","sanctuary-avatar-"+num+"-description");
		container.find("div#sanctuary-avatar").html("<p id='sanctuary-avatar-"+num+"-description' class='description'>"+quest.avatars.alt[num]+"</p>");

		num = quest.settings.mate.replace("mate-","");
		container.find("div#sanctuary-mate").attr("aria-describedby","sanctuary-mate-"+num+"-description");
		quest.avatars.assignAltText(container.find("div#sanctuary-mate"),true);
		//container.find("div#sanctuary-mate").html("<p id='sanctuary-mate-"+num+"-description' class='description'>"+quest.avatars.mateAlt[num]+"</p>");
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest, quest.sanctuary = quest.sanctuary || {}))

quest.video = (function(quest,self){
	
	var trace = quest.trace;
	var showing = false;
	var video = null;


	self.launchVideo = function(url,target)
	{
		$("#"+quest.settings.VIDEO_PAGE).find(".video-button").removeClass("selected");
		$("#"+target).addClass("selected");
		$("#"+quest.settings.VIDEO_PAGE).find("#video-cave-video").find("iframe").attr("src",url);
	};

	self.setTab = function(tab){
		var container = $("#tab-container");
		trace(container);
		container.attr("class",container.attr("class").replace(/tab-[a-z]+/gim,""));
		container.addClass("tab-"+tab);
	};


	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.VIDEO_PAGE) configure(pData);
		else if(pType == quest.PAGE_ANIMATION_COMPLETE && quest.currentPage != quest.settings.VIDEO_PAGE) unload();
	}
	
	function unload()
	{
		if(showing) $("#"+quest.settings.VIDEO_PAGE).find("#video-cave-video").html(video.text());
		showing = false;
	}
	
	function configure(pData)
	{
		video = $(pData.content).find("video");
		$("#"+quest.settings.VIDEO_PAGE).find("#video-cave-video").html(video.text());
		showing = true;

		$("#"+quest.settings.VIDEO_PAGE).find("button").click(onScroll);

		var leftVideos = $("#video-links-left").find("a").length;
		var rightVideos = $("#video-links-right").find("a").length;

		if(leftVideos < 6) $(".scroll-buttons.left").hide();
		if(rightVideos < 6) $(".scroll-buttons.right").hide();
		
		var container = $("#"+quest.settings.VIDEO_PAGE);
		container.find("div#video-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		container.find("div#video-mate").addClass(quest.settings.mate);

		var num = quest.settings.mate.replace("mate-","");
		container.find("div#video-mate").attr("aria-describedby","video-mate-"+num+"-description");
		quest.avatars.assignAltText(container.find("div#video-mate"),true);
	}

	function onScroll(event)
	{
		var button = $(this);
		var target = $("#"+button.closest("div").data("target"));
		var up = button.hasClass("scroll-up");
		var scrollValue = target.scrollTop();
		if(up) target.scrollTop(Math.max(scrollValue-100,0));
		else target.scrollTop(scrollValue + 100);
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest, quest.video = quest.video || {}))

quest.glossary = (function(quest,self){
	
	var trace = quest.trace;
	var configured = false;
	var content = null;
	var requestedContext = null;

	var audioArray = [{"id":0,"term":"Ability"}, {"id":1,"term":"Access"}, {"id":2,"term":"Career"}, {"id":3,"term":"College"}, {"id":4,"term":"Consistently"}, {"id":5,"term":"Curriculum"}, {"id":6,"term":"Future"}, {"id":7,"term":"Inconsistently"}, {"id":8,"term":"Information"}, {"id":9,"term":"Produce"}, {"id":10,"term":"Readiness"}, {"id":11,"term":"504 Plan"}, {"id":12,"term":"Accommodation"}, {"id":13,"term":"Consistent"}, {"id":14,"term":"Goal"}, {"id":15,"term":"IEP (Individualized Education Program)"}, {"id":16,"term":"Independent"}, {"id":17,"term":"Learning Style"}, {"id":18,"term":"Ownership"}, {"id":19,"term":"Personal"}, {"id":20,"term":"Strategy"}, {"id":21,"term":"Strength"}, {"id":22,"term":"Conflict"}, {"id":23,"term":"Counseling"}, {"id":24,"term":"Direction"}, {"id":25,"term":"Extracurricular"}, {"id":26,"term":"Friend"}, {"id":27,"term":"Responsibility"}, {"id":28,"term":"Role Model"}, {"id":29,"term":"Self Advocacy"}, {"id":30,"term":"Social Skills"}, {"id":31,"term":"Access"}, {"id":32,"term":"Admire"}, {"id":33,"term":"Advocacy"}, {"id":34,"term":"Annual Review"}, {"id":35,"term":"Apprenticeship"}, {"id":36,"term":"Artist Smock"}, {"id":37,"term":"Assistive Technology"}, {"id":38,"term":"Associates Degree"}, {"id":39,"term":"Bachelors Degree"}, {"id":40,"term":"Bullying"}, {"id":41,"term":"Business Casual"}, {"id":42,"term":"Business Siut"}, {"id":43,"term":"Bystander"}, {"id":44,"term":"Certification"}, {"id":45,"term":"Chef Coat"}, {"id":46,"term":"Chef Hat"}, {"id":47,"term":"Collage"}, {"id":48,"term":"Community College"}, {"id":49,"term":"Consequence"}, {"id":50,"term":"Coveralls"}, {"id":51,"term":"Cowardly"}, {"id":52,"term":"Daydream"}, {"id":53,"term":"Determination"}, {"id":54,"term":"Disability"}, {"id":55,"term":"Duplicate"}, {"id":56,"term":"Firefigher Uniform"}, {"id":57,"term":"Firefighter Uniform Helmet"}, {"id":58,"term":"Glossary"}, {"id":59,"term":"Gossip"}, {"id":60,"term":"Graduate School"}, {"id":61,"term":"Guidance Counselor"}, {"id":62,"term":"Hard Hat"}, {"id":63,"term":"Headset Microphone"}, {"id":64,"term":"Inclusion"}, {"id":65,"term":"Insconsistently"}, {"id":66,"term":"Inspire"}, {"id":67,"term":"Interdependent"}, {"id":68,"term":"Interview"}, {"id":69,"term":"Job"}, {"id":70,"term":"Lab Coat"}, {"id":71,"term":"Learning Specialist"}, {"id":72,"term":"Long Term Goal"}, {"id":73,"term":"Master's Degree"}, {"id":74,"term":"Military Uniform"}, {"id":75,"term":"Military Uniform Hat"}, {"id":76,"term":"Modification"}, {"id":77,"term":"Modify"}, {"id":78,"term":"Peer Pressure"}, {"id":79,"term":"Police Hat"}, {"id":80,"term":"Police Uniform"}, {"id":81,"term":"Quality"}, {"id":82,"term":"Resilient"}, {"id":83,"term":"Resource"}, {"id":84,"term":"Safety Goggles"}, {"id":85,"term":"Salary"}, {"id":86,"term":"Sanctuary"}, {"id":87,"term":"Scrubs"}, {"id":88,"term":"Scuba Mask & Breathing Apparatus"}, {"id":89,"term":"Self Confidence"}, {"id":90,"term":"Self Esteem"}, {"id":91,"term":"Short Term Goal"}, {"id":92,"term":"Special Education"}, {"id":93,"term":"Sports Jersey"}, {"id":94,"term":"Stylist Smock"}, {"id":95,"term":"Surgical Mask & Cap"}, {"id":96,"term":"Technical School"}, {"id":97,"term":"Trade School"}, {"id":98,"term":"Transition"}, {"id":99,"term":"Transition IEP"}, {"id":100,"term":"Unique"}, {"id":101,"term":"Vocational School"}, {"id":102,"term":"Wetsuit"}, {"id":103,"term":"Yurt"}];	
	var audioDictionarySrc = {"Ability":0, "Access":1, "Career":2, "College":3, "Consistently":4, "Curriculum":5, "Future":6, "Inconsistently":7, "Information":8, "Produce":9, "Readiness":10, "504 Plan":11, "Accommodation":12, "Consistent":13, "Goal":14, "IEP (Individualized Education Program)":15, "Independent":16, "Learning Style":17, "Ownership":18, "Personal":19, "Strategy":20, "Strength":21, "Conflict":22, "Counseling":23, "Direction":24, "Extracurricular":25, "Friend":26, "Responsibility":27, "Role Model":28, "Self Advocacy":29, "Social Skills":30, "Access":31, "Admire":32, "Advocacy":33, "Annual Review":34, "Apprenticeship":35, "Artist Smock":36, "Assistive Technology":37, "Associates Degree":38, "Bachelors Degree":39, "Bullying":40, "Business Casual":41, "Business Siut":42, "Bystander":43, "Certification":44, "Chef Coat":45, "Chef Hat":46, "Collage":47, "Community College":48, "Consequence":49, "Coveralls":50, "Cowardly":51, "Daydream":52, "Determination":53, "Disability":54, "Duplicate":55, "Firefigher Uniform":56, "Firefighter Uniform Helmet":57, "Glossary":58, "Gossip":59, "Graduate School":60, "Guidance Counselor":61, "Hard Hat":62, "Headset Microphone":63, "Inclusion":64, "Insconsistently":65, "Inspire":66, "Interdependent":67, "Interview":68, "Job":69, "Lab Coat":70, "Learning Specialist":71, "Long Term Goal":72, "Master's Degree":73, "Military Uniform":74, "Military Uniform Hat":75, "Modification":76, "Modify":77, "Peer Pressure":78, "Police Hat":79, "Police Uniform":80, "Quality":81, "Resilient":82, "Resource":83, "Safety Goggles":84, "Salary":85, "Sanctuary":86, "Scrubs":87, "Scuba Mask & Breathing Apparatus":88, "Self Confidence":89, "Self Esteem":90, "Short Term Goal":91, "Special Education":92, "Sports Jersey":93, "Stylist Smock":94, "Surgical Mask & Cap":95, "Technical School":96, "Trade School":97, "Transition":98, "Transition IEP":99, "Unique":100, "Vocational School":101, "Wetsuit":102, "Yurt":103};
	var audioDictionary = {};
	for(var term in audioDictionarySrc) {
		audioDictionary[term.toLowerCase()] = audioDictionarySrc[term];
	}

	function onApplicationUpdate(type,data)
	{
		if(type == quest.PROGRAM_LINKS) setLinks(data);
		if(type == quest.PAGE_LOAD && data.id == quest.settings.GLOSSARY_PAGE) configure(data);
	}
	function setLinks(data){
		requestedContext = data.context;
		$(".glossary-term").off("click",onLinkClick);
		$(".glossary-term").on("click",onLinkClick);
	}
	function onLinkClick(event){
		var container = $("#"+ quest.settings.GLOSSARY_PAGE);
		var link = $(this);
		var term = link.text().substring(0,1).toUpperCase() + link.text().substring(1).toLowerCase();
		var header = container.find("h3:contains("+term+")");
		
		if(!header || !header.length) {
			term = link.text();
			header = container.find("h3:contains("+term+")");
		}
		trace("About to search for term",term)
		var definition = header.siblings("p").html().replace(/"/gim,"");
		var parent = requestedContext || link.closest(".screen");
		var template = $('<div id="gb-glossary" aria-hidden="true" aria-live="polite" aria-atomic="true" aria-relevant="text,additions,deletions"> <div class="db-glossary-container"> <h3>Test</h3> <p>definition</p> <button class="close">Close</button> </div> </div>');
		var position = link.offset();
		var audio = header.parent().attr("src");
		template.find("h3").html(term);
		template.find("p").html(definition);
		parent.append(template);

		trace("we have a word",term,definition,audio,"------");

		if(audio && audio.length > 1){
			var button = $("<a class='glossary-audio-button' href='javascript:void(0)' data-audio='"+audio+"'>Play Audio</a> ");
			template.find(".db-glossary-container").prepend(button);
			template.find(".glossary-audio-button").click(function(event){
				event.stopImmediatePropagation();
				var audio = $(this).data("audio");
				quest.audio.playClip(audio);
			});
		}

		requestedContext = null;
		event.stopImmediatePropagation();
		template.fadeIn();


		$(document).on("click.glossary",function(){
			$("#gb-glossary").remove();
			$(document).off("click.glossary");
		});
	}
	function configure(data)
	{
		var container = $("#"+ quest.settings.GLOSSARY_PAGE);
		container.find(".glossary-activity-title").stop().ariaHide();
		container.find(".glossary-entry").stop().ariaHide();
		container.find(".glossary-category").stop().ariaHide(); //MD
		if(quest.previousPage) 
		{
			var termsExist = container.find("."+quest.previousPage).length;
			if(termsExist) container.find("."+quest.previousPage).stop().ariaFadeIn();
			else 
			{
				//MD ... if general glossary, all terms showup, including the category headings
				container.find(".glossary-category").stop().ariaFadeIn(); //MD
				container.find(".glossary-entry").stop().ariaFadeIn();
			}
		}
		if(!configured) 
		{
			content = $(data.content);
			container.find(".glossary-entry").attr("tabindex",0).attr("role","button").click(glossaryClickHandler).on("keydown",function(e){
				
				if(e.keyCode == 32  || e.keyCode == 13) 
				{
					e.preventDefault();
					glossaryClickHandler.bind(this)();
				}
			});

			container.find(".glossary-entry").each(function(e){
				var block = $(this);
				var word = block.find("h3");
				var def = block.find("p");
				word.prepend('<a class="global-audio-button xs" href="javascript:void(0)">Toggle Audio</a>');
				def.prepend('<a class="global-audio-button xs" href="javascript:void(0)">Toggle Audio</a>');

				word.find(".global-audio-button").click(playWord);
				def.find(".global-audio-button").click(playDefinition);
			});
		}
		configured = true;
		$("#word-container").get(0).scrollTop = 0;

		if(self.requestedTerm){	

			var term = self.requestedTerm.substring(0,1).toUpperCase() + self.requestedTerm.substring(1).toLowerCase();
			var target = container.find("h3:contains("+term+")");
			if(!target.length) return;
			setTimeout(function(){
				$("#word-container").animate({scrollTop:target.position().top});
			},0);
			

			self.requestedTerm = null;
		}
		quest.update(quest.PROGRAM_LINKS,{});
	}
	
	function glossaryClickHandler(event)
	{
		/*var word = $(this).find("h3").text().replace(/[']/gim,"").toLowerCase();
		var audio = audioDictionary[word];

		trace(word,audio,audioDictionary);
		/*var path = $(content.find("#word-container").find("block")[$(this).index()]).attr("src");
		if(!path) return;
		
		quest.audio.playClip(path);*/
	}

	function playWord() {
		var word = $(this).closest(".glossary-entry").find("h3").text().replace(/[']/gim,"").toLowerCase().replace(/toggle audio/gim,"");
		var audio = audioDictionary[word];

		trace(audio,word,audioDictionary);

		var path = "audio/" + audio + "_term";
		quest.audio.playClip(path);
	}
	function playDefinition() {
		var word = $(this).closest(".glossary-entry").find("p").text().replace(/[']/gim,"").toLowerCase().replace(/toggle audio/gim,"");
		var audio = audioDictionary[word];

		trace(audio,word);

		var path = "audio/" + audio + "_definition";
		quest.audio.playClip(path);
	}
	
	function visitCheck(data)
	{
		var page = quest.previousPage;
		if(data == page) return true;
		return false;
	}
	
	quest.audio.registerAudioCallback("glossaryVisitCheck",visitCheck);
	quest.registerEventListener(onApplicationUpdate);
	return self;
}(quest,quest.glossary = quest.glossary || {}))

quest.dreambig = (function(quest,self){

	var trace 						= quest.trace;
	var container 					= null;
	var next 						= null;
	var previous					= null;
	var pages						= null;
	var welcome						= null;
	var currentScreen				= 0;
	var audioCue 					= {category: [], source: []};
	
	var animation					= 0;
	var lights						= null;
	var currentLight				= null;
	var lightCount					= 0;
	var lightIndex					= -1;	
	var lightSpeed					= 100;
	var lightFactor					= 0;

	var template 					= null;
	
	var cycles						= 0;
	var active  					= false;
	var completed 					= false;

	var glossary 					= null;

	self.location =  "cove";

	
	self.toggleCategoryItem = function(category,item,path)
	{
		var button = $("#db-category-"+item);
		var selectionsPage = $("#db-lights-"+item);
		var totem = $("#db-totem-"+item);
		
		if(button.hasClass("disabled")) return;
		if(!button.hasClass("selected")) quest.audio.playClip(path);
		button.toggleClass("selected");
		selectionsPage.toggleClass('selected');
		totem.toggleClass('selected');
		checkCategoryCompletion(category);
	}
	
	function checkCategoryCompletion(category)
	{
		var page  = $("#db-category-"+category);
		var items = page.find(".db-category-selection");
		var selections = page.find(".selected");
		var count = selections.length;
		var totemSelects = $(".db-future-totem");
		
		
		if(count == quest.settings.MAX_DREAM_BIG_SELECTIONS) 
		{
			 items.not(".selected").addClass("disabled").attr("disabled","disabled");
			 totemSelects.not(".selected").addClass("disabled");
			 next.removeClass("disabled");



		}
		else
		{
			items.removeClass("disabled").attr("disabled",null);
			totemSelects.removeClass(".selected");
			next.addClass("disabled");
		}
		
		page.find(".selected").each(function(index){
			container.addClass("item-"+$(this).attr("id"));
		})
	}
	
	function nextScreen(event)
	{
		if(next.hasClass("disabled")) return;
		
		if(currentScreen < pages.length - 1)
		{
			pages.eq(currentScreen).ariaFadeOut().removeClass('active');
			currentScreen++;
			pages.eq(currentScreen).ariaFadeIn().addClass('active');
			if(pages.eq(currentScreen).hasClass('active')) quest.audio.playClip(pages.eq(currentScreen).attr("src"));
			showScreen();

			pages.eq(currentScreen).attr("tabindex","-1").focus();

			if(pages.eq(currentScreen).find(".selected").length != quest.settings.MAX_DREAM_BIG_SELECTIONS) next.addClass("disabled");
		}
		
		if(currentScreen == pages.length - 1 && pages.eq(currentScreen).find(".selected").length == quest.settings.MAX_DREAM_BIG_SELECTIONS)
		{
			pages.eq(currentScreen).removeClass('active').ariaFadeOut();
			$('.db-category-lights').ariaFadeOut();
			$('#db-navigation').ariaFadeOut();
			$('#db-selections').ariaFadeIn();


			quest.audio.queueClip('audio/30_FQI_FutureForecast.mp3',true);
			quest.audio.queueClip('audio/31_FQI_FutureForecast.mp3');
			//quest.audio.queueClip('audio/32_FQI_FutureForecast.mp3');
			quest.audio.queueClip('audio/33_FQI_FutureForecast.mp3');
			quest.audio.loadQueue(true);
			
			//set the light colors initially
			var colors = ["pink","orange","blue","green"];
			var colorIndex = 0;
			var list = $(container).find(".db-light-background.selected").not(".disabled").find(".db-light-enabled");
		
			list.each(function(index){
				$(this).closest("div").addClass(colors[colorIndex]);
				colorIndex == 3 ? colorIndex = 0 : colorIndex++;
			});
		} 
		
		previous.removeClass("disabled");
	}
	function previousScreen(event)
	{
		if(currentScreen > 0)
		{
			pages.eq(currentScreen).ariaFadeOut().removeClass('active');
			currentScreen--;
			pages.eq(currentScreen).ariaFadeIn().addClass('active');
			showScreen();
		}
		
		if(pages.eq(currentScreen).find(".selected").length == quest.settings.MAX_DREAM_BIG_SELECTIONS)
		{
			next.removeClass('disabled');
		}

		if(currentScreen > 0 )previous.removeClass("disabled");
		else previous.addClass("disabled");
	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.DREAM_BIG_PAGE) 
		{
			configure();
			$('#db-totem-restart').click();
			quest.update(quest.PROGRAM_LINKS,{});
		}
		else active = false;
	}

	function preloadAudio(url) {
	    var audio = new Audio();
	    audio.src = url;
	    audio.preload = "auto";
	    $(audio).on("loadeddata", function(){trace("audio preloaded")});  // jQuery checking
	}
	
	function configure()
	{
		if(!template) template = $("#dream-big").html();
		$("#dream-big").html(template);

		container = $("#dream-big-container");
		next = $("#db-next-button");
		previous = $("#db-previous-button");
		pages = $(".db-category");
		welcome = $("#db-instructions");
		ui = $('#ui-controls').css({display:"block"});
		active = true;

		glossary = container.find("#db-glossary");
		
		next.click(nextScreen);
		previous.click(previousScreen);
		
		welcome.ariaFadeIn();
		next.addClass("disabled");
		previous.addClass("disabled");

		preloadAudio("audio/slow_dings.mp3");
		preloadAudio("audio/fast_dings.mp3");
		preloadAudio("audio/slow_dings.ogg");
		preloadAudio("audio/fast_dings.ogg");
		
		//$.ajax({url:quest.settings.UPLOADER_SCRIPT,type:'POST',data:{username:username,text:"hello there"},dataType:'json',success:uploadComplete,error:errorHandler});
		
		
		
		restart();
		mainButtons();
		marqueeButtons();

		container.find("button.glossary-link").on("click",onGlossaryRequest);



		//$(".dream-big-screen").eq(0).ariaShow();



		//$("#db-final").ariaFadeIn()
	}

	function onGlossaryRequest(event)
	{

		var button = $(this);
		var audioID = button.attr("data-audio-id");
		var word = "<a class='glossary-audio-button' href='javascript:void(0)' data-audio='"+audioID+"'>Play Audio</a> " + button.siblings("label").text();
		var definition = button.attr("data-def");

		event.preventDefault();
		event.stopImmediatePropagation();

		glossary.find("h3").html(word).find("a").on("click",function(){
			quest.audio.playClip('audio/FutureForecast_'+$(this).data("audio")+'.mp3');
		});
		glossary.find("p").html(definition);

		//trap focus on the glossary panel to prevent keyboard navigation away when still active
		glossary.ariaFadeIn({complete:function(){
			glossary.attr("tabindex","-1").focus();
			glossary.on("keydown.glossary",function(e){
				if(e.keyCode === 27) return glossaryClose.bind(button)();
				if(e.keyCode === 9) 
				{
					e.preventDefault();
					e.stopImmediatePropagation();
					glossary.find("button").focus();
				}
			});
			glossary.find("button").on("click.glossary-exit",glossaryClose.bind(button));

		}});
		
	}

	function glossaryClose(event)
	{
		quest.audio.close();
		glossary.find("button").off("click.glossary-exit");
		glossary.off("keydown.glossary");
		glossary.ariaFadeOut();
		this.focus();
	}
	
	function uploadComplete(data)
	{
		quest.progress.activityComplete();
		quest.hut.updateAccount(5);
	}
	function errorHandler()
	{
		trace("error uploading activity results");
		for(var i =0, count = arguments.length; i < count; i++)
		{
			trace(arguments[i]);
		}
		quest.progress.activityComplete();
		quest.showAlert("shutdown");

	}
	
	
	function mainButtons()
	{
		$("#db-start-button").click(function(){
			welcome.ariaFadeOut();
			pages.first().ariaFadeIn().addClass('active');
			if($("#db-category-live")) quest.audio.playClip($("#db-category-live").attr("src"));
			showScreen();
		});
		
		$("#db-totem-save").click(function(){
			$("#db-final").ariaFadeOut();
			$("#db-completed").ariaFadeIn();
			var text = generateText();
			quest.progress.activityComplete();
			$.ajax({url:"php/forecast.php",type:'POST',data:{request:"save",screen:"cove",forecast:text},dataType:'json',success:uploadComplete,error:errorHandler});
			//$.ajax({url:quest.settings.UPLOADER_SCRIPT,type:'POST',data:{username:quest.settings.username,text:text},dataType:'json',success:uploadComplete,error:errorHandler});

		});
		
		$("#db-done-button").click(function(){
			$("#dream-big").ariaFadeOut();
			quest.loadScreen(quest.settings.COVE_PAGE);
			restart();
		});
		
	}
	
	function generateText()
	{
		return $("#db-final-future").text();
	}
	
	function autoselect()
	{
		$(".db-category").each(function(){
			$(this).find(".db-category-selection").each(function(index){
				if(index < 4) $(this).click()//addClass("selected");
			})
		})
		
		next.removeClass("disabled");
		var screenA	= $('#db-category-live');
		var screenB	= $('#db-selections');
		var nav = $('#db-navigation');
		$("#db-category-selection-lights").ariaHide()
		nav.ariaHide()
		screenB.ariaFadeIn();
		screenA.ariaHide();
		screenB.css("opacity",1);
		var colors = ["pink","orange","blue","green"];
		var colorIndex = 0;
		var list = $(container).find(".db-light-background.selected").not(".disabled").find(".db-light-enabled");
		
		list.each(function(index){
			$(this).closest("div").addClass(colors[colorIndex]);
			colorIndex == 3 ? colorIndex = 0 : colorIndex++;
		});
	}
	
	function showScreen()
	{
		var screenLight = $('.db-category-lights');
		screenLight.removeClass("active")
		
		pages.each(function(index){
			if($(this).hasClass('active')) screenLight.eq(index).addClass("active");
		});
	}
	
	function marqueeButtons()
	{
		var screenB	= $('#db-selections');
		var screenC = $('#db-final');
		
		$('#db-selections-go-button').click(function(event){
			$('.db-light-enabled').animate({opacity:0});
			$('#db-selections-glowing-eyes').ariaFadeIn();
			animateLights();
			quest.audio.clearQueue();
			quest.audio.playClip("audio/fast_dings.mp3", true);
			cycles++;
			
			
			$(this).ariaFadeOut();
			$('#db-selections-go').ariaFadeOut()
			$('#db-selections-stop').ariaFadeIn();
			$('#db-selections-stop-button').ariaFadeIn();
			
		});
		$('#db-selections-stop-button').click(function(event){
			stopAnimation();
			
			$(this).ariaFadeOut();
			$('#db-selections-stop').ariaFadeOut()
			$('#db-selections-go').ariaFadeIn();
			$('#db-selections-go-button').ariaFadeIn().addClass('disabled');
			
			if(screenB.find(".final").length + 1 == quest.settings.MAX_DREAM_BIG_CYCLES){
				stopAnimation();
				screenB.delay(7000).fadeOut(function(){screenB.attr("aria-hidden","true")});
				screenC.delay(7500).fadeIn(function(){
					screenC.attr("aria-hidden","false");

					quest.audio.clearQueue();
					trace("loading queue");
					quest.audio.queueClip("audio/Sentence1part1.mp3");
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("education")]);
					quest.audio.queueClip("audio/Sentence1part2.mp3");
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("job")]);
					quest.audio.queueClip("audio/Sentence2part1.mp3");
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("house")]);
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("location")]);
					quest.audio.queueClip("audio/Sentence2part2.mp3");
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("number")]);
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("pet")]);
					quest.audio.queueClip("audio/Sentence3part1.mp3");
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("color")]);
					quest.audio.queueClip(audioCue.source[audioCue.category.indexOf("transportation")]);
					quest.audio.loadQueue(true);
				});
			}
		});
	}
	
	function restart()
	{
		var screenA	= $('#db-category-live');
		var screenC = $('#db-final');
		var nav = $('#db-navigation');
		var panel = $("#db-selections-future");
		var summary = $("#db-final-future");
			
		$('#db-totem-restart').click(function(event){
			currentScreen = 0;
			cycles = 0;
			pages = $(".db-category"); 
			$('#db-categories').find('.selected').removeClass('selected');
			$('#db-categories').find('.disabled').removeClass('disabled');
			$('#db-category-lights-1').ariaFadeIn();
			nav.ariaFadeIn();
			nav.find('a').addClass('disabled');
			$('#db-selections-go-button').removeClass('disabled');
			$('.db-light-enabled').css({opacity:0});
			lightIndex = 0;
			
			container[0].className = container[0].className.replace(/item-[A-Za-z0-9\-]+\b/gim,'');
			
			screenC.ariaFadeOut();
			screenA.ariaFadeIn();
			
			container.find(".pink").removeClass("pink");
			container.find(".orange").removeClass("orange");
			container.find(".blue").removeClass("blue");
			container.find(".green").removeClass("green");
			container.find(".db-light-background").removeClass("disabled").removeClass("selected").removeClass("final");
			container.find(".db-light-enabled").css("opacity","auto");

			panel.find("span").html("");
			summary.find("span").html("");
		});
		
		
	}
	
	function animateLights()
	{
		lightSpeed =  100/1000;
		lightIndex = 0;
		currentLight = null;
		clearInterval(animation);
		
		lights = $(container).find(".db-light-background.selected").not(".disabled").find(".db-light-enabled");
		
		
		lightCount = lights.length;
		animation = setInterval(advanceLight,100);
	}
		
	function stopAnimation()
	{
		clearInterval(animation);
		quest.audio.playClip("audio/slow_dings.mp3");
		animation = setInterval(slowLight,lightSpeed);
	}
	
	function slowLight()
	{ 
		clearInterval(animation);
		if(lightFactor >= 0.08) {
			if(!currentLight) return;
			var page = container.find("#db-selections");
			var panel = $("#db-selections-future");
			var summary = $("#db-final-future");
			var label = currentLight.siblings(".label").html();
			var regex = /^.*?((?:education)|(?:job)|(?:house)|(?:location)|(?:number)|(?:pet)|(?:color)|(?:transportation)).*?$/gim;
			var className = currentLight.closest("div")[0].className.replace(regex,"$1");
			container.find("."+className).addClass("disabled");
			currentLight.closest("div").addClass("final");
			if(currentLight.closest("div").hasClass("final")) {
				quest.audio.playClip(currentLight.closest("div").attr("src"));
				audioCue.category.push(className);
				audioCue.source.push(currentLight.closest("div").attr("src"));
			}
			panel.find("#db-selections-"+className).find(".selection-label").html(label);
			summary.find("span.selection-label."+className).html(applyArticle(label.toLowerCase(),className));
			lightFactor = 0;
			if($("#db-selections").find(".final").length < quest.settings.MAX_DREAM_BIG_CYCLES)
			{
				$('#db-selections-go-button').removeClass('disabled').css({display:"none"}).ariaFadeIn();
			}
			$("#db-selections-glowing-eyes").ariaFadeOut();
			return;
		}
		lightFactor += 10/1000;
		lightSpeed = easeOut(lightFactor,lightSpeed,800,1);
		
		if(currentLight) 
		{
			currentLight.removeClass("current");
			currentLight.stop().animate({opacity:0},1000);
		}
		lightIndex = (lightIndex == lightCount - 1) ? 0 :  lightIndex+1;
		currentLight = $(lights[lightIndex]);
		currentLight.stop().animate({opacity:1},100);
		
		animation = setInterval(slowLight,lightSpeed);
	}
	
	function applyArticle(label,className)
	{
		var targets = ["job","house","color"];
		if(targets.indexOf(className) == -1) return label;
		return label.match(/^[aeiou]/i) ? ("an " + label) : ("a " + label);
	}
	
	
	function advanceLight()
	{
		if(currentLight) currentLight.stop().animate({opacity:0},1000);
		lightIndex = (lightIndex == lightCount - 1) ? 0 : lightIndex+1;
		currentLight = $(lights[lightIndex]);
		currentLight.stop().animate({opacity:1},100);
	}
	
	function easeOut(t, b, c, d) 
	{
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	}	
	
	$(window).unload(function(){
		quest.audio.close();
	})
	
	quest.registerEventListener(onApplicationUpdate);

	
	return self;
}(quest,quest.dreambig = quest.dreambig || {}));

quest.clickable = (function(quest,self){
	
	var trace = quest.trace;
	var interval;
	var container;
	var index = 0;
	var active = false;
	var current = null;
	var back = null;
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.APPLICATION_READY) configure();
	}
	
	function configure()
	{
		container = $("#"+quest.settings.CLICKABLE_DIALOG);
		quest.launchClickable = launchClickableDialog;
	}
	
	function launchClickableDialog(pTarget,pFrontAudio,pBackAudio)
	{
		if(active) return;
		
		var backMessageContainer = container.find("#back-messages");
		backMessageContainer[0].className = backMessageContainer[0].className.replace(/dialog-mate-\d/gim,"");
		backMessageContainer.addClass("dialog-" + quest.settings.mate);
		
		container.find(".front-message").stop().ariaHide();
		container.find(".back-message").stop().ariaHide();
		container.find(".front-message").attr("aria-hidden","true");
		container.find(".back-message").attr("aria-hidden","true");
		current = pTarget;
		active = true;
		index = 0;
		container[0].className = container[0].className.replace(/dialog-\d/gim,"");
		container.addClass("dialog-1");
		container.stop().ariaFadeIn({complete:renderFrontFace});
		container.attr("aria-hidden","false");
		back = pBackAudio;
		quest.audio.playClip(pFrontAudio);

		quest.update(quest.PROGRAM_LINKS,{context:$("#quest-container")});
	}
	
	function renderFrontFace()
	{
		container.find("a.invisible-button").bind("click",flipHandler);
		$("#front-messages").find("."+current).stop().ariaFadeIn();
		$("#front-messages").find("."+current).attr("aria-hidden","false");
		$("#front-messages").find(".invisible-button").focus();
		
	}
	
	function flipHandler()
	{
		container.find(".front-message").stop().ariaHide();
		container.find(".front-message").attr("aria-hidden",'true');
		container.find("a.invisible-button").unbind("click",flipHandler);
		container.find("a.invisible-button").bind("click",closeHandler);
		
		interval = setInterval(updateFlipPosition,50);
	}
	
	function updateFlipPosition()
	{
		index++;
		if(index > 8) 
		{
			$("#back-messages").find("."+current).stop().ariaFadeIn();
			$("#back-messages").find("."+current).attr("aria-hidden","false");
			$("#back-messages").find(".invisible-button").focus();
			quest.audio.playClip(back);
			return clearInterval(interval);
		}
		container[0].className = container[0].className.replace(/dialog-\d/gim,"");
		container.addClass("dialog-"+index);

	}
	
	function closeHandler()
	{
		clearInterval(interval);
		container.find("a.invisible-button").unbind("click",closeHandler);
		container.stop().ariaFadeOut();
		container.attr("aria-hidden","true");
		active = false;
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest, quest.cove = quest.cove | {}))

quest.hut = (function(quest,self){
	
	var trace = quest.trace;
	var configured = false;

	var source = {
		"Armadillos":{price:3,label:"Armadillos",type:"standard", className:"animals"},
		"bicycle":{price:3,label:"Bicycle",type:"standard", className:"transportation"},
		"Car":{price:3,label:"Car",type:"standard", className:"transportation"},
		"Cats":{price:3,label:"Cats",type:"standard", className:"animals"},
		"Dog":{price:3,label:"Dog",type:"standard", className:"animals"},
		"Dolphin":{price:3,label:"Dolphin",type:"standard", className:"animals"},
		"Fish":{price:3,label:"Fish",type:"standard", className:"animals"},
		"Golf_Cart":{price:3,label:"Golf cart",type:"standard", className:"transportation"},
		"guinea_pigs":{price:3,label:"Guinea pigs",type:"standard", className:"animals"},
		"Hamster":{price:3,label:"Hamster",type:"standard", className:"animals"},
		"Hedgehogs":{price:3,label:"Hedgehogs",type:"standard", className:"animals"},
		"Horses":{price:3,label:"Horses",type:"standard", className:"animals"},
		"Jet_Ski":{price:3,label:"Jet ski",type:"standard", className:"transportation"},
		"Kangaroos":{price:3,label:"Kangaroos",type:"standard", className:"animals"},
		"Koala":{price:3,label:"Koala",type:"standard", className:"animals"},
		"Limo":{price:3,label:"Limo",type:"standard", className:"transportation"},
		"Lizards":{price:3,label:"Lizards",type:"standard", className:"animals"},
		"Monkeys":{price:3,label:"Monkeys",type:"standard", className:"animals"},
		"Places_window_Arctic":{price:3,label:"Arctic window",type:"standard", className:"windows"},
		"Places_Window_Big_City":{price:3,label:"Big city window",type:"standard", className:"windows"},
		"Places_window_by_the_lake":{price:3,label:"Lake window",type:"standard", className:"windows"},
		"Places_window_by_the_sea":{price:3,label:"Sea window",type:"standard", className:"windows"},
		"Places_window_Country":{price:3,label:"Country window",type:"standard", className:"windows"},
		"Places_window_desert":{price:3,label:"Desert window",type:"standard", className:"windows"},
		"Places_window_ghost_town":{price:3,label:"Ghost town window",type:"standard", className:"windows"},
		"Places_window_highway":{price:3,label:"Highway window",type:"standard", className:"windows"},
		"Places_window_jungle":{price:3,label:"Jungle window",type:"standard", className:"windows"},
		"Places_window_mountains":{price:3,label:"Mountains window",type:"standard", className:"windows"},
		"Places_window_outer_space":{price:3,label:"Outer space window",type:"standard", className:"windows"},
		"Places_window_small_town":{price:3,label:"Small town window",type:"standard", className:"windows"},
		"Places_Window_tropical":{price:3,label:"Tropical window",type:"standard", className:"windows"},
		"Places_window_underwater":{price:3,label:"Underwater window",type:"standard", className:"windows"},
		"Places_window_woods":{price:3,label:"Woods window",type:"standard", className:"windows"},
		"pot_bellied_pigs":{price:3,label:"Pot bellied pics",type:"standard", className:"animals"},
		"Racecar":{price:3,label:"Racecar",type:"standard", className:"transportation"},
		"Rocket_Ship":{price:3,label:"Rocket ship",type:"standard", className:"transportation"},
		"Sailboat":{price:3,label:"Sailboat",type:"standard", className:"transportation"},
		"Scooter":{price:3,label:"Scooter",type:"standard", className:"transportation"},
		"Segway":{price:3,label:"Segway",type:"standard", className:"transportation"},
		"Skateboard":{price:3,label:"Skateboard",type:"standard", className:"transportation"},
		"Snails":{price:3,label:"Snails",type:"standard", className:"animals"},
		"Snowmobile":{price:3,label:"Snowmobile",type:"standard", className:"transportation"},
		"Sub":{price:3,label:"Sub",type:"standard", className:"transportation"},
		"Truck":{price:3,label:"Truck",type:"standard", className:"transportation"},
		"Unicycle":{price:3,label:"Unicycle",type:"standard", className:"transportation"},
		
		"beanbag-blue":{price:3,label:"Blue beanbag chair",type:"standard", className:"furniture"},
		"beanbag-plaid":{price:3,label:"Plaid beanbag chair",type:"standard", className:"furniture"},
		"beanbag-polkadots":{price:3,label:"Polka-dotted beanbag chair",type:"standard", className:"furniture"},
		"beanbag-red":{price:3,label:"Red beanbag chair",type:"standard", className:"furniture"},
		"beanbag-zebra":{price:3,label:"Zebra beanbag chair",type:"standard", className:"furniture"},
		"bear-blue":{price:3,label:"Blue bear",type:"standard", className:"accessories"},
		"bear-pink":{price:3,label:"Pink bear",type:"standard", className:"accessories"},
		"bear-white":{price:3,label:"White bear",type:"standard", className:"accessories"},
		"bed-blue":{price:3,label:"Blue bed",type:"standard", className:"furniture"},
		"bed-polkadots":{price:3,label:"Polka-dotted bed",type:"standard", className:"furniture"},
		"bed-striped":{price:3,label:"Striped bed",type:"standard", className:"furniture"},
		"bigpalm-blue":{price:3,label:"Blue big palm",type:"standard", className:"accessories"},
		"bigpalm-terracotta":{price:3,label:"Terracotta big palm",type:"standard", className:"accessories"},
		"bigpalm-white":{price:3,label:"White big palm",type:"standard", className:"accessories"},
		"bigpalm-yellow":{price:3,label:"Yellow big palm",type:"standard", className:"accessories"},
		"bigtable":{price:3,label:"Big table",type:"standard", className:"furniture"},
		"chair-blue":{price:3,label:"Blue chair",type:"standard", className:"furniture"},
		"chair-green":{price:3,label:"Green chair",type:"standard", className:"furniture"},
		"chair-orange":{price:3,label:"Orange chair",type:"standard", className:"furniture"},
		"chair-red":{price:3,label:"Red chair",type:"standard", className:"furniture"},
		"fishtank":{price:3,label:"Fish tank",type:"standard", className:"accessories"},
		"floordarkwood":{price:3,label:"Dark floor",type:"floor", className:"house"},
		"floorgarage":{price:3,label:"Garage floor",type:"floor", className:"house"},
		"floorgreen":{price:3,label:"Green floor",type:"floor", className:"house"},
		"floorpink":{price:3,label:"Pink floor",type:"floor", className:"house"},
		"floorsand":{price:3,label:"Sand floor",type:"floor", className:"house"},
		"floorwhite":{price:3,label:"White floor",type:"floor", className:"house"},
		"floorwood":{price:3,label:"Woord floor",type:"floor", className:"house"},
		"islandframe":{price:3,label:"Island frame",type:"standard", className:"accessories"},
		//"lamp-blue":{price:3,label:"Blue lamp",type:"standard", className:"accessories"},
		//"lamp-green":{price:3,label:"Green lamp",type:"standard", className:"accessories"},
		//"lamp-red":{price:3,label:"Red lamp",type:"standard", className:"accessories"},
		"laptop":{price:3,label:"Laptop",type:"standard", className:"accessories"},
		"lava-green":{price:3,label:"Green lava lamp",type:"standard", className:"accessories"},
		"lava-pink":{price:3,label:"Pink lava lamp",type:"standard", className:"accessories"},
		"light-blue":{price:3,label:"Blue light",type:"standard", className:"accessories"},
		"light-green":{price:3,label:"Green light",type:"standard", className:"accessories"},
		"light-red":{price:3,label:"Red light",type:"standard", className:"accessories"},
		"partylanterns":{price:3,label:"Party lanterns",type:"standard", className:"accessories"},
		"plant-blue":{price:3,label:"Blue plant",type:"standard", className:"accessories"},
		"plant-red":{price:3,label:"Red plant",type:"standard", className:"accessories"},
		"plant-terracotta":{price:3,label:"Terracotta plant",type:"standard", className:"accessories"},
		"plant-yellow":{price:3,label:"Yellow plant",type:"standard", className:"accessories"},
		"rug-blue":{price:3,label:"Blue rug",type:"standard", className:"accessories"},
		"rug-green":{price:3,label:"Green rug",type:"standard", className:"accessories"},
		"rug-red":{price:3,label:"Red rug",type:"standard", className:"accessories"},
		"shelf":{price:3,label:"Shelf",type:"standard", className:"accessories"},
		"table-blue":{price:3,label:"Blue table",type:"standard", className:"furniture"},
		"table-orange":{price:3,label:"Orange table",type:"standard", className:"furniture"},
		"table-white":{price:3,label:"White table",type:"standard", className:"furniture"},
		"tiki":{price:3,label:"Tiki",type:"standard", className:"accessories"},
		"tv":{price:3,label:"TV",type:"standard", className:"accessories"},
		"wallgarage":{price:3,label:"Garage wall",type:"wall", className:"house"},
		"wallgreen":{price:3,label:"Green wall",type:"wall", className:"house"},
		"wallgreenstripes":{price:3,label:"Green striped wall",type:"wall", className:"house"},
		"wallmelon":{price:3,label:"Melon wall",type:"wall", className:"house"},
		"wallorange":{price:3,label:"Orange wall",type:"wall", className:"house"},
		"wallpinkstripes":{price:3,label:"Pink striped wall",type:"wall", className:"house"},
		"wallpurple":{price:3,label:"Purple wall",type:"wall", className:"house"},
		"wallstripes":{price:3,label:"Striped wall",type:"wall", className:"house"},
		"wallyellow":{price:3,label:"Yellow wall",type:"wall", className:"house"},
		"windowround-blue":{price:3,label:"Blue round window",type:"standard", className:"windows"},
		"windowround-orange":{price:3,label:"Orange round window",type:"standard", className:"windows"},
		"windowround-red":{price:3,label:"Red round window",type:"standard", className:"windows"},
		"windowsquare-blue":{price:3,label:"Blue square window",type:"standard", className:"windows"},
		"windowsquare-orange":{price:3,label:"Orange square window",type:"standard", className:"windows"},
		"windowsquare-red":{price:3,label:"Red square window",type:"standard", className:"windows"},
		"xbox":{price:3,label:"Game console",type:"standard", className:"accessories"},



		"bananatree":{price:3,label:"banana tree (outdoor)",type:"standard",className:"accessories"},
		"bbq":{price:3,label:"bbq grill",type:"standard",className:"furniture"},
		"birdbath":{price:3,label:"birdbath with a bird on it",type:"standard",className:"accessories"},
		"blender":{price:3,label:"Blender",type:"standard",className:"accessories"},
		"butterfly":{price:3,label:"butterfly",type:"standard",className:"animals"},
		"cafetable":{price:3,label:"cafe table and chairs (outdoor)",type:"standard",className:"furniture"},
		"coffeemaker":{price:3,label:"coffee maker",type:"standard",className:"accessories"},
		"fruitbowl":{price:3,label:"fruit bowl",type:"standard",className:"accessories"},
		"gamerchair":{price:3,label:"gamer chair",type:"standard",className:"furniture"},
		"gardenfence":{price:3,label:"garden fence",type:"standard",className:"accessories"},
		"lawngnome":{price:3,label:"garden gnome",type:"standard",className:"accessories"},
		"flowerbed":{price:3,label:"garden: flower bed",type:"standard",className:"accessories"},
		"vegetablegarden":{price:3,label:"garden: vegetable patch",type:"standard",className:"accessories"},
		"grassfloor":{price:3,label:"grass floor",type:"floor",className:"house"},
		"hammock":{price:3,label:"hammock",type:"standard",className:"furniture"},
		"kitchenclock":{price:3,label:"kitchen clock",type:"standard",className:"accessories"},
		"kitchencounter":{price:3,label:"kitchen counter",type:"standard",className:"furniture"},
		"kitchentable":{price:3,label:"kitchen table and chairs",type:"standard",className:"furniture"},
		"kitchentilefloor":{price:3,label:"Kitchen tile",type:"floor",className:"house"},
		"lawnchair":{price:3,label:"lawn chair",type:"standard",className:"furniture"},
		"oaktree":{price:3,label:"oak tree (outdoor)",type:"standard",className:"accessories"},
		"orangetree":{price:3,label:"orange tree (outdoor)",type:"standard",className:"accessories"},
		"pastelwalltile":{price:3,label:"Pastel tile wall",type:"wall",className:"house"},
		"picnicblanket":{price:3,label:"picnic blanket w/ picnic setup",type:"standard",className:"accessories"},
		"retrochair1":{price:3,label:"retro chair 1",type:"standard",className:"furniture"},
		"retrochair2":{price:3,label:"retro chair 2",type:"standard",className:"furniture"},
		"retrocarpet1":{price:3,label:"retro pattern carpet1",type:"floor",className:"house"},
		"retrocarpet2":{price:3,label:"retro pattern carpet2",type:"floor",className:"house"},
		"retrowallpaper1":{price:3,label:"Retro pattern wallpaper1",type:"wall",className:"house"},
		"retrowallpaper2":{price:3,label:"Retro pattern wallpaper2",type:"wall",className:"house"},
		"rockingchair":{price:3,label:"rocking chair",type:"standard",className:"furniture"},
		"rosebush":{price:3,label:"rose bush (outdoor)",type:"standard",className:"accessories"},
		"sandfloor":{price:3,label:"sand floor",type:"floor",className:"house"},
		"kitchensink":{price:3,label:"sink",type:"standard",className:"furniture"},
		"skywall":{price:3,label:"Sky wall (outdoor)",type:"wall",className:"house"},
		"smallfishpond":{price:3,label:"small fish pond",type:"standard",className:"accessories"},
		"squirrel":{price:3,label:"squirrel",type:"standard",className:"animals"},
		"stonebench":{price:3,label:"stone bench",type:"standard",className:"furniture"},
		"stove":{price:3,label:"stove",type:"standard",className:"furniture"},
		"toaster":{price:3,label:"toaster",type:"standard",className:"accessories"},
		"wardrobe":{price:3,label:"wardrobe with clothes hanging",type:"standard",className:"furniture"},
		"whitewalltile":{price:3,label:"White tile wall",type:"wall",className:"house"},
		"xbox4":{price:3,label:"Xbox4 Console",type:"standard",className:"accessories"}
		//"xmaslights":{price:3,label:"Holiday lights",type:"standard", className:"accessories"}
	};

	var inventory = [];
	var available = [];
	var zindex = 1000;
	var scroll = 0;
	var room = 1;
	var dropindex = 1;

	var rooms = ["room-1"];

	var timeout,activity;

	self.account = 0;

	self.updateAccount = function(amount)
	{
		self.account += amount;
		$("#header-hut").html(self.account + " coins");

		if(amount > 0)
		{
			update();
		}

		$(".shop-item").each(function(index){
			var itemPrice = parseInt($(this).find("p.price").text());
			if(itemPrice > self.account) $(this).addClass("disabled");
			else $(this).removeClass("disabled");
		});
	}

	function onApplicationUpdate(pType,pData)
	{
		self.updateAccount(0);
		if(pType == "activities-retrieved") 
		{
			activity = quest.activityManager.getActivity("MYHUT","any");
			if(!activity) return;
			
			if(quest.settings.role === "teacher" && activity.data.account < 100) self.account = 500; 
			else self.account = activity.data.account;
			self.updateAccount(0);
			configure();
		}
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.HUT_PAGE && !configured) configure();
	}

	function configure()
	{
		$("#hut").find("div#hut-avatar").removeClass(function (index, css) { return (css.match (/\bavatar-\S+/g) || []).join(' ');});
		$("#hut").find("div#hut-mate").removeClass(function (index, css) { return (css.match (/\bmate-\S+/g) || []).join(' ');})
		$("#hut").find("div#hut-avatar").addClass(quest.settings.avatar);
		$("#hut").find("div#hut-mate").addClass(quest.settings.mate);
		if(configured) return;
		configured = true;

		//Todo, fetch storage
		var count = 0;
		for(var item in source)
		{
			var object = source[item];
			object.id = item;
			available.push({id:item,price:object.price,label:object.label,className:object.className, index:count});
			count ++;
		}

		available.sort(function(a,b){
			if(a.price > b.price) return 1;
			if(a.price < b.price) return -1;
			if(a.id > b.id) return 1;
			if(a.id < b.id) return -1;
			return 0;

		});

		var shopHTML = "";
		for(var i = 0, count = available.length; i < count; i++)
		{
			var item = available[i];
			shopHTML += "<li id='shop-"+item.id+"' role='button' tabindex='0' data-item='"+item.id+"' class='shop-item large-"+item.id+" "+item.className+"'><span class='label'>"+item.label+"</span><p class='price'>"+item.price+"</p></li>";
		}
		$("#hut-shop-list").html(shopHTML);
		$("#hut-shop-list").attr("class","animals");
		$("#hut-shop-tabs").find("a").on("click",setTab);

		$("#hut-shop-list").find("li.animals").eq(0).addClass("first");
		$("#hut-shop-list").find("li.accessories").eq(0).addClass("first");
		$("#hut-shop-list").find("li.furniture").eq(0).addClass("first");
		$("#hut-shop-list").find("li.house").eq(0).addClass("first");
		$("#hut-shop-list").find("li.transportation").eq(0).addClass("first");
		$("#hut-shop-list").find("li.windows").eq(0).addClass("first");


		activity = quest.activityManager.getActivity("MYHUT","any");

		$(".shop-item").click(onPurchaseAttempt);
		$(".shop-item").on("keyup",function(event){if(event.keyCode == 13) onPurchaseAttempt(null,source[$(this).attr("data-item")]);});
		
		$("#hut-workspace").droppable({accept:".inventory-item",drop:function(event,ui){
			var item = ui.draggable.attr("data-item");
			var html = "<div id='placed-"+item+"-"+dropindex+"' data-item='"+item+"' class='placed "+item+"'><span class='label'>"+source[item].label+"</span></div>";
			var offset = ui.draggable.offset();
			var x = offset.left - $(this).offset().left;
			var y = offset.top - $(this).offset().top;
			var wall = source[item].type == "wall";
			var floor = source[item].type == "floor";


			ui.draggable.remove();
			if($(".placed:not(.static)").length) $(".placed:not(.static)").draggable("destroy");
			$(this).append(html);
			
			if(floor || wall)
			{
				$(".placed.static."+(wall ? "wall":"floor")+".room-"+room).each(function(index){
					var item = source[$(this).attr("data-item")];
					$(this).remove();

					if($(".inventory-item").length) $(".inventory-item").draggable("destroy");

					var html = "<li id='inventory-"+item.id+"' role='button' tabindex='0' data-item='"+item.id+"' data-type='"+item.type+"' class='inventory-item small-"+item.id+"'><span class='label'>"+item.label+"</span></li>";
					$("#hut-inventory-list").append(html);
					$(".inventory-item").draggable({revert:"invalid",drag:function(event,ui){zindex++; $(this).css("z-index",zindex);}});
				});

				$("#placed-"+item+"-"+dropindex).css("left","3px").css("top",wall ? "3px":"346px").css("z-index",1).addClass("room-"+room).addClass(wall ? "wall":"floor").addClass("static").attr("data-room",room);
			}
			else
			{
				zindex ++;
				$("#placed-"+item+"-"+dropindex).css("left",x).css("top",y).css("z-index",zindex).addClass("room-"+room).attr("data-room",room);
			}
			$(".placed:not(.static)").draggable({containment:"parent",drag:function(){zindex++; $(this).css("z-index",zindex);}, stop:function(){update();}});
		
			
			dropindex ++;


			update();
		}});

		$("#hut-inventory").droppable({accept:".placed",tolerance:"touch",drop:function(event,ui){
			var item = source[ui.draggable.attr("data-item")];
			ui.draggable.remove();

			if($(".inventory-item").length) $(".inventory-item").draggable("destroy");

			var html = "<li id='inventory-"+item.id+"' role='button' tabindex='0' data-item='"+item.id+"' data-type='"+item.type+"' class='inventory-item small-"+item.id+"'><span class='label'>"+item.label+"</span></li>";
			$("#hut-inventory-list").append(html);
			$(".inventory-item").draggable({revert:"invalid",drag:function(event,ui){zindex++; $(this).css("z-index",zindex);}});

			update();
		}});

		$(".hut-shop-scroll").click(onShopScroll);
		$(".hut-inventory-scroll").click(onInventoryScroll);
		$("#header-hut").html(self.account + " coins");
		$(".room").click(onRoomSelect);
		$(".room:gt(0)").addClass("inactive");

		if(activity) rebuild();

		$("#hut-button-no").click(function(event){$("#hut-confirm").hide()})
	}

	function setTab(event)
	{
		var type = $(this).data("tab");
		$("#hut-shop-tabs").find("a").removeClass("selected");
		$("#hut-shop-list").attr("class",type);
		$("#hut-shop-list").scrollTo("0px");
		$(this).addClass("selected");
	}

	function rebuild()
	{
		trace("rebuilding",quest.settings.role);

		if(quest.settings.role === "teacher" && activity.data.account < 100) self.account = 500; 
		else self.account = activity.data.account;

		dropindex = activity.data.dropindex;
		zindex = Math.max(1,activity.data.zindex);
		rooms = activity.data.rooms;

		for(var i = 0, count = activity.data.inventory.length; i < count; i++)
		{
			var item = source[activity.data.inventory[i].item];
			var html = "<li id='inventory-"+item.id+"' role='button' tabindex='0' data-item='"+item.id+"' data-type='"+item.type+"' class='inventory-item small-"+item.id+"'><span class='label'>"+item.label+"</span></li>";
			$("#hut-inventory-list").append(html);
			
		}

		for(var j = 0, count = activity.data.workspace.length; j < count; j++)
		{
			var data = activity.data.workspace[j];
			var item = source[data.item];
			var wall = item.type == "wall";
			var floor = item.type == "floor";
			var html = "<div id='"+data.id+"' data-item='"+item.id+"' class='placed "+item.id+"'><span class='label'>"+item.label+"</span></div>";
			$("#hut-workspace").append(html);

			$("#"+data.id).css("left",data.left).css("top",data.top).css("z-index",data.zindex).addClass("room-"+data.room).attr("data-room",data.room);
			if(wall || floor) $("#"+data.id).addClass("static").addClass(wall ? "wall":"floor");
		}

		for(var k =0, count = rooms.length; k < count; k++)
		{
			var room = rooms[k];
			$("#"+room).removeClass("locked");
		}


		$(".placed:not(.static)").draggable({containment:"parent",drag:function(){zindex++; $(this).css("z-index",zindex);}, stop:function(){update();}});
		$(".inventory-item").draggable({revert:"invalid",drag:function(event,ui){zindex++; $(this).css("z-index",zindex);}});

		updateAccount(0);
	}

	function onRoomSelect(event)
	{
		if($(this).hasClass("locked"))
		{
			var hut = $(this);
			if(self.account < 10) return alert("You must have at least 10 coins to purchase a new room.");
			$("#hut-item-label").html("A new hut");
			$("#hut-item-cost").html("10 coins.");
			$("#hut-confirm").show().find("a#hut-button-yes").unbind("click.purchase").bind("click.purchase",function(event){
				executePurchase("hut",hut);
				$("#hut-confirm").hide();
			});
			return;
		}
		$(".room").addClass("inactive");
		$(this).removeClass("inactive");
		room = parseInt($(this).attr("data-room"));
		$("#hut-workspace").removeClass("room-1 room-2 room-3 room-4").addClass("room-"+room);
	}

	function onShopScroll(event)
	{
		var up = $(this).attr("id") == "hut-shop-scroll-up";
		if(up)
		{
			$("#hut-shop-list").scrollTo("-=168px");
		}
		else
		{
			$("#hut-shop-list").scrollTo("+=168px");
		}
	}

	function onInventoryScroll(event)
	{
		var left = $(this).attr("id") == "hut-inventory-scroll-left";
		if(left)
		{
			if(scroll > 0) scroll --;
		}
		else
		{
			if(scroll < $("#hut-inventory-list").find("li").length - 1) scroll ++;
		}

			$("#hut-inventory-list").find("li:lt("+scroll+")").hide();
			$("#hut-inventory-list").find("li:eq("+scroll+")").show();
			$("#hut-inventory-list").find("li:gt("+scroll+")").show();
	}

	function onPurchaseAttempt(event,item)
	{
		var item = item || source[$(this).attr("data-item")];
		$("#hut-item-label").html(item.label);
		$("#hut-item-cost").html(item.price + (parseInt(item.price) == 1 ? " coin": " coins"));
		$("#hut-confirm").show().find("a#hut-button-yes").unbind("click.purchase").bind("click.purchase",function(event){
			executePurchase(item);
			$("#hut-confirm").hide();
		});
	}
	function executePurchase(item,hut)
	{


		if(item == "hut")
		{
			rooms.push(hut.attr("id"));
			hut.removeClass("locked");
			hut.click();
			updateAccount(parseFloat(10));
			update();
			return;
		}

		if($(".inventory-item").length) $(".inventory-item").draggable("destroy");

		var html = "<li id='inventory-"+item.id+"-"+dropindex+"' role='button' tabindex='0' data-item='"+item.id+"' data-type='"+item.type+"' class='inventory-item small-"+item.id+"'><span class='label'>"+item.label+"</span></li>";
		$("#hut-inventory-list").append(html);
		$(".inventory-item").draggable({revert:"invalid"});
		dropindex ++;

		updateAccount(parseFloat(item.price));
		update();
	}

	function updateAccount(price)
	{
		self.account -= price;
		if(self.account < 0) self.account = 0;

		$(".shop-item").each(function(index){
			var itemPrice = parseInt($(this).find("p.price").text());
			if(itemPrice > self.account) $(this).addClass("disabled");
			else $(this).removeClass("disabled");
		});

		$("#header-hut").html(self.account + "coins");
	}

	function update()
	{
		var data = {inventory:[],workspace:[], rooms:rooms,account:self.account,dropindex:dropindex,zindex:zindex};
		var workspace = $("#hut-workspace");
		var inventory = $("#hut-inventory");

		if(!activity) activity = {type:"MYHUT",page:"any",data:data};

		workspace.find("div.placed").each(function(index){
			var placed = {id:$(this).attr("id"),top:$(this).css("top"),left:$(this).css("left"),zindex: $(this).css("z-index"),item:$(this).attr("data-item"),room:$(this).attr("data-room")};
			data.workspace.push(placed);
		});

		inventory.find("li.inventory-item").each(function(index){
			var item = {id:$(this).attr("id"),item:$(this).attr("data-item"), index:index};
			data.inventory.push(item);
		});
		activity.data = data;

		quest.activityManager.saveActivity(activity,function(result){activity = result;});
	}


	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.hut = quest.hut || {}))

quest.survey = (function(quest,self){
	
	var trace 			= quest.trace;
	var currentPage		= null;
	var ready 			= false;
	var source			= null;
	var surveys 		= {};
	var currentQuestion	= 0;
	var currentSurvey 	= null;
	var currentID 		= null;
	var currentSurveyIndex = 0;

	self.totalSurveysComplete = 0;


	self.surveyComplete = 0;
	
	function onApplicationUpdate(pType,pData)
	{
		$("html").addClass("surveys-complete")
		return;
		if(pType == "login") initialize(pData);
		if(pType == quest.PAGE_LOAD) configure(pData);
	}
	
	function initialize(pData)
	{
		$.ajax({url:'php/surveys.php',type:'POST',data:{request:"fetch" },dataType:'json',success:surveyHandler,error:errorHandler});
	}
	
	function configure(pData)
	{
		return;
	 	currentPage = pData.display;
	 	currentID = currentPage.attr("id");
	 	if(ready) buildSurvey();	
	}

	function surveyHandler(result)
	{
		return;
		source = result;

		var noActiveSurveys = false;
		self.totalSurveysComplete = 0;

		trace("report",result);


		for(var i = 0, count = source.length; i < count; i++)
		{
			var survey = source[i];
			surveys[survey.id] = {name:survey.name,id:survey.id, customClass:survey.customClass, description:survey.description, questions:[],currentQuestion:null};

			var questions = survey.questions;
			var responses = survey.responses;
			var currentQuestion;

			if(survey.surveyComplete == "true") 
			{
				self.surveyComplete = true;
				self.totalSurveysComplete ++;
			}

			if(survey.activeAttempt === 0)
			{
				self.noActiveSurveys = noActiveSurveys = true;
				break;
			}

			for(var j = 0, questionCount = questions.length; j < questionCount; j++)
			{
				var question = questions[j];
				if(!currentQuestion || currentQuestion.questionID != question.questionID) 
				{
					currentQuestion = {questionID:question.questionID, audio:question.audio, categoryAudio:question.categoryAudio || "", questionText:question.questionText, categoryName: question.categoryName, customClass: question.customClass, answers:[]};
					if(responses["question-"+currentQuestion.questionID]) currentQuestion.response = responses["question-"+currentQuestion.questionID].answer;
					if(responses["question-"+currentQuestion.questionID] && (survey.lastQuestions[survey.id.toString()] == question.sortIndex)) 
					{
						surveys[survey.id].isComplete = true;
					}
					
					surveys[survey.id].questions.push(currentQuestion);
				}
				var answer = {id: question.answerID, answerText: question.answerText, audio: question.answerAudio, index: question.answerIndex};
				currentQuestion.answers.push(answer);
			}

			currentQuestion = null;
		}
		if(self.surveyComplete || noActiveSurveys) $(".survey-screen").addClass("all-complete");
		if(self.totalSurveysComplete === 4 || noActiveSurveys) $("html").addClass("surveys-complete");
		if(currentPage && !noActiveSurveys) buildSurvey();
		ready = true;
	}

	function buildSurvey(id,multi,multiIndex)
	{
		if(!currentPage.attr("data-survey")) return $("#quest-container").removeClass("survey-visible");
		if(currentPage.attr("data-survey-rendered")) 
		{
			var ss = currentPage.attr("data-survey").split(",");
			if(ss.length > 1)
			{
				id = ss[0];
				if(!currentPage.find(".survey-screen").eq(0).hasClass("complete") || !currentPage.find(".survey-screen").eq(1).hasClass("complete"))
				{
					currentPage.find(".survey-screen").eq(0).show();
					currentPage.find(".survey-button").css("display","block");
				} 
			}
			var survey = surveys[id || currentPage.attr("data-survey")];
			currentPage.find(".survey-screen").addClass("launch");
			$("#quest-container").removeClass("survey-visible");

			if(!survey) return;
			currentSurvey = survey;
			currentQuestion = survey.currentQuestion;
			currentSurveyIndex = 0;
			return;
		}

		if(!id)
		{
			var ids = currentPage.attr("data-survey").split(",");
			for(var i = 0, count = ids.length; i < count; i++)
			{
				buildSurvey(ids[i],ids.length > 1,i);
			}
			currentPage.find(".survey-screen:not(:eq(0))").hide();
			currentPage.attr("data-survey-rendered","true");
			var isComplete = true;
			currentPage.find(".survey-screen").each(function(index){
				if($(this).hasClass("complete")) currentPage.find("span.group").eq(index).addClass("complete").find("a").html("Complete");
				else isComplete = false;

				if(parseInt($(this).attr("data-last-selected-index")) > 0 && !$(this).hasClass("complete"))
				{
					currentPage.find("span.group").eq(index).removeClass("complete").find("a").html("Resume");
				}
				else if(!$(this).hasClass("complete"))
				{
					currentPage.find("span.group").eq(index).find("a").html("Start");
				}
			});

			if(isComplete) $("div.survey-screen").hide();
			$("#quest-container").removeClass("survey-visible");
			return;
		}
		var survey = surveys[id || currentPage.attr("data-survey")];
		if(!survey) 
		{
			self.totalSurveysComplete = 4;
			self.surveyComplete = true;
			$("#quest-container").removeClass("survey-visible");
			return;
		}

		var questions = survey.questions;
		var container =$("<div class='survey-screen launch "+(multi?'multi':'')+"'/>");
		var header = $("<h1 class='survey-header' aria-live='assertive' aria-atomic='false' aria-relevant='text additions'></h1>");
		var html = $("<div class='survey-container'/>");
		var form = $("<form action='javascript:void(0)' class='survey'/>");
		var indicator = $("<div class='indicator'/>");
		var lastSelectedIndex = 0;
		var complete = true;


		container.append(header);
		container.append($("<audio class='survey-audio' preload><source type='audio/mp3' src='' /><source type='audio/ogg' src='' /></audio>"))

		for(var i = 0, count = questions.length; i < count; i++)
		{
			var question = questions[i];
			var category = questions.categoryName;
			var answers  = question.answers;
			var questionText = question.questionText;
			var questionID = question.questionID;
			var selection = question.response;
			if(!question.audio) question.audio = "";


			if(!selection) complete = false;
			

			if(selection) lastSelectedIndex = i+1;

			
			form.append("<fieldset id='survey-fieldset-"+questionID+"' data-question-id='"+questionID+"' class='"+question.customClass+" answers-"+(answers.length)+"'/>");
			form.find("#survey-fieldset-"+questionID).append("<legend> <a class='audio' data-audio='"+question.audio.replace(/\.mp3/gim,"")+"' href='javascript:void(0)'>Listen to question</a> "+questionText+" </legend>");
			form.find("#survey-fieldset-"+questionID).append("<div class='row-container'/>");
			indicator.append("<span class='indicator'/>");

			for(var j = 0, answerCount = answers.length; j < answerCount; j++)
			{
				var answer = answers[j];
				var answerText = answer.answerText;
				var answerID = answer.id;
				var answerIndex = answer.index;
				if(!answer.audio) answer.audio = "";
				var answerAudio = answer.audio.replace(/\.mp3/gim,"").replace(/\s+/gim,"");
				var selected = selection == answerID;
				var unique = "question-" + questionID + "-answer-" + answerID;
				form.find("#survey-fieldset-"+questionID).find(".row-container").append("<div data-audio='"+answerAudio+"' class='formrow answer-choice answer-"+j+"'><input id='"+unique+"' name='question-"+questionID+"' type='radio' value='"+answerID+"' "+(selected?"checked='checked'":"")+"/><label class='answer-"+j+"' for='"+unique+"'>"+answerText+"</label></div>");
			}
			html.append(form);
		}

		if(survey.isComplete) complete = true;

		form.find("a.audio").click(function(){
			if(quest.audio.muted) return;
			container.find("audio.survey-audio").find("source").eq(0).attr("src","audio/"+$(this).data("audio") + ".mp3");
			container.find("audio.survey-audio").find("source").eq(1).attr("src","audio/"+$(this).data("audio") + ".ogg");
			container.find("audio.survey-audio").get(0).load();
			container.find("audio.survey-audio").get(0).play();
		});

		form.find("input[type=radio]").on("change",function(){
			if(quest.audio.muted) return;
			container.find("audio.survey-audio").find("source").eq(0).attr("src","audio/"+$(this).closest(".answer-choice").data("audio") + ".mp3");
			container.find("audio.survey-audio").find("source").eq(1).attr("src","audio/"+$(this).closest(".answer-choice").data("audio") + ".ogg");
			container.find("audio.survey-audio").get(0).load();
			container.find("audio.survey-audio").get(0).play();
		});

		if(!id) currentPage.attr("data-survey-rendered","true");
		if(complete && !multi) 
		{
			return lastSelectedIndex;
		}
		if(complete || quest.login.username == "guest") container.addClass("complete");

		var prompt = $("<div class='survey-prompt'/>");
		prompt.append("<h2>Welcome!</h2>");

		container.attr("data-last-selected-index",lastSelectedIndex);

		if(!multi) prompt.append("<p>Before you can explore <span class='location'>"+fetchCurrentLocation()+"</span> <br/> you must complete this survey. Every survey you take is worth 10 coins which can be used to buy decorations for your hut.  It also allows you to further explore the location. <a class='survey-prompt-button' role='button' href='javascript:void(0)'>"+(lastSelectedIndex > 0 ? "Resume":"Start")+"</a> <span class='survey-prompt-instructions'>Click here to "+(lastSelectedIndex > 0 ? "resume":"start")+" the survey</span></p>");
		else prompt.append("<p>Before you can explore <span class='location'>"+fetchCurrentLocation()+"</span> <br/> you must complete these surveys. Every survey you take is worth 10 coins which can be used to buy decorations for your hut.  It also allows you to further explore the location. <br/><span class='group'><a class='survey-prompt-button' role='button' href='javascript:void(0)'>"+(lastSelectedIndex > 0 ? "Resume":"Start")+"</a> <span class='survey-prompt-instructions'>Click here to "+(lastSelectedIndex > 0 ? "resume":"start")+" survey 1</span></span> <span class='group'><a class='survey-prompt-button' role='button' href='javascript:void(0)'>"+(lastSelectedIndex > 0 ? "Resume":"Start")+"</a> <span class='survey-prompt-instructions'>Click here to "+(lastSelectedIndex > 0 ? "resume":"start")+" survey 2</span></span></p>");

		survey.currentQuestion = currentQuestion = lastSelectedIndex;
		currentSurvey = survey;
		container.append(html);

		currentSurvey.lastSelectedIndex = lastSelectedIndex;


		var progress = $("<div class='survey-progress-container'> <h3>SURVEY PROGRESS</h3> <div class='survey-progress-background'> <div class='survey-progress-foreground'/></div> </div>");
		container.append(progress);
		form.append("<a class='survey-button' role='button' href='javascript:void(0)'>Next</a>");
		

		currentPage.append(container);
		currentPage.find("fieldset:not(:eq("+lastSelectedIndex+"))").hide();
		currentPage.find("a.survey-button").unbind("click",onNextQuestion).bind("click",onNextQuestion).off("keydown.next").on("keydown.next",function(e){
			e.preventDefault();
			if(e.keyCode == 32) onNextQuestion();
		});

		if(!multi || (multi && multiIndex == 0))
		{
			container.append(prompt);
			container.find("a.survey-prompt-button").eq(0).click(function(){
				container.removeClass("launch");
				if(multi) currentPage.find("div.survey-screen").eq(1).hide();
				if(multi) currentSurvey = surveys[id]; 
				if(multi) currentQuestion = currentSurvey.lastSelectedIndex;
				if(multi) container.show();
				if(multi) currentPage.find("div.survey-screen").eq(0).find("fieldset:not(:eq("+currentQuestion+"))").ariaHide();
				if(multi) currentPage.find("div.survey-screen").eq(0).find("fieldset:eq("+currentQuestion+")").ariaShow().attr("tabindex","-1").focus();
				else currentPage.find("fieldset:eq("+currentQuestion+")").attr("tabindex","-1").focus();

				currentPage.find("div.survey-screen").eq(0).find(".survey-progress-foreground").css("width",Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
				currentPage.find(".survey-progress-container").find("h3").html("SURVEY PROGRESS: " + Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
		
				currentSurveyIndex = 0;
			})
			container.find("a.survey-prompt-button").eq(1).click(function(){
				container.hide(); currentPage.find("div.survey-screen").eq(1).removeClass("launch").show();
				currentSurvey = surveys["3"]; 
				currentQuestion = currentSurvey.lastSelectedIndex;
				currentPage.find("div.survey-screen").eq(1).find("fieldset:not(:eq("+currentQuestion+"))").ariaHide();
				currentPage.find("div.survey-screen").eq(1).find("fieldset:eq("+currentQuestion+")").ariaShow();
				currentPage.find("div.survey-screen").eq(0).find(".survey-progress-foreground").css("width",Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
				currentPage.find(".survey-progress-container").find("h3").html("SURVEY PROGRESS: " + Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
				currentSurveyIndex = 1;
			})
		}
		else
		{
			container.find("a.survey-prompt-button").click(function(){

				container.find("fieldset").eq(0).attr("tabindex","-1").focus();
				container.removeClass("launch")});
			currentPage.find(".survey-progress-foreground").css("width",Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
			currentPage.find(".survey-progress-container").find("h3").html("SURVEY PROGRESS: " + Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
		
		}

		currentPage.find(".survey-prompt").attr("tabindex","-1").focus();

		
		if(currentSurvey.questions[currentQuestion]) 
		{
			form.attr("class","survey " + currentSurvey.questions[currentQuestion].customClass + " answers-" + currentSurvey.questions[currentQuestion].length);
		}


		//$("span.indicator").removeClass("active").eq(currentQuestion).addClass("active");
		if(currentSurvey.questions[lastSelectedIndex]) 
		{
			var headerHtml = "<a class='audio' data-audio='"+currentSurvey.questions[lastSelectedIndex].categoryAudio.replace(/\.mp3/gim,"")+"' href='javascript:void(0)'>Listen to header instructions</a><span>"+currentSurvey.questions[lastSelectedIndex].categoryName+"</span>";
			header.html(headerHtml);
			header.find("a").click(function(){
				if(quest.audio.muted) return;
				container.find("audio.survey-audio").find("source").eq(0).attr("src","audio/"+$(this).data("audio") + ".mp3");
				container.find("audio.survey-audio").find("source").eq(1).attr("src","audio/"+$(this).data("audio") + ".ogg");
				container.find("audio.survey-audio").get(0).load();
				container.find("audio.survey-audio").get(0).play();
			});
		}

		$("html").addClass("survey-visible");
		return lastSelectedIndex;
	}

	function fetchCurrentLocation()
	{
		switch(currentID)
		{
			case "mountain":
				return "About Me Mountain";
			break;
			case "cove":
				return "College and Career Cove";
			break;
			case "sanctuary":
				return "Social Sanctuary";
			default:
		}
		return "";
	}

	function onNextQuestion(event)
	{
		var forms = currentPage.find("div.survey-screen").eq(currentSurveyIndex).find("form.survey").find("fieldset");
		var numQuestions = forms.length;
		var currentForm = forms.eq(currentSurvey.currentQuestion);
		if(!currentForm.find("input:checked").length) return;
		currentForm.animate({opacity:0.5}).find("input").attr("disabled","true");
		submitQuestion(currentForm);
	}

	var submitting  = false;
	function submitQuestion(form)
	{
		var question = parseInt(form.attr("data-question-id"));
		var answer = form.find("input:checked")[0].value;
		if(submitting) return;
		submitting = true;
		currentPage.find("a.survey-button").hide();
		$.ajax({url:'php/surveys.php',type:'POST',data:{request:"save",question:question,answer:answer},dataType:'json',success:questionHandler,error:errorHandler});
	}

	function questionHandler(result)
	{
		var forms = currentPage.find("div.survey-screen").eq(currentSurveyIndex).find("form.survey").find("fieldset");
		var numQuestions = forms.length;
		var currentForm = forms.eq(currentSurvey.currentQuestion);
		submitting = false;
		if(!currentForm.find("input:checked").length) return;

		currentPage.find("a.survey-button").show().css("display","block");
		currentForm.hide();

		if(currentQuestion < numQuestions - 1)
		{
			currentQuestion ++;
			currentSurvey.lastSelectedIndex = currentQuestion;
			currentSurvey.currentQuestion = currentQuestion;
			forms.eq(currentQuestion).ariaShow().attr("tabindex","-1").focus();
			//$("span.indicator").removeClass("active").eq(currentQuestion).addClass("active");
			currentPage.find("div.survey-screen").eq(currentSurveyIndex).find(".survey-progress-foreground").css("width",Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
			currentPage.find(".survey-progress-container").find("h3").html("SURVEY PROGRESS: " + Math.round((currentQuestion)*100/currentSurvey.questions.length)+"%");
			var headerHtml = "<a class='audio' data-audio='"+currentSurvey.questions[currentQuestion].categoryAudio.replace(/\.mp3/gim,"")+"' href='javascript:void(0)'>Listen to header instructions</a><span>"+currentSurvey.questions[currentQuestion].categoryName+"</span>";
			currentPage.find(".survey-header").html(headerHtml);
			currentPage.find(".survey-header").find("a").click(function(){
				if(quest.audio.muted) return;
				var container = currentPage.find("div.survey-screen");
				container.find("audio.survey-audio").find("source").eq(0).attr("src","audio/"+$(this).data("audio") + ".mp3");
				container.find("audio.survey-audio").find("source").eq(1).attr("src","audio/"+$(this).data("audio") + ".ogg");
				container.find("audio.survey-audio").get(0).load();
				container.find("audio.survey-audio").get(0).play();
			});

			if(currentSurvey.questions[currentQuestion]) currentForm.closest("form").attr("class","survey " + currentSurvey.questions[currentQuestion].customClass);
		}
		else
		{
			currentPage.find("div.survey-screen").eq(currentSurveyIndex).addClass("complete");
			currentPage.find(".survey-screen").each(function(index){
				if($(this).hasClass("complete")) currentPage.find("span.group").eq(index).addClass("complete").find("a").html("Complete");
			});
			if(currentPage.find(".survey-screen.complete").length < currentPage.find(".survey-screen").length)
			{
				forms.closest(".survey-screen").hide()
				$("div.survey-prompt").show().closest(".survey-screen").addClass("launch").show();
			}
			else
			{
				forms.closest(".survey-screen").hide();
				$("html").removeClass("survey-visible");
			}

			quest.hut.updateAccount(10);
			currentPage.find(".survey-screen:not(.complete)").show();
		}


		if(result.surveyComplete == "true") 
		{
			self.totalSurveysComplete ++;
			$("html").addClass("surveys-complete");
			self.surveyComplete = true;
			$(".survey-screen").addClass("all-complete");
		}
	}


	function errorHandler(error)
	{
		trace("error",arguments);
		quest.showAlert("shutdown");
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
	
}(quest,quest.survey = quest.survey || {}));
quest.collage = (function(quest,self){
	
	var trace 			= quest.trace;
	var currentPage		= null;
	var container 		= null;
	var wordlist		= [];
	var canvas			= null;
	var constructor		= null;

	var palettes		= [];
	var currentPalette  = null;
	var configured		= false;

	var currentFontIndex = 1;
	var currentPaletteIndex = 1;
	var currentColorIndex = 0;
	var currentShapeIndex = 0;
	var saved = false;
	var generic = "false";
	var saveAsGeneric = false;
	var savedScreenValue;
	var forceNonGeneric = false;

	self.requestedCollage = null;
	self.location = null;
	self.spawnGeneric = false;

	var gradients = { "purple-gradient":"background: rgb(143,100,238); background: -moz-linear-gradient(top, rgba(143,100,238,1) 0%, rgba(198,115,245,1) 100%); background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(143,100,238,1)), color-stop(100%,rgba(198,115,245,1))); background: -webkit-linear-gradient(top, rgba(143,100,238,1) 0%,rgba(198,115,245,1) 100%); background: -o-linear-gradient(top, rgba(143,100,238,1) 0%,rgba(198,115,245,1) 100%); background: -ms-linear-gradient(top, rgba(143,100,238,1) 0%,rgba(198,115,245,1) 100%); background: linear-gradient(to bottom, rgba(143,100,238,1) 0%,rgba(198,115,245,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8f64ee', endColorstr='#c673f5',GradientType=0 );", 
						"blue-gradient":"background: rgb(122,180,217); background: -moz-linear-gradient(top, rgba(122,180,217,1) 0%, rgba(155,236,228,1) 100%); background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(122,180,217,1)), color-stop(100%,rgba(155,236,228,1))); background: -webkit-linear-gradient(top, rgba(122,180,217,1) 0%,rgba(155,236,228,1) 100%); background: -o-linear-gradient(top, rgba(122,180,217,1) 0%,rgba(155,236,228,1) 100%); background: -ms-linear-gradient(top, rgba(122,180,217,1) 0%,rgba(155,236,228,1) 100%); background: linear-gradient(to bottom, rgba(122,180,217,1) 0%,rgba(155,236,228,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7ab4d9', endColorstr='#9bece4',GradientType=0 );",
						"green-gradient":"background: rgb(193,228,132); background: -moz-linear-gradient(top, rgba(193,228,132,1) 0%, rgba(237,246,161,1) 100%); background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(193,228,132,1)), color-stop(100%,rgba(237,246,161,1))); background: -webkit-linear-gradient(top, rgba(193,228,132,1) 0%,rgba(237,246,161,1) 100%); background: -o-linear-gradient(top, rgba(193,228,132,1) 0%,rgba(237,246,161,1) 100%); background: -ms-linear-gradient(top, rgba(193,228,132,1) 0%,rgba(237,246,161,1) 100%); background: linear-gradient(to bottom, rgba(193,228,132,1) 0%,rgba(237,246,161,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#c1e484', endColorstr='#edf6a1',GradientType=0 );",
						"orange-gradient":"background: rgb(221,148,37); background: -moz-linear-gradient(top, rgba(221,148,37,1) 0%, rgba(178,87,21,1) 100%); background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(221,148,37,1)), color-stop(100%,rgba(178,87,21,1))); background: -webkit-linear-gradient(top, rgba(221,148,37,1) 0%,rgba(178,87,21,1) 100%); background: -o-linear-gradient(top, rgba(221,148,37,1) 0%,rgba(178,87,21,1) 100%); background: -ms-linear-gradient(top, rgba(221,148,37,1) 0%,rgba(178,87,21,1) 100%); background: linear-gradient(to bottom, rgba(221,148,37,1) 0%,rgba(178,87,21,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dd9425', endColorstr='#b25715',GradientType=0 );",
						"red-gradient":"background: rgb(231,84,59); background: -moz-linear-gradient(top, rgba(231,84,59,1) 0%, rgba(63,61,132,1) 100%); background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(231,84,59,1)), color-stop(100%,rgba(63,61,132,1))); background: -webkit-linear-gradient(top, rgba(231,84,59,1) 0%,rgba(63,61,132,1) 100%); background: -o-linear-gradient(top, rgba(231,84,59,1) 0%,rgba(63,61,132,1) 100%); background: -ms-linear-gradient(top, rgba(231,84,59,1) 0%,rgba(63,61,132,1) 100%); background: linear-gradient(to bottom, rgba(231,84,59,1) 0%,rgba(63,61,132,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e7543b', endColorstr='#3f3d84',GradientType=0 );"};

	var patterns = {"green-pattern":"background: url(images/collage/green.png) repeat;",
						"blue-pattern":"background: url(images/collage/blue.png) repeat;",
						"red-pattern":"background: url(images/collage/orange.png) repeat;",
						"purple-pattern":"background: url(images/collage/red.png) repeat;"};

	self.regenerate = function(id,data)
	{
		savedScreenValue = null;
		self.requestedCollage = id;
		constructor = quest.fetchConstructor("collage");
		configure({collage:JSON.stringify(data)});
		return container.html();
	}					

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.COLLAGE_PAGE) load(pData);
	}

	function load(pData)
	{
		constructor = pData.content;
		if(!self.requestedCollage) return quest.loadScreen("map");
		savedScreenValue = null;
		$("#debugger").html("<b>ID:</b> " + self.requestedCollage);
		$.ajax({url:'php/collage.php',type:'POST',data:{request:"fetch", screen:self.requestedCollage ? self.requestedCollage : "temp", location: self.location }, dataType:'json',success:configure,error:errorHandler});
	}

	function playAudioPrompt() {
		quest.audio.playClip("audio/"+self.requestedCollage+"-text");
	}

	function playAudioTitle() {
		quest.audio.playClip("audio/"+self.requestedCollage+"-title");
	}
	
	function configure(pData)
	{
		if(!configured) {
			$("#collage").find(".global-audio-button.prompt").click(playAudioPrompt);
			$("#collage").find(".global-audio-button.title").click(playAudioTitle);
		}
		forceNonGeneric = false;
		saveAsGeneric = false;

		saved = pData.collage ? JSON.parse(pData.collage) : null;
		if(saved) savedScreenValue = pData.screen;

		container = $("#collage");


		if(self.spawnGeneric) 
		{
			saved = null;
			generic = "true";
			saveAsGeneric = true;
			container.find("#collage-title").find("input").attr("disabled",null);
		}
		else
		{
			generic = "false";
			container.find("#collage-title").find("input").attr("disabled","true").attr("placeholder","");
		}

		self.spawnGeneric = false;
		title = "Thought Collage";//self.requestedTitle || "";

		var images = quest.settings.images[self.requestedCollage];
		container.find(".image-selection").find("a.toggle").off("click.toggle");
		container.find(".image-items a").off("click.images");
		container.find("a.submit").off("click.images");
		container.find("a.cancel").off("click.images")

		container.find(".image-selection").find("a.toggle").off("click.toggle");
		
		if(images)
		{
			var html = "";
			images.forEach(function(image){
				html += "<li><a data-prompt='"+image.text+"' href='javascript:void(0)'><span class='image-container'><img src='images/support/"+image.image+".png' alt='"+image.text+"'/></span><span class='label'>"+image.text+"</span></a></li>";
			});
			container.find(".image-items").html($(html));
			container.find(".image-selection a.toggle").on("click.toggle",function(){
				container.find(".image-items").toggle();
				container.find(".image-selection").toggleClass("open");
			});
			container.find(".image-items a").on("click.images",function(){
				$(this).closest("ul").find("a").removeClass("selected");
				$(this).addClass("selected");
			});
			container.find("a.submit").on("click.images",function(){
				var parent = $(this).closest(".image-selection");
				var target = parent.find("a.selected");
				var value = $(this).closest("form").find('textarea').val() || "";
				value += (value.length ? (" " + target.data("prompt")) : target.data("prompt"));
				target.closest("form").find('textarea').val(value);
				parent.find("a.selected").removeClass("selected");
				container.find(".image-selection a.toggle").click();
			});
			container.find("a.cancel").on("click.images",function(){
				var parent = $(this).closest(".image-selection");
				parent.find("a.selected").removeClass("selected");
				container.find(".image-selection a.toggle").click();
			});
			container.find(".image-selection").show();
		}
		else
		{
			container.find(".image-items").html("");
			container.find(".image-selection").hide();
		}

		if(configured)
		{
			onRestart();
			if(self.requestedCollage)
			{
				$("#collage-instructions").html(constructor.find("collage#"+self.requestedCollage).find("prompt").text());
				$("#prompt-image").attr("src",constructor.find("collage#"+self.requestedCollage).attr("src"));
			}
			applySavedState(saved);
			quest.update(quest.PROGRAM_LINKS,{});
			return;
		}	

		configured = true;





		palettes = [];
		
		canvas = container.find("#collage-canvas");
		container.find("a.tab").click(onSelectTab).each(function(index){$(this).attr("data-panel","tab-"+index); $(this).siblings("form.panel").attr("id","tab-"+index);});
		container.find("#collage-selection").find("form").submit(onWordSubmit);

		container.find("#enlarge").click(onEnlarge);
		container.find("#shrink").click(onShrink);
		container.find("#rotate").click(onRotate);
		container.find("#clone").click(onClone);
		container.find("#delete").click(onDelete);

		container.find("#collage-restart").click(onRestart);
		container.find("#collage-done").click(onDone);
		container.find("#collage-save").click(onSave);
		container.find("#collage-add").click(onAdd);

		$("#collage-activity-done-button").click(function(event){$("#collage-activity").hide()});
		
		container.find("#collage-fonts").find("input")
		.on("change",function(event){
			canvas[0].className = canvas[0].className.replace(/font-\d/gim,"");
			canvas.addClass("font-"+$(this).attr("value"));
			currentFontIndex = parseInt($(this).attr("value"));
		})
		.eq(0).attr("checked","checked");
		
		container.find("#collage-colors").find("input")
			.each(function(index){
				palettes.push({index:0,list:$(this).attr("data-colors").split(",")})
			})
			.on("change",function(event){
				currentPalette = palettes[parseInt($(this)[0].value) - 1];
				recolor();
				currentPaletteIndex = parseInt($(this).attr("value"));
			})
			.eq(0).attr("checked","checked");


		container.find("#collage-background").find("fieldset").eq(0).find("input").on("change",function(){
			if($(this).attr("data-color")) 
			{
				if($(this).attr("data-color").match(/-gradient/gim)) 
				{
					canvas.css("background-color","none");
					canvas.attr("style",gradients[$(this).attr("data-color")]);
				}
				else if($(this).attr("data-color").match(/-pattern/gim)) 
				{
					canvas.css("background-color","none");
					canvas.attr("style",patterns[$(this).attr("data-color")]);
				}
				else 
				{
					canvas.attr("style","");
					canvas.css("background-color",$(this).attr("data-color"));
				}
			}
			currentColorIndex = parseInt($(this).attr("value"));
		});
		

		container.find("#collage-background").find("fieldset").eq(1).find("input").on("change",function(event){
			canvas[0].className = canvas[0].className.replace(/background-\d/gim,"");
			canvas.addClass("background-"+$(this).attr("value"));
			currentShapeIndex = parseInt($(this).attr("value"));
		});

		currentPalette = palettes[0];
		canvas.addClass("font-1").click(function(event){
			container.find(".panel").hide();
		});

		if(self.requestedCollage) 
		{
			$("#collage-instructions").html(constructor.find("collage#"+self.requestedCollage).find("prompt").text());
			$("#prompt-image").attr("src",constructor.find("collage#"+self.requestedCollage).attr("src"));
		}

		currentFontIndex = currentPaletteIndex = 1;
		currentShapeIndex = currentColorIndex = 0;

		onRestart();

		applySavedState(saved);

		container.find("#collage-info").click(function(){$("#collage-activity").show()});
		quest.update(quest.PROGRAM_LINKS,{});
	}

	function applySavedState(data)
	{
		if(!data) 
		{
			container.find("#collage-title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"')).attr("placeholder","");
			return;
		}


		currentFontIndex = data.font;
		currentPaletteIndex = data.palette;
		currentColorIndex = data.color;
		currentShapeIndex = data.shape;

		title = "Thought Collage"; //data.title || "";
		if(data.generic == "true") 
		{
			container.find("#collage-title").find("input").attr("disabled",null);
		}
		container.find("#collage-title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"')).attr("placeholder","");

		var words = data.words;
		var textarea = container.find("#collage-selection").find("textarea");
		var ids;
		var index = 0;
		for(var i = 0, count = words.length; i < count; i++)
		{
			var word = words[i];
			canvas.append("<p id='collage-word-"+i+"' class='collage-word' data-rotation='"+word.rotation+"' style='color:"+word.color+";top:"+word.top+";left:"+word.left+";font-size:"+word.size+";-webkit-transform:rotate("+word.rotation+"deg);-moz-transform:rotate("+word.rotation+"deg);-ms-transform:rotate("+word.rotation+"deg);transform:rotate("+word.rotation+"deg);'>"+word.text+"</p>");
			//textarea[0].value += (word.text + "\n");
			ids = ids ? (ids + ",collage-word-"+i) : ("collage-word-"+i);
			index = i;
		}
		textarea.attr("data-words",ids);
		textarea.attr("data-index",index);

		canvas[0].className = canvas[0].className.replace(/font-\d/gim,"");
		canvas.addClass("font-"+data.font);

		currentPalette = palettes[parseInt(currentPaletteIndex) - 1];

		var color = container.find("#collage-background").find("fieldset").eq(0).find("input").eq(parseInt(currentColorIndex)-1).attr("data-color");
		
		if(color.match(/-gradient/gim)) 
		{
			canvas.css("background-color","none");
			canvas.attr("style",gradients[color]);
		}
		else if(color.match(/-pattern/gim)) 
		{
			canvas.css("background-color","none");
			canvas.attr("style",patterns[color]);
		}
		else 
		{
			canvas.attr("style","");
			canvas.css("background-color",color);
		}

		canvas[0].className = canvas[0].className.replace(/background-\d/gim,"");
		canvas.addClass("background-"+currentShapeIndex);


		container.find("#collage-fonts").find('input[value="'+currentFontIndex+'"]').prop("checked","checked");
		container.find("#collage-colors").find('input[value="'+currentPaletteIndex+'"]').prop("checked","checked");
		container.find("#collage-background").find("fieldset").eq(0).find('input[value="'+currentColorIndex+'"]').prop("checked","checked");
		container.find("#collage-background").find("fieldset").eq(1).find('input[value="'+currentShapeIndex+'"]').prop("checked","checked");



		draggable();

		$("#collage-selection").hide();
		$("#collage-modifiers").show();
	}

	function onAdd(event)
	{
		$("#collage-selection").show().find("textarea")[0].value = "";
		$("#collage-modifiers").hide();
	}

	function onSave(event,preventGeneric)
	{
		preventGeneric = preventGeneric || forceNonGeneric;
		savedScreenValue = savedScreenValue || (self.requestedCollage || "temp") + (saveAsGeneric ? Math.round(Math.random()*100000000) : "");
		var screenID = savedScreenValue;
		var json = synthesizeJSON();
		container.find("#collage-save").css("opacity",0);
		$.ajax({url:'php/collage.php',type:'POST',data:{request:"save", screen:screenID,generic:preventGeneric === true ? false : saveAsGeneric,location: self.location, collage:json },dataType:'json',success:collageHandler,error:errorHandler});
	}

	function onDone(event)
	{
		onSave(null,true);
		//if(!saved) quest.hut.updateAccount(5);
		quest.login.completions[quest.collage.requestedCollage] = true;
		saved = true;
		quest.loadScreen(quest.previousPage || "map");
		quest.showAlert("completion");
	}

	function synthesizeJSON()
	{
		var data = {};
		data.font = currentFontIndex;
		data.palette = currentPaletteIndex;
		data.color = currentColorIndex;
		data.shape = currentShapeIndex;
		data.words = [];
		data.title = self.requestedTitle || container.find("#collage-title").find("input").val();

		canvas.find("p.collage-word").each(function(index){
			data.words.push({text:$(this).text(),
								size:$(this).css("font-size"),
								rotation:$(this).attr("data-rotation"),
								left:$(this).css("left"),
								top:$(this).css("top"),
								color:$(this).css("color")});
		});

		return JSON.stringify(data);
	}

	function collageHandler(data)
	{
		if(data.badTitle)
		{
			quest.showAlert("collage");
			container.find("#collage-save").animate({opacity:1});
			return;
		}
		forceNonGeneric = true;
		container.find("#collage-save").animate({opacity:1});
	}
	function errorHandler(result)
	{
		quest.showAlert("shutdown");
	}

	function onRestart(event)
	{
		canvas.find("p.collage-word").remove();
		canvas[0].className = canvas[0].className.replace(/background-\d/gim,"");
		canvas[0].className = canvas[0].className.replace(/font-\d/gim,"font-1");
		canvas.css("background-color","white");

		$("#collage-selection").show().find("textarea")[0].value = "";
		$("#collage-modifiers").hide();

		container.find("#collage-colors").find("input").eq(0).prop("checked","checked");
		container.find("#collage-fonts").find("input").eq(0).prop("checked","checked");
		container.find("#collage-background").find("input").prop("checked",false);
		container.find(".panel").hide();

		currentFontIndex = 1;
		currentPaletteIndex = 1;
		currentColorIndex = 0;
		currentShapeIndex = 0;
	}

	function onEnlarge(event)
	{
		var target = canvas.find(".active");
		var size = parseInt(target.css("font-size"));
		target.css("font-size",(size+5)+"px");
	}
	function onShrink(event)
	{
		var target = canvas.find(".active");
		var size = parseInt(target.css("font-size"));
		if(size <= 10) return;
		target.css("font-size",(size-5)+"px");
	}

	function onRotate(event)
	{
		var target = canvas.find(".active");
		var rotation = parseInt(target.attr("data-rotation"));
		rotation += 45;
		if(rotation >= 360) rotation = 0;
		target.attr("data-rotation",rotation);

		target.css("-webkit-transform","rotate("+rotation+"deg)");
		target.css("-moz-transform","rotate("+rotation+"deg)");
		target.css("-ms-transform","rotate("+rotation+"deg)");
		target.css("transform","rotate("+rotation+"deg)");
	}

	function onClone(event)
	{
		var target = canvas.find(".active");
		var clone = target.clone();
		clone.css("left",(parseInt(target.css("left")) + 20) + "px");
		clone.css("top",(parseInt(target.css("top")) + 30) + "px");
		clone.css("color",fetchColor());
		canvas.append(clone);
		canvas.find(".active").removeClass("active");
		clone.addClass("active");
		draggable();
	}

	function onDelete(event)
	{
		var target = canvas.find(".active");
		target.remove();

		if(!canvas.find(".collage-word").eq(0).addClass("active").length)
		{
			$("#collage-selection").show().find("textarea")[0].value = "";
			$("#collage-modifiers").hide();
		}
	}

	function onWordSubmit()
	{
		var words = $(this).find("textarea")[0].value;
		var pattern = /(\S+)/gim;

		var result = pattern.exec(words);
		trace(result);
		wordlist = [];
		while(result)
		{
			var word = result[0];
			if(word.replace(/\s*/gim,"").length) wordlist.push(word.replace(/^\s*/,""));
			result = pattern.exec(words);
		}

		renderWordlist();
		$("#collage-selection").hide();
		$("#collage-modifiers").show();
	}

	function renderWordlist()
	{
		//canvas.html("");
		for(var i = 0, count = wordlist.length; i < count; i++)
		{
			var word = wordlist[i];
			
			canvas.append("<p class='collage-word' data-rotation='0' style='top:"+(60+i*30)+"px;left:"+(60+i*20)+"px; color:"+fetchColor()+"'>"+word+"</p>");
			
		}	
		draggable().eq(0).addClass("active");;
	}

	function fetchColor()
	{
		if(currentPalette.index >= currentPalette.list.length) currentPalette.index = 0;
		var color = currentPalette.list[currentPalette.index]
		currentPalette.index ++;
		return color;
	}

	function recolor()
	{
		canvas.find(".collage-word").each(function(index){
			$(this).css("color",fetchColor());
		});
	}


	function draggable()
	{
		try {$(".collage-word").draggable("destroy");} catch(ignore){}
		return $(".collage-word").draggable({containment:"parent"}).on("mousedown",function(event,ui){canvas.find(".active").removeClass("active"); $(this).addClass("active")});
	}

	function onSelectTab(event)
	{
		var panel = $(this).siblings(".panel");
		container.find(".panel:not(#"+$(this).attr("data-panel")+")").hide();
		panel.toggle();
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
	
}(quest,quest.collage = quest.collage || {}));
quest.chest = (function(quest,self){
	
	var trace = quest.trace;
	var configured = false;
	var popup;


	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD) configure();
	}
	function configure()
	{
		if(popup) popup.hide();

		if(configured) return;
		configured = true;

		popup = $("#chest-popup");
		$("img.chest").click(onChestClick).on("keydown",function(event){
			if(event.keyCode == 13 || event.keyCode == 32) $(this).click();
		});

		popup.find("a").click(function(){

			if($(this).hasClass("collage"))
			{
				quest.collage.requestedTitle = $(this).text();
				quest.collage.location = quest.currentPage;
				quest.collage.requestedCollage = $(this).attr("data-collage");
				if(!quest.collage.requestedCollage) return;
				quest.loadScreen("collage");
			}
			if($(this).hasClass("wardrobe"))
			{
				//quest.wardrobe.requestedTitle = $(this).text();
				quest.wardrobe.location = quest.currentPage;
				//quest.wardrobe.requestedCollage = $(this).attr("data-wardrobe");
				//if(!quest.wardrobe.requestedCollage) return;
				quest.loadScreen("wardrobe");
			}
			if($(this).hasClass("prompt"))
			{
				quest.prompt.requestedTitle = $(this).text();
				quest.prompt.location = quest.currentPage;
				quest.prompt.requestedPrompt = $(this).attr("data-prompt");
				if(!quest.prompt.requestedPrompt) return;
				quest.loadScreen("prompt");
			}
			if($(this).hasClass("organizer"))
			{
				quest.organizer.requestedTitle = $(this).text();
				quest.organizer.location = quest.currentPage;
				quest.organizer.requestedOrganizer = $(this).attr("data-organizer");
				if(!quest.organizer.requestedOrganizer) return;
				quest.loadScreen("organizer");
			}
		});

		$(document).click(function(event){ if($(event.target).hasClass("chest")) return; popup.hide();})
	}

	function onChestClick(event)
	{
		var ratings = quest.comments.activeComments;
		var location = $(this).parent().attr("id");
		popup[0].className = popup[0].className.replace(/location-\w+/gim,"");
		popup.addClass("location-"+location).toggle();

		popup.find("a."+location).each(function(){
			var link = $(this);
			var attr = "data-"+ link.get(0).className.replace(location,"").replace(/\s+/gim,"");
			var data = ratings[link.attr(attr)];
			var completion = quest.login.completions ? quest.login.completions[link.attr(attr)] : false;
			if(data) link.addClass("rating-"+data.rating);
			if(completion) link.addClass("completed");

		});

		if(popup.css("display") == "block") popup.attr("tabindex","-1").focus();

	}

	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.chest = quest.chest || {}))

quest.messages = (function(quest,self){
	
	var trace 				= quest.trace;
	var timeout 			= null;
	var unread				= [];
	var configured			= false;
	var classChanged		= false;

	self.onSubmitForm = function(){
		return false;
	};

	quest.preventForm = function(){
		return false;
	};

	function onApplicationUpdate(type,data)
	{
		if(type === "login") 
		{
			fetchMessages();
			configureTeacherPanel();
		}
	}

	function fetchMessages()
	{
		$.ajax({url:'php/messages.php',type:'POST',data:{request:"fetch"},dataType:'json',success:successHandler,error:errorHandler});
	}

	function successHandler(messages)
	{
		var list = $("div.message-container").find("ol");
		list.html("");
		unread = [];
		for(var i = 0, count = messages.length; i < count; i++)
		{
			var message = messages[i];
			var html = "<li>";
			html += "<p>"+parseURLs(message.text)+"</p>";
			html += "<span class='date-container'><span class='day'>" + message.day + "</span>";
			html += "<span class='date'>"+message.date+"</span></span></li>";
			list.append(html);

			if(!message.read) unread.push(message.id);
		}
		if(unread.length > 0) $("#header-messages").addClass("on");
		$("#header-messages").find("span.count").html(unread.length > 0 ? unread.length : "0");
		$("#header-messages").click(showMenu);
		if(quest.settings.role !== "teacher") $("div.message-container").find(".close-button").click(hideMenu);

		if(configured) return;
		configured = true;
		


		/*$("div.message-container").find(".sendmessage, .sendclassmessage").show().on("mousedown",function(e){
			var html = $("<li/>");
			var message = $("<p contenteditable='true'>Type your message here. Click outside to send.</p> <button class='savemessage'>Send</button>");
			html.append(message);
			list.prepend(html);
			e.stopImmediatePropagation();
			e.preventDefault();
			var button = $(this);
			var global = button.hasClass("sendclassmessage");
			button.attr("disabled","disabled");

			html.find("button").click(function(){
				var text = html.find("p").text();
				button.attr("disabled",null);
				$.ajax({url:'php/messages.php',type:'POST',data:{request:"save",global:global ? "true":"false",message:text},dataType:'json',success:successHandler,error:errorHandler});
			});
			html.find("p").attr("tabindex",-1).focus();
		}); */

	}

	function configureTeacherPanel(){
		if(quest.settings.role !== "teacher") return;
		$("div.message-container").find(".pg1").show();
		$("div.message-container").find(".pg2").hide();

		$("div.message-container").addClass("teacher");

		var years = quest.login.yearList;
		var $years = $("#message-year");
		var $classes = $("#message-class");
		var $select = $("#message-select");
		var $buttons = $(".message-container").find(".buttons");
		var $next = $buttons.find(".message-next");
		var $cancel = $buttons.find(".message-cancel");
		var $submit = $buttons.find(".message-submit");
		var $back = $("div.message-container").find(".back-to-roster");
		var $entry = $("div.message-container").find("textarea");
		var $quit = $("div.message-container").find(".close-button");

		var defaultYear = null;

		$years.find('option:not([value="-1"])').remove();
		$classes.find("option:not([value='-1'])").remove();

		years.forEach(function(year){
			$years.append($("<option value='"+year.id+"'>"+year.name+"</option>"));
			defaultYear = year.id;
		});

		$years.off("change.year",onYearChange).on("change.year",onYearChange);
		$classes.attr("disabled","disabled");
		$select.attr("disabled","disabled");

		$cancel.off("click.cancel",onCancel).on("click.cancel",onCancel);
		$quit.off("click.cancel",onCancel).on("click.cancel",onCancel);
		$next.off("click.next",onCancel).on("click.next",onNext);
		$entry.off("keyup.entry",onEntry).on("keyup.entry",onEntry);
		$submit.off("click.submit",onSubmit).on("click.submit",onSubmit);
		$back.off("click.back",onBack).on("click.back",onBack);

		$years.val(defaultYear);
		onYearChange();
	}

	function onNext(){
		var $list = $("div.message-container").find("form.students ul");
		var $entry = $("div.message-container").find("textarea");
		var $preset = $("div.message-container").find(".preset-message");

		var ids = [];
		$list.find("input:checked").each(function(){
			$input = $(this);
			ids.push($input.val().toString());
		});

		if(quest.presetMessage) {
			$entry.hide();
			$preset.html(quest.presetMessage).show();
			$("div.message-container").find(".message-submit.pg2").attr("disabled",null);
		} else {
			$entry.show();
			$preset.html("").hide();
		}

		var students = getStudents(ids);
		var $recipients = $("div.message-container").find(".recipients").html("");
		students.forEach(function(student){
			$recipients.append(($recipients.text().length ? ", ": "") + student.name);
		});

		self.selectedStudents = students;


		$("div.message-container").find(".pg1").hide();
		$("div.message-container").find(".pg2").show();
		$("div.message-container").find(".info").css("display","flex");
	}

	function onCancel(){
		var $years = $("#message-year");
		var $classes = $("#message-class");
		var $submit = $("#message-select");
		var $list = $("div.message-container").find("form.students ul");
		var $next = $("div.message-container").find(".message-next");
		var $entry = $("div.message-container").find("textarea");
		var $back = $("div.message-container").find(".back-to-roster");
		var $send = $("div.message-container").find(".message-submit");
		
		self.currentYear = null;
		self.currentClass = null;
		self.selectedStudents = null;

		$classes.find("option:not([value='-1'])").remove();
		$submit.attr("disabled","disabled");
		$classes.attr("disabled","disabled");
		$next.attr("disabled","disabled");
		$back.attr("disabled",null);
		$send.attr("disabled","disabled");
		$list.find("li").remove();
		$years.find("option").eq(0).prop("selected","selected");
		$entry.val(null);

		quest.presetMessage = null;

		$("div.message-container").find(".pg1").show();
		$("div.message-container").find(".pg2").hide();

		hideMenu();
	}

	function onYearChange(event){
		var $years = $("#message-year");
		var $classes = $("#message-class");
		var $submit = $("#message-select");

		var year = $years.val();
		$classes.find("option:not([value='-1'])").remove();
		
		if(year === "-1") {
			self.currentYear = null;
			$classes.attr("disabled","disabled");
		}
		else{
			var info = getYear(year);
			var classes = info.classes;
			self.currentYear = info;

			classes.forEach(function(item){
				$classes.append($("<option value='"+item.id+"'>"+item.label+"</option>"))
			});
			$classes.attr("disabled",null);
		}

		$submit.attr("disabled","disabled");
		$classes.off("change.class",onClassChange).on("change.class",onClassChange);
	}

	function onClassChange(event){
		var $classes = $("#message-class");
		var $submit = $("#message-select");

		var selection = $classes.val();

		if(selection === "-1") {
			self.currentClass = null;
			classChanged = true;
			$submit.attr("disabled","disabled");
		}
		else{
			var info = getClass(selection)
			var students = info.students;
			
			if(self.currentClass == info) classChanged = false;
			else classChanged = true;

			self.currentClass = info;
			$submit.off("click.selection",onClassSelection).on("click.selection",onClassSelection).attr("disabled",null);
		}
	}

	function onClassSelection(event){
		if(event) 
		{
			event.preventDefault();
			event.stopImmediatePropagation();
		}

		var students = self.currentClass.students;
		var $list = $("div.message-container").find("form.students ul");
		if(!classChanged) return;

		$list.find("li").remove();
		$list.append($('<li><input id="student-all" data-on="false" type="checkbox" value="all"><label for="student-all">Student Name</label></li>'));

		students.forEach(function(student){
			var html = '<li><input id="student-'+student.id+'" type="checkbox" value="'+student.id+'"><label for="student-'+student.id+'">'+student.name+'</label></li>';
			$list.append($(html));
		});

		$list.find("input").eq(0).on("change",onToggleAll);
		$list.find("input").on("change",onSelection);
		classChanged = false;
	}

	function onToggleAll(){
		var $list = $("div.message-container").find("form.students ul");
		var $item = $list.find("input").eq(0);

		if($item.attr("data-on") === "true") $item.attr("data-on","false");
		else $item.attr("data-on","true");

		if($item.attr("data-on") === "true"){
			$list.find("input").prop("checked","checked");
		}
		else{
			$list.find("input").prop("checked",false);
		}
	}

	function onSelection(){
		var $list = $("div.message-container").find("form.students ul");
		var $next = $("div.message-container").find(".message-next");
		if($list.find("input:checked").length){
			$next.attr("disabled",null);
		}
		else{
			$next.attr("disabled","disabled");
		}
	}

	function onBack(){
		$("div.message-container").find(".pg1").show();
		$("div.message-container").find(".pg2").hide();
	}

	function reset(){
		var $list = $("div.message-container").find("form.students ul");
		var $next = $("div.message-container").find(".message-next");
		$list.find("input:checked").prop("checked",null);
		self.selectedStudents = null;
		$next.attr("disabled","disabled")
		$("div.message-container").find(".pg1").show();
		$("div.message-container").find(".pg2").hide();
	}

	function onEntry(){
		var $entry = $("div.message-container").find("textarea");
		var $send = $("div.message-container").find(".message-submit");
		var value = $entry.val();
		if(value && value.length > 0) $send.attr("disabled",null);
		else $send.attr("disabled","disabled");
	}

	function onSubmit(){
		var $entry = $("div.message-container").find("textarea");
		var $preset = $("div.message-container").find(".preset-message");
		var $back = $("div.message-container").find(".back-to-roster");
		var $send = $("div.message-container").find(".message-submit");

		var message = $entry.val();
		$entry.attr("disabled","disabled");
		$send.attr("disabled","disabled");
		$back.attr("disabled","disabled");

		if(quest.presetMessage) {
			message = $preset.html().replace(/\s+/gim," ");
		}


		$.ajax({url:'php/messages.php',type:'POST',data:{request:"send",message:message,students: JSON.stringify(self.selectedStudents)}, complete:onSendSuccess, error:onSendError});
	}

	function onSendSuccess(data){
		var $back = $("div.message-container").find(".back-to-roster");
		var $entry = $("div.message-container").find("textarea");
		var $send = $("div.message-container").find(".message-submit");

		$entry.val(null).attr("disabled",null);
		$back.attr("disabled",null);
		$send.attr("disabled","disabled");

		reset();
	}
	function onSendError(data){
		trace("error",data);
	}

	function getYear(year){
		var years = quest.login.yearList;
		for(var i = 0, count = years.length; i < count; i++){
			var item = years[i];
			if(item.id.toString() === year) return item;
		}
		return null;
	}

	function getClass(selection){

		var classes = self.currentYear.classes;

		for(var i = 0, count = classes.length; i < count; i++){
			var item = classes[i];
			if(item.id.toString() === selection) return item;
		}
		return null;
	}

	function getStudents(list){
		var students = self.currentClass.students;
		var results = students.filter(function(element){
			if(list.indexOf(element.id.toString()) !== -1) return true;
			return false;
		});
		return results;
	}

	function parseURLs(string)
	{	
		var reg = /((https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w\.-]*)*\/?)/gim;
		var copy = string;

		copy = copy.replace(/&quot;/gim,'"');

		if(copy.match(/href=".*?"/gim)) return copy;
		if(copy.match("Your teacher has left a comment on")) return copy;
		return copy;

		var result = reg.exec(copy);

		while(result)
		{
			var url = (result[2] ? "" : "//") + result[0];
			string = string.replace(result[0],"<a href='"+url+"' target='_blank'>"+result[0]+"</a>");
			result = reg.exec(copy);
		}

		return string;
	}
	function showMenu(event)
	{
		if(unread.length > 0)  timeout = setTimeout(markMessagesRead,2500);
		$("div.messages").ariaFadeIn().attr("tabindex",-1).focus();
	}
	function hideMenu(event)
	{
		clearTimeout(timeout);
		$("div.messages").ariaFadeOut();
		$("#header-messages").focus();
	}

	function markMessagesRead()
	{
		$("#header-messages").find("span.count").html("0");
		$("#header-messages").removeClass("on");
		$.ajax({url:'php/messages.php',type:'POST',data:{request:"read",messages:unread.join(",")}});
	}



	function errorHandler(event)
	{
		trace("error",event);
	}

	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.messages = quest.messages || {}))

quest.comments = (function(quest,self){
	
	var trace 				= quest.trace;
	self.activeComments = {};
	self.successHandler = successHandler;
	
	function onApplicationUpdate(type,data)
	{
		if(type === "login") fetchComments();
	}

	function fetchComments()
	{
		$.ajax({url:'php/comments.php',type:'POST',data:{request:"fetch"},dataType:'json',success:successHandler,error:errorHandler});
	}

	function successHandler(comments)
	{
		for(var i = 0, count = comments.length; i < count; i++)
		{
			var comment = comments[i];
			self.activeComments[comment.screen] = comment;
		}

		if(this.activityID) {
			quest.loadScreen(quest.settings.TEACHER_ADMINISTRATION_CONTAINER_PAGE);
		}
	}

	function errorHandler()
	{

	}

	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.comments = quest.comments || {}));

quest.prompt = (function(quest,self){
	
	var trace 			= quest.trace;
	var currentPage		= null;
	var container 		= null;
	var textarea		= null;
	var submit			= null;
	var constructor, configured;
	var multi = false;
	var saved = false;
	var generic = "false";
	var saveAsGeneric = false;
	var savedScreenValue;
	var title = "";

	self.requestedPrompt = null;
	self.requestedTitle = null;
	self.location = null;
	self.spawnGeneric = false;

	self.getMulti = function(){return multi;}


	self.regenerate = function(id,data)
	{
		savedScreenValue = null;
		self.requestedPrompt = id;
		constructor = quest.fetchConstructor("prompt");
		configure({prompt:data},true);
		return container.html();
	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.PROMPT_PAGE) load(pData);
	}

	function load(pData)
	{
		constructor = pData.content;
		if(!self.requestedPrompt) return quest.loadScreen("map");
		savedScreenValue = null;
		$.ajax({url:'php/prompt.php',type:'POST',data:{request:"fetch", screen:self.requestedPrompt ? self.requestedPrompt : "temp",location: self.location }, dataType:'json',success:onLoad,error:errorHandler});
	}

	function onLoad(pData) {
		configure(pData);
		addAudioToMulti();
	}

	function addAudioToMulti() {
		if(!multi) return;
		$("#multi").find("fieldset").each(function(index){
			$(this).prepend('<a class="global-audio-button sm multibutton" href="javascript:void(0)">Toggle Audio</a>');
			$(this).find('.global-audio-button.multibutton').click(onMultiButton.bind({index:index}))
		});
	}

	function onMultiButton(){
		var index = this.index + 2;
		quest.audio.playClip("audio/writing_prompt_imagine_"+index);
	}

	function onTitleAudio() {
		quest.audio.playClip("audio/"+self.requestedPrompt+"-title");
	}
	function onTextAudio() {
		if(multi) quest.audio.playClip("audio/writing_prompt_imagine_1");
		else quest.audio.playClip("audio/"+self.requestedPrompt+"-text");
	}

	function configure(pData)
	{
		saved = pData.prompt;
		savedScreenValue = null;
		if(saved) savedScreenValue = pData.screen;
		container = $("#prompt");
		textarea = container.find("textarea");
		submit = container.find('input[type="submit"]').css("opacity",1);
		textarea.val("");
		container.find("#prompt-title").find("input").val("");
		$("#prompt").find("form#multi").empty();

		$(".title-audio").click(onTitleAudio);
		$(".text-audio").click(onTextAudio);

		saveAsGeneric = false;

		if(pData.forecast && (self.requestedPrompt === "prompt-7" || self.requestedPrompt === "prompt-15"))
		{
			container.find(".forecast-content").removeClass("multi");
			if(self.requestedPrompt === "prompt-7") 
			{
				container.find(".forecast-content").find("h2").show();
			}
			else 
			{
				container.find(".forecast-content").addClass("multi");
				container.find(".forecast-content").find("h2").hide();
			}

			container.find(".forecast-content").find("p").html(pData.forecast.replace("Your Future Forecast",""));
			container.find(".forecast-content").show();
		} 
		else if(self.requestedPrompt === "prompt-7" || self.requestedPrompt === "prompt-15")
		{
			if(self.requestedPrompt === "prompt-7") 
			{
				container.find(".forecast-content").find("h2").show();
				container.find(".forecast-content").find("p").html("<a href='javascript:void(0)'>Click here</a> to start your Future Forecast.");
			}
			else 
			{
				container.find(".forecast-content").addClass("multi");
				container.find(".forecast-content").find("h2").hide();
				container.find(".forecast-content").find("p").html("<a href='javascript:void(0)'>Click here</a> to start the Future Forecast.");
			}
			container.find(".forecast-content").find("p").find("a").click(function(){
				quest.port.launchActivity();
			});

		}
		else
		{
			container.find(".forecast-content").hide();
			container.find(".forecast-content").find("p").html("");
		}

		var images = quest.settings.images[self.requestedPrompt];
		container.find(".image-selection").find("a.toggle").off("click.toggle");
		container.find(".image-items a").off("click.images");
		container.find("a.submit").off("click.images");
		container.find("a.cancel").off("click.images")
		
		if(images)
		{
			console.log("CPROMPT: 1");
			var isMulti = constructor.find("prompt#"+self.requestedPrompt).find("multi").length ? true:false;
			
			if (!isMulti)
			{
				/*MD: leaving single prompt as is*/
				var html = "";
				images.forEach(function(image){
					html += "<li><a data-prompt='"+image.text+"' href='javascript:void(0)'><span class='image-container'><img src='images/support/"+image.image+".png' alt='"+image.text+"'/></span><span class='label'>"+image.text+"</span></a></li>";
				});
				container.find(".image-items.single").html($(html));
				container.find(".image-selection.single a.toggle").on("click.toggle",function(){
					container.find(".image-selection.single .image-items.single").toggle();
					container.find(".image-selection.single").toggleClass("open");
				});
				container.find(".image-items.single a").on("click.images",function(){
					$(this).closest("ul").find("a").removeClass("selected");
					$(this).addClass("selected");
				});
				container.find("a.submit").on("click.images",function(){
					var parent = $(this).closest(".image-selection");
					var target = parent.find("a.selected");
					var value = $(this).closest("form").find('textarea').val() || "";
					value += (value.length ? (" " + target.data("prompt")) : target.data("prompt"));
					target.closest("form").find('textarea').val(value);
					container.find(".image-selection a.toggle").click();
				});
				container.find("a.cancel").on("click.images",function(){
					var parent = $(this).closest(".image-selection");
					parent.find("a.selected").removeClass("selected");
					container.find(".image-selection a.toggle").click();
				});
				container.find(".image-selection.single").show();
			}
			else
			{
				//is multi
				var html = "";
				images.forEach(function(image,index){
					html += "<li class='field-"+image.field+"'><a data-field='"+image.field+"' data-prompt='"+image.text+"' href='javascript:void(0)'><span class='image-container'><img src='images/support/"+image.image+".png' alt='"+image.text+"'/></span><span class='label'>"+image.text+"</span></a></li>";
				});
				container.find(".image-items.multi").html($(html));

				container.find(".image-items.multi a").on("click.images",function(){
					var field = $(this).data("field");
					$(this).closest("ul").find('a[data-field='+field+']').removeClass("selected");
					$(this).addClass("selected");
				});

				container.find("a.submit").on("click.images",function(){
					var field = container.find(".image-selection").attr("data-field");
					var map = [1,2,3,4,5,6][parseInt(field)-1]-1;
					var parent = $(this).closest(".image-selection");
					var target = parent.find("a[data-field="+field+"].selected");

					/*MD if multi, this is not 0-based*/
					map++;
					/*MD end */

					var value = container.find('textarea').eq(map).val() || "";
					value += (value.length ? (" " + target.data("prompt")) : target.data("prompt"));
					container.find('textarea').eq(map).val(value);
					container.find(".image-items.multi").find("li").hide();
					container.find(".image-items.multi").find("li.field-"+field).hide();
					container.find(".image-items.multi").hide();
					container.find(".image-selection").toggleClass("open");
					container.find("a.selected").removeClass("selected");
				});
				container.find("a.cancel").on("click.images",function(){
					var parent = $(this).closest(".image-selection");
					container.find("a.selected").removeClass("selected");
					container.find(".image-items.multi").find("li").hide();
					container.find(".image-items.multi").hide();
					container.find(".image-selection").toggleClass("open");
				});
				container.find(".image-selection.multi").show();
			}		
		}
		else
		{
			container.find(".image-items.single").html("");
			container.find(".image-items.multi").html("");
			container.find(".image-selection.single").hide();
			container.find(".image-selection.multi").hide();
		}
		

		if(self.spawnGeneric) 
		{
			saved = null;
			generic = "true";
			saveAsGeneric = true;
			container.find("#prompt-title").find("input").attr("disabled",null);
		}
		else
		{
			generic = "false";
			container.find("#prompt-title").find("input").attr("disabled","true").attr("placeholder","");
		}
		self.spawnGeneric = false;
		title = constructor.find("#"+self.requestedPrompt).find("title").text();
		container.find("#prompt-title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));




		var comment = quest.comments.activeComments[self.requestedPrompt];
		var starContainer = container.find("div.star-rating");
		starContainer.get(0).className = starContainer.get(0).className.replace(/star\d{1}/gim,"");
		starContainer.find("p").html("");
		
		if(comment)
		{
			starContainer.addClass("star"+(comment.rating ? comment.rating : 0));
			starContainer.find("p").html(comment.comment);
		}

		if(configured)
		{
			if(self.requestedPrompt)
			{
				multi = constructor.find("prompt#"+self.requestedPrompt).find("multi").length ? true:false;
				//$("#prompt").find("h1").find("span.text").html(constructor.find("prompt#"+self.requestedPrompt).find("header").text());
				
				$("#prompt").find(".subheader").find("span.text").html(constructor.find("prompt#"+self.requestedPrompt).find("question").text());
				$("#prompt").find(".prompt-content").html(constructor.find("prompt#"+self.requestedPrompt).find("content").text());

				if(multi)
				{
					if(pData.prompt) pData = pData.prompt.title ? pData.prompt : JSON.parse(pData.prompt);
					//title = pData.title || "";
					container.find("#prompt-title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"')).attr("placeholder","");


					if(pData.generic == "true") 
					{
						container.find("#prompt-title").find("input").attr("disabled",null);
					}

					var questions = constructor.find("prompt#"+self.requestedPrompt).find("multi");
					var form = $("#prompt").find("form#multi");
					var source = $("#prompt").find("form#single").find("fieldset").eq(0);
					form.find()
					//form.html("");/*MD removed this so that the multi image-selection remains

					$("#prompt").find("form#single").hide();
					$("#prompt").find("form#multi").show();	

					questions.each(function(){
						var question = source.clone();
						question.find("label").text($(this).text());
						form.append(question);
					});

					form.append($("<input type='submit' value='Submit'/>"));
					$("#prompt").addClass("multi");
					if(saved && container.find("textarea").length) 
					{
						var prompts = pData.prompts;
						//var prompts = (typeof pData.prompt == "string" ? JSON.parse(pData.prompt) : pData.prompt;
						container.find("textarea").each(function(index){
							$(this).val(prompts[index].replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
						});
					}

					container.find("fieldset").each(function(index){
						$(this).append("<a class='toggle' data-field='"+(index+1)+"' href='javascript:void'>Toggle</a>");
					});
					container.find(".image-selection a.toggle").on("click.toggle",function(){
						var field = $(this).data("field");
						container.find(".image-items.multi").find("li").hide();
						container.find(".image-items.multi").find("li.field-"+field).show();
						container.find(".image-items.multi").toggle();
						container.find(".image-selection").toggleClass("open");
						container.find(".image-selection").attr("data-field",field);
					});
				}
				else
				{
					$("#prompt").find("form#single").show();
					$("#prompt").find("form#multi").hide();		
					

					if(multi && saved && container.find("textarea").length)
					{

						var prompts = JSON.parse(pData.prompt);
						container.find("textarea").each(function(index){
							$(this).val(prompts[index].replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
						});
					}	
					else if(saved && container.find("textarea").length) 
					{
						pData = pData.prompt.title ? pData.prompt : JSON.parse(pData.prompt);

						//title = pData.title || "";
						container.find("#prompt-title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n")).attr("placeholder","");


						if(pData.generic == "true") 
						{
							container.find("#prompt-title").find("input").attr("disabled",null);
						}
						textarea.val(pData.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
						container.find("#prompt-title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n")).attr("placeholder","");
					}
				}
			}
			quest.update(quest.PROGRAM_LINKS,{});
			return;
		}

		configured = true;
		

		multi = constructor.find("prompt#"+self.requestedPrompt).find("multi").length ? true:false;

		container.find("form").on("submit",function(){

			if(multi)
			{
				var quit = false;
				container.find("form#multi").find("textarea").each(function(){
					var value = this.value;
					if(!value) return quit = true;
					if(value.match(/\S+/g).length < 6) quit = true;
				});
				if(quit) return quest.showAlert("words","prompt-input");
			}
			else if(container.find("form#single").find("textarea").val() && container.find("form#single").find("textarea").val().match(/\S+/g).length < 6) return quest.showAlert("words","prompt-input");
			else if(!container.find("form#single").find("textarea").val()) return quest.showAlert("words","prompt-input");

			
			submit.css("opacity",0);

			if(multi)
			{
				var prompts = [];
				container.find("textarea").each(function(){
					prompts.push($(this).val().replace(/'/gim,"&apos;").replace(/"/gim,"&quot;").replace(/\n/gim,"<br/>"))
				});

				savedScreenValue = savedScreenValue || (self.requestedPrompt || "temp") + (saveAsGeneric ? Math.round(Math.random()*100000000) : "");
				var screenID = savedScreenValue;
				$.ajax({url:'php/prompt.php',type:'POST',data:{request:"save", screen:screenID,generic:saveAsGeneric,location: self.location , prompts: JSON.stringify({title:$("#prompt-title").find("input").val(), prompts:prompts})},dataType:'json',success:saveHandler,error:errorHandler});
			}
			else
			{
				savedScreenValue = savedScreenValue || (self.requestedPrompt || "temp") + (saveAsGeneric ? Math.round(Math.random()*100000000) : "");
				var screenID = savedScreenValue;

				$.ajax({url:'php/prompt.php',type:'POST',data:{request:"save", screen:screenID,generic:saveAsGeneric,location: self.location , prompt: JSON.stringify({title:$("#prompt-title").find("input").val(),text:textarea.val().replace(/'/gim,"&apos;").replace(/"/gim,"&quot;").replace(/\n/gim,"<br/>")})},dataType:'json',success:saveHandler,error:errorHandler});
			}
		});


		$("#prompt").find("h1").find("span.text").html(constructor.find("prompt#"+self.requestedPrompt).find("header").text());
		$("#prompt").find(".subheader").find("span.text").html(constructor.find("prompt#"+self.requestedPrompt).find("question").text());
		$("#prompt").find(".prompt-content").html(constructor.find("prompt#"+self.requestedPrompt).find("content").text().replace(/<br\/>/gim,"\n"));
		

		if(multi)
		{
			var questions = constructor.find("prompt#"+self.requestedPrompt).find("multi");
			var form = $("#prompt").find("form#multi");
			var source = $("#prompt").find("form#single").find("fieldset").eq(0);
			//form.html(""); /*MD removed this so that image-selection stays*/

			questions.each(function(){
				var question = source.clone();
				question.find("label").text($(this).text());
				form.append(question);
			});

			form.append($("<input type='submit' value='Submit'/>"));
			$("#prompt").addClass("multi");
			if(saved && container.find("textarea").length) 
			{
				var prompts = (typeof pData.prompt == "string" ? JSON.parse(pData.prompt) : pData.prompt).prompts;
				container.find("textarea").each(function(index){
					$(this).val(prompts[index].replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
				});
			}

			if(images){
			container.find("fieldset").each(function(index){
				$(this).append("<a class='toggle image multi' data-field='"+(index)+"' href='javascript:void'>Toggle</a>");
			});
			container.find("a.toggle.multi").on("click.toggle",function(){
				var field = $(this).data("field");
				container.find(".image-items.multi").find("li").hide();
				container.find(".image-items.multi").find("li.field-"+field).show();
				container.find(".image-items.multi").toggle();
				container.find(".image-selection").toggleClass("open");
				container.find(".image-selection").attr("data-field",field);
			});}
		}
		else
		{
			pData.prompt = typeof pData.prompt == "string" ? JSON.parse(pData.prompt) : pData.prompt;
			if(saved && container.find("textarea").length) textarea.val(pData.prompt.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"').replace(/<br\/>/gim,"\n"));
			$("#prompt").removeClass("multi");
		}
		quest.update(quest.PROGRAM_LINKS,{});
	}
	function saveHandler(data)
	{
		if(data.badTitle)
		{
			quest.showAlert("prompt");
			submit.animate({opacity:1});
			return;
		}

		if(quest.previousPage && quest.previousPage != quest.settings.LOGIN_PAGE) 
		{
			//if(!saved) quest.hut.updateAccount(5);
			quest.login.completions[quest.prompt.requestedPrompt] = true;
			saved = true;
			quest.loadScreen(quest.previousPage);
		}
		else submit.animate({opacity:1});
		quest.showAlert("completion");
	}
	function errorHandler()
	{
		quest.showAlert("shutdown");
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
	
}(quest,quest.prompt = quest.prompt || {}));
quest.organizer = (function(quest,self){
	
	var trace 			= quest.trace;
	var currentPage		= null;
	var container 		= null;
	var textarea		= null;
	var submit			= null;
	var constructor, configured;
	var multi = false;
	var saved = false;
	var generic = "false";
	var saveAsGeneric = false;
	var savedScreenValue;
	var title;


	self.requestedOrganizer = null;
	self.location = null;
	self.spawnGeneric = false;
	self.requestedTitle = "";

	self.screenIndex = 0;


	self.getMulti = function(){return multi;};


	self.regenerate = function(id,data)
	{
		savedScreenValue = null;
		self.requestedOrganizer = id;
		constructor = quest.fetchConstructor("organizer");

		configure({organizer:JSON.stringify(data)},true);
		return container.html();
	};
	self.addedToLightbox = function(lightbox)
	{
		lightbox.find("#title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
	};

	self.nextScreen = function(){
		var screens = $("#goal-setting").find(".slide");
		if(self.screenIndex < screens.length - 1)
		{
			self.screenIndex ++;
			updateScreenView();
		}
		else {
			$("#goal-setting").ariaFadeOut();
			$("#organizer").find("a.global-audio-button").show();
		}
	};
	self.prevScreen = function(){
		var screens = $("#goal-setting").find(".slide");
		if(self.screenIndex > 0)
		{
			self.screenIndex --;
			updateScreenView();
		}
	};
	self.skip = function()
	{
		var targetIndex = $("#goal-setting").find(".slide.skipto").index();
		if(self.screenIndex < targetIndex) 
		{
			self.screenIndex = targetIndex;
			updateScreenView();
		}
	};

	function updateScreenView()
	{
		var skipto = $("#goal-setting").find(".slide.skipto").index();
		$(".goal-container").attr("class","goal-container "+self.requestedOrganizer);
		quest.audio.close();

		$("#goal-setting").find(".slide").each(function(index){
			var bubble = $("#goal-setting").find(".bubble").eq(index);
			$(this).removeClass("left").removeClass("right");
			bubble.removeClass("left").removeClass("right");
			
			if(index < self.screenIndex) 
			{
				$(this).addClass("left");
				bubble.addClass("left");

				$(this).attr("aria-hidden","true");
				bubble.attr("aria-hidden","true");
			}
			else if(index > self.screenIndex) 
			{
				$(this).addClass("right");
				bubble.addClass("right");

				$(this).attr("aria-hidden","true");
				bubble.attr("aria-hidden","true");
			}
			else 
			{
				$(this).attr("aria-hidden","false");
				bubble.attr("aria-hidden","false");
				bubble.parent().attr("tabindex","-1").focus();
			}
		});

		if(self.screenIndex >= skipto) $("#goal-setting").find("button.skip").ariaHide();
		else $("#goal-setting").find("button.skip").ariaShow();
	}
	
	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.ORGANIZER_PAGE) load(pData);
	}

	function load(pData)
	{
		constructor = pData.content;
		if(!self.requestedOrganizer) return quest.loadScreen("map");
		$("#organizer").find("a.global-audio-button").hide();
		trace("hiding buttons");
		$("#debugger").html("<b>ID:</b> " + self.requestedOrganizer);
		savedScreenValue = null;
		$.ajax({url:'php/organizer.php',type:'POST',data:{request:"fetch", screen:self.requestedOrganizer ? self.requestedOrganizer : "temp",location: self.location }, dataType:'json',success:configure,error:errorHandler});
	}

	function onTitleClick() {
		quest.audio.playClip("audio/"+self.requestedOrganizer+"-title");
	}

	function configure(pData,reconfigure)
	{
		self.screenIndex = 0;
		updateScreenView();

		if(!configured) {
			$("#organizer").find(".global-audio-button.prompt").click(onTitleClick);
		}


		if(reconfigure !== true && self.requestedOrganizer !== "organizer-6") $("#goal-setting").ariaShow();
		
		$("#organizer").removeClass("generic");
		savedScreenValue = null;
		saved = pData.organizer;
		if(saved) savedScreenValue = pData.screen;
		container = $("#organizer");
		textarea = container.find("textarea");
		submit = container.find('input[type="submit"]').css("opacity",1);
		textarea.val("");
		container.find("input").val("");
		saveAsGeneric = false;

		container.find("h1").html($("body").find('a[data-organizer="'+self.requestedOrganizer+'"]').text());

		submit.val("Save");

		if(self.spawnGeneric) 
		{
			saved = null;
			generic = "true";
			saveAsGeneric = true;
			$("#organizer").addClass("generic");
			container.find("#title").find("input").attr("disabled",null);
		}
		else
		{
			generic = "false";
			container.find("#title").find("input").attr("disabled","true");
		}
		self.spawnGeneric = false;

		title = self.requestedTitle;

		container.find("#title").find("input").attr("placeholder","Enter title here...");

		if(saved)
		{
			var data = JSON.parse(pData.organizer);
			var goal = data.goal;
			var tasks = data.tasks;

			title = data.title || "";

			//saveAsGeneric = data.generic == "true";

			if(data.generic == "true") 
			{
				$("#organizer").addClass("generic");
				container.find("#title").find("input").attr("disabled",null);
			}

			container.find("#title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			container.find("#goals").find("textarea").val(goal.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			for(var i = 1; i <= 3; i++)
			{
				var task = tasks[i-1];
				container.find("#task-input-"+i).val(task.text.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				container.find("#date-input-"+i).val(task.date.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
				container.find("#date-input-"+i+"b").val(task.date2.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
			}
		}
		else
		{
			container.find("#title").find("input").val(title.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
		}

		var images = quest.settings.images[self.requestedOrganizer];
		container.find(".image-selection").find("a.toggle").off("click.toggle");
		container.find(".image-items a").off("click.images");
		container.find("a.submit").off("click.images");
		container.find("a.cancel").off("click.images")
		
		if(images)
		{
			var html = "";
			images.forEach(function(image){
				html += "<li class='field-"+image.field+"'><a data-field='"+image.field+"' data-prompt='"+image.text+"' href='javascript:void(0)'><span class='image-container'><img src='images/support/"+image.image+".png' alt='"+image.text+"'/></span><span class='label'>"+image.text+"</span></a></li>";
			});
			container.find(".image-items").html($(html));
			container.find(".image-selection a.toggle").on("click.toggle",function(){
				var field = $(this).data("field");
				container.find(".image-items").find("li").hide();
				container.find(".image-items").find("li.field-"+field).show();
				container.find(".image-items").toggle();
				container.find(".image-selection").toggleClass("open");
				container.find(".image-selection").attr("data-field",field);

				trace("setting field: " + field);
			});
			container.find(".image-items a").on("click.images",function(){
				var field = $(this).data("field");
				$(this).closest("ul").find('a[data-field='+field+']').removeClass("selected");
				$(this).addClass("selected");
			});
			container.find("a.submit").on("click.images",function(){
				var field = container.find(".image-selection").attr("data-field");
				var map = [1,2,5,8,3,6,9,4,7,10][parseInt(field)-1]-1;
				var parent = $(this).closest(".image-selection");
				var target = parent.find("a[data-field="+field+"].selected");
				var value = container.find('textarea').eq(map).val() || "";
				value += (value.length ? (" " + target.data("prompt")) : target.data("prompt"));
				container.find('textarea').eq(map).val(value);
				container.find(".image-items").find("li").hide();
				container.find(".image-items").find("li.field-"+field).hide();
				container.find(".image-items").hide();
				container.find(".image-selection").toggleClass("open");
				container.find("a.selected").removeClass("selected");
			});
			container.find("a.cancel").on("click.images",function(){
				var parent = $(this).closest(".image-selection");
				container.find("a.selected").removeClass("selected");
				container.find(".image-items").find("li").hide();
				container.find(".image-items").hide();
				container.find(".image-selection").toggleClass("open");
			});
			container.find(".image-selection").show();
		}
		else
		{
			container.find(".image-items").html("");
			container.find(".image-selection").hide();
		}

		$(".goal-container").find("img").each(function(index){
			var img = $(this);
			var src = img.attr("data-"+self.requestedOrganizer);
			var alt = img.attr("data-"+self.requestedOrganizer + "-alt");
			if(!src) return;
			img.attr("src","images/organizer/"+src);
			img.attr("alt",alt);
		});

		$(".text-content").find("a.audio-button").each(function(){
			var a = $(this);
			var audio = a.attr("data-"+self.requestedOrganizer+"-audio");
			var text = a.attr("data-"+self.requestedOrganizer+"-text");
			if(!audio || !text) return;
			
			a.attr("href",audio);
			a.siblings(".message").html(text);
		});


		if(configured) return;
		configured = true;

		container.find("form").on("submit",function(){
			submit.css("opacity",0);
			savedScreenValue = savedScreenValue || (self.requestedOrganizer || "temp") + (saveAsGeneric ? Math.round(Math.random()*100000000) : "");
			var screenID = savedScreenValue;
			$.ajax({url:'php/organizer.php',type:'POST',data:{request:"save", screen:screenID,location: self.location , generic:saveAsGeneric ? "true":"false", organizer: generateJSON()},dataType:'json',success:saveHandler,error:errorHandler});
		});






	
		//if(saved && container.find("textarea").length) textarea.val(pData.organizer.replace(/&apos;/gim,"'").replace(/&quot;/gim,'"'));
	}
	function saveHandler(data)
	{

		if(data.badTitle)
		{
			quest.showAlert("organizer");
			submit.animate({opacity:1});
			return;
		}
		if(quest.previousPage && quest.previousPage != quest.settings.LOGIN_PAGE) 
		{
			//if(!saved) quest.hut.updateAccount(5);
			quest.login.completions[quest.organizer.requestedOrganizer] = true;
			saved = true;
			quest.loadScreen(quest.previousPage);
		}
		else submit.animate({opacity:1});
		quest.showAlert("completion");
	}
	function errorHandler()
	{
		quest.showAlert("shutdown");
	}

	function generateJSON()
	{
		var output = {};
		output.title = clean($("#title").find("input").val());
		output.goal = clean($("#goals").find("textarea").val());
		output.tasks = [];
		output.generic = generic;

		for(var i = 1; i <= 3; i++)
		{
			var text = clean($("#task-input-"+i).val());
			var date = clean($("#date-input-"+i).val());
			var date2 = clean($("#date-input-"+i+"b").val());

			output.tasks.push({text:text,date:date,date2:date2});
		}

		return JSON.stringify(output);
	}
	function clean(text)
	{
		return text.replace(/'/gim,"&apos;").replace(/"/gim,"&quot;")
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
	
}(quest,quest.organizer = quest.organizer || {}));
quest.wardrobe = (function(quest,self){
	
	var trace 			= quest.trace;
	var container 		= null;
	var canvas			= null;
	var constructor		= null;

	var backgrounds		= [];
	var outfits 		= [];
	var heads 			= [];
	var currentBackground  = null;
	var currentOutfit  = null;
	var currentHead  = null;
	var configured		= false;

	var currentOutfitIndex = 1;
	var currentBackgroundIndex = 1;
	var currentHeadIndex = 0;
	var saved = false;
	var generic = false;
	var saveAsGeneric = false;
	var savedScreenValue;
	var forceNonGeneric = false;

	self.title = '';

	self.requestedWardrobe = null;
	self.location = 'cove';
	
	var scrollH = 0;
	var scrollC = 0;
	var scrollP = 0;

    var glossary = null;

	self.regenerate = function(id,data)
	{
		savedScreenValue = null; //?
		self.requestedWardrobe = id;
		constructor = quest.fetchConstructor("wardrobe");
		configure({wardrobe:JSON.stringify(data)});
		return container.html();
	}	

	self.playMasterAudio = function(){
		if(!self.currentProfession) self.currentProfession = "artist";
		trace($("#wardrobe-description").find("a.glossary-audio-button").data("current-tab"));
		if($("#wardrobe-description").find("a.glossary-audio-button").data("current-tab") == "tab-2") return handleAccessoryAudio();
		var target = $(".wardrobe-descr[data-profession='"+self.currentProfession+"']");
		var audio = target.find(".glossary-link").eq(0).attr("data-audio-id").replace(/[abc]/gim,"");
		quest.audio.playClip('audio/careeroutfitters_'+audio+'.mp3');
	};

	function handleAccessoryAudio(){
		var $accessory = $(".wardrobe-descr-access[data-accessory='"+self.currentAccessory+"']");
		var audio = $accessory.data("audio");
		if(audio && audio.length) quest.audio.playClip('audio/accessory-'+audio+'.mp3');
	}

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.WARDROBE_PAGE) load(pData);
	}

//MD
	function load(pData)
	{
		constructor = pData.content;
		//if(!self.requestedWardrobe) return quest.loadScreen("map");
		savedScreenValue = null;
		$.ajax({url:'php/wardrobe.php',type:'POST',data:{request:"fetch", screen:self.requestedWardrobe ? self.requestedWardrobe : "wardrobe", location: self.location }, dataType:'json',success:configure,error:errorHandler});
	}
	
	function configure(pData)
	{
		//holds the next counter up for this user
		self.nextId = pData.count || 1;
		
		if (pData && pData.length>0)
			pData = pData[0];
		forceNonGeneric = false;
		saveAsGeneric = false;

		saved = pData.wardrobe ? JSON.parse(pData.wardrobe) : null;
		if(saved) savedScreenValue = pData.screen;

		//if (!savedScreenValue && self.nextId >= 0)
		if (!self.requestedWardrobe && self.nextId >= 0)
		{
			savedScreenValue = "wardrobe-"+self.nextId;
			self.title = "Career Outfitters - "+self.nextId;
		}
		else
		{
			self.title = (saved ? saved.title : "Career Outfitters - "+self.nextId);
		}
		
		container = $("#wardrobe");
		generic = "false";	

		if(configured)
		{
			//onRestart();
			applySavedState(saved);
			quest.update(quest.PROGRAM_LINKS,{});
			return;
		}	

		configured = true;

		backgrounds = [];
		container.find("a.tab").click(onSelectTab).each(function(index){$(this).attr("data-panel","tab-"+index); $(this).siblings("form.panel").attr("id","tab-"+index);});

		$("#wardrobe-activity-done-button").click(function(event){$("#wardrobe-activity").hide()});
		
		container.find("#wardrobe-choose-background").find("li")
			.each(function(index){
				if ($(this).attr("id").indexOf("background-")>-1)
					backgrounds.push({index:0,list:$(this).attr("data-background").split(",")})
			})
			.on("click",function(event){
				var newValue = $(this).attr("id").substring($(this).attr("id").lastIndexOf("-")+1, $(this).attr("id").length);
				currentBackground = backgrounds[parseInt(newValue) - 1];
				currentBackgroundIndex = parseInt(newValue);
				renderBackground();
			})
			.eq(0).attr("checked","checked");

		currentBackground = backgrounds[0];

		container.find("#wardrobe-choose-outfit").find("li")
			.each(function(index){
				if ($(this).attr("id").indexOf("outfit-")>-1)
					outfits.push({index:0,list:$(this).attr("data-outfit").split(",")})
			})
			.on("click",function(event){
				var newValue = $(this).attr("id").substring($(this).attr("id").lastIndexOf("-")+1, $(this).attr("id").length);
				currentOutfit = outfits[parseInt(newValue) - 1];
				currentOutfitIndex = parseInt(newValue);
				showOutfit.bind(this)();
			})
			.eq(0).attr("checked","checked");


		container.find("#wardrobe-choose-head").find("li")
			.each(function(index){
				if ($(this).attr("id").indexOf("head-")>-1)
					heads.push({index:0,list:$(this).attr("data-head").split(",")})
			})
			.on("click",function(event){
				var newValue = $(this).attr("id").substring($(this).attr("id").lastIndexOf("-")+1, $(this).attr("id").length);
				currentHead = heads[parseInt(newValue) - 1];
				currentHeadIndex = parseInt(newValue);
				showHead();
			})
			.eq(0).attr("checked","checked");


		container.find("#wardrobe-body-head").addClass("head-"+quest.settings.avatar);
//		container.find("#wardrobe-background").find("fieldset").eq(1).find("input").on("change",function(event){
//		});

		currentBackgroundIndex = 1;
		currentHeadIndex = currentOutfitIndex = 0;

//scroll
		$(".wardrobe-button-scroll").click(onShopScroll);

		$("#wardrobe-wearoutfit").click(renderOutfit);
		$("#wardrobe-wearaccess").click(renderHead);
		$("#wardrobe-choose-outfit").find("form").show().addClass("selected");

		$("#showWardrobe").click(function() {$("#all-professions").show();$("#all-accessory-description").hide();$("#wardrobe-prompt").hide();$(this).addClass("selected");$("#showWriting").removeClass("selected");});
		$("#showWriting").click(function() {$("#all-professions").hide();$("#all-accessory-description").hide();$("#wardrobe-prompt").show();$(this).addClass("selected");$("#showWardrobe").removeClass("selected");});
		$("#wardrobe-prompt").hide();

		//professions
		//Using the glossary functionality, but for bringing up more info on related careers
		glossary = container.find("#db-glossary-wardrobe");
		glossary = $("#db-glossary-wardrobe");
		container.find("button.glossary-link").on("click",onGlossaryRequest);
		//SAVING
		$("#wardrobe-single").find('input[type=submit]').click(onDone);

		//onRestart();
		applySavedState(saved);
		quest.update(quest.PROGRAM_LINKS,{});
		//container.find("#wardrobe-info").click(function(){$("#wardrobe-activity").show()});
	}

	function applySavedState(data)
	{
		if(!data) 
		{
			console.log("in apply saved date without title");
			//self.title = "Career Outfitters"
			return;
		}


		var textarea = container.find("textarea#wardrobe-prompt-input");
		

		if (!self.requestedWardrobe)
		{
			//start anew
			currentBackgroundIndex = 1;
			currentHeadIndex = currentOutfitIndex = 0;
			textarea.val('');
		}
		else
		{
			//restore saved
			currentOutfitIndex = data.outfit;
			currentBackgroundIndex = data.background;
			currentHeadIndex = data.head;

			self.title = data.title || "";
			textarea.val(data.description);
		}

		currentBackground = backgrounds[parseInt(currentBackgroundIndex)-1];
		currentOutfit = outfits[parseInt(currentOutfitIndex)-1];
		currentHead = heads[parseInt(currentHeadIndex)-1];

		fetchOutfit();
		fetchBackground();
		fetchHead();

		//showOutfit();

		$("#outfit-scroll").find("li").eq(0).click();

		renderOutfit();
		renderHead();
		renderBackground();

		$("#all-professions").show();
		$("#all-accessory-description").hide();
		$("#wardrobe-prompt").hide();
		$("#showWardrobe").addClass("selected");
		$("#showWriting").removeClass("selected");
	}

	function onSave(event,preventGeneric)
	{
		//MD TODO

		savedScreenValue = savedScreenValue || (self.requestedWardrobe || "wardrobe") + (saveAsGeneric ? Math.round(Math.random()*100000000) : "");
		var screenID = savedScreenValue;
		$("#wardrobe-single").find('input[type="submit"]').css("opacity",0);
		$.ajax({url:'php/wardrobe.php',type:'POST',data:{request:"save", screen:screenID,generic:false,location: self.location, wardrobe:synthesizeJSON() },dataType:'json',success:wardrobeHandler,error:errorHandler});
	}

	function synthesizeJSON()
	{
		var data = {};
		data.outfit = currentOutfitIndex;
		data.background = currentBackgroundIndex;
		data.head = currentHeadIndex;
		data.title = self.title;
		data.description = container.find("textarea#wardrobe-prompt-input").val();

		return JSON.stringify(data);
	}


	function wardrobeHandler(data)
	{
		/*if(data.badTitle)
		{
			quest.showAlert("wardrobe"); // TODO ??
			//container.find("#collage-save").animate({opacity:1});
			$("#wardrobe-single").find('input[type="submit"]').animate({opacity:1});
			return;
		}*/
		$("#wardrobe-single").find('input[type="submit"]').animate({opacity:1})
	}
	function errorHandler(result)
	{
		console.log("result",result);
		//quest.showAlert("shutdown");
	}

	function onDone(event)
	{
		if(!$("#wardrobe-single").find("textarea").val() || $("#wardrobe-single").find("textarea").val().match(/\S+/g).length < 6)
		{
			return quest.showAlert("words","prompt-input");
		}
		
		quest.login.completions[quest.wardrobe.requestedWardrobe] = true;
		onSave(null,true);
		saved = true;
		self.requestedWardrobe = null;
		var toLoad = quest.previousPage || "map";
		quest.loadScreen(toLoad);
	}

	

	/*function onRestart(event)
	{
		container.find("#wardrobe-choose-outfit").find("input").eq(0).prop("checked","checked");
		container.find("#wardrobe-choose-head").find("input").eq(0).prop("checked","checked");
		container.find("#wardrobe-choose-background").find("input").prop("checked",false);
		container.find(".panel").hide();

		currentOutfitIndex = 0;
		currentBackgroundIndex = 1;
		currentHeadIndex = 0;
		currentOutfit = outfits[currentOutfitIndex];
		currentHead = heads[currentHeadIndex];
		currentBackground = backgrounds[currentBackgroundIndex];
	}*/


	function fetchBackground()
	{
		if(currentBackground.index >= currentBackground.list.length) currentBackground.index = 0;
		var background = currentBackground.list[currentBackground.index]
		currentBackground.index ++;
		return background;
	}

	function renderBackground()
	{
		container.find("#wardrobe-background").removeClass().addClass(fetchBackground());
	}

	function showOutfit()
	{
		var outfit = fetchOutfit();
		container.find(".wardrobe-descr:not(#"+$(this).attr("data-profession")+")").hide();
		container.find(".wardrobe-descr").each(function(){
			if (outfit === $(this).attr("data-profession") )
			{
				$(this).show();
			}
		});

		if ($('#all-professions').css('display') === 'none')
		{
			$('#all-professions').show();
			$('#all-accessory-description').hide();
		}
		self.currentProfession = $(this).attr("data-outfit");
		quest.audio.close();
	}

	function fetchOutfit()
	{
		if (!currentOutfit)
			currentOutfit = outfits[0];
		if(currentOutfit.index >= currentOutfit.list.length) currentOutfit.index = 0;
		var outfit = currentOutfit.list[currentOutfit.index];
		currentOutfit.index ++;
		return outfit;
	}

	function renderOutfit()
	{
		container.find("#wardrobe-outfit").removeClass().addClass(fetchOutfit());
	}

	function showHead()
	{
		var head = fetchHead();
		container.find(".wardrobe-descr-access:not(#"+$(this).attr("data-accessory")+")").hide();
		container.find(".wardrobe-descr-access").each(function(){
			if (head === $(this).attr("data-accessory") )
			{
				self.currentAccessory = $(this).attr("data-accessory");
				if(self.currentAccessory  === "none") $(".glossary-audio-button").hide();
				else $(".glossary-audio-button").show();
				$(this).show();
			}
		});
		if ($('#all-accessory-description').css('display') === 'none')
		{
			$('#all-professions').hide();
			$('#all-accessory-description').show();
			self.currentAccessory = "";
		}
	}

	function fetchHead()
	{
		if (!currentHead)
			currentHead = heads[0];
		if(currentHead.index >= currentHead.list.length) currentHead.index = 0;
		var head = currentHead.list[currentHead.index]
		currentHead.index ++;
		return head;
	}

	function renderHead(event)
	{
		var accessory = fetchHead();

		if (accessory === 'none')
			accessory ='';
		self.currentAccessory = accessory;

		container.find("#wardrobe-body-head").removeClass().addClass("head-"+quest.settings.avatar).addClass(accessory);
	}

	function onSelectTab(event)
	{
		var panel = $(this).siblings(".panel");
		$(panel).closest("a.tab").removeClass("selected");
		container.find(".panel:not(#"+$(this).attr("data-panel")+")").closest("a.tab.selected").removeClass("selected");
		container.find(".panel:not(#"+$(this).attr("data-panel")+")").hide();
		panel.show();
		$(".wardrobe-selection").find("a.tab").removeClass("selected");
		$(this).addClass("selected");

		if($(this).data("panel") == "tab-1" || $(this).data("panel") == "tab-2") $("#wardrobe-description").find("a.glossary-audio-button").show().data("current-tab",$(this).data("panel"));
		else $("#wardrobe-description").find("a.glossary-audio-button").hide();
		if($(this).data("panel") == "tab-2" && self.currentAccessory == "") $("#wardrobe-description").find("a.glossary-audio-button").hide();

		//Change the descriptions as well
		if ($(this).closest("div").attr("id").indexOf("outfit") > -1)
		{
			$("#all-professions").show();
			$("#all-accessory-description").hide();
		}
		else
		{
			$("#all-professions").hide();
			$("#all-accessory-description").show();
			showHead();
		}
	}

//scroll
	function onShopScroll(event)
	{
		var up = $(this).attr("id") == "wardrobe-scroll-up";
		var parent = $(this).closest('div');
		var parentName = $(parent).attr("id");
		var whichone = parentName.substring(parentName.lastIndexOf("-")+1, parentName.length);
		//var scroll= 0;
		switch (whichone) {
			case "head":
				if(up)
				{
					if(scrollH > 0) scrollH --;
					$("#head-scroll").scrollTo('li.formrow:eq('+scrollH+')', {axis:'y'});
				}
				else
				{
					if(scrollH < $("#head-scroll").find("li.formrow").length - 1) scrollH ++;
					$("#head-scroll").scrollTo('li.formrow:eq('+scrollH+')', {axis:'y'});
				}
				break;
			case "outfit":
				if(up)
				{
					if(scrollC > 0) scrollC --;
					$("#outfit-scroll").scrollTo('li.formrow:eq('+scrollC+')', {axis:'y'});
				}
				else
				{
					if(scrollC < $("#outfit-scroll").find("li.formrow").length - 1) scrollC ++;
					$("#outfit-scroll").scrollTo('li.formrow:eq('+scrollC+')', {axis:'y'});
				}
				break;
			case "background":
				if(up)
				{
					if(scrollP > 0) scrollP --;
					$("#place-scroll").scrollTo('li.formrow:eq('+scrollP+')', {axis:'y'});
				}
				else
				{
					if(scrollP < $("#place-scroll").find("li.formrow").length - 1) scrollP ++;
					$("#place-scroll").scrollTo('li.formrow:eq('+scrollP+')', {axis:'y'});
				}
				break;
			}
	}

	function onGlossaryRequest(event)
	{
		var button = $(this);
		var audioID = button.attr("data-audio-id");
		var word = "<a class='glossary-audio-button' href='javascript:void(0)' data-audio='"+audioID+"'>Play Audio</a> " + button.siblings("label").text();
		var definition = button.attr("data-def");

		event.preventDefault();
		event.stopImmediatePropagation();
		quest.audio.close();

		glossary.find("h3").html(word).find("a").on("click",function(){
			quest.audio.playClip('audio/careeroutfitters_'+$(this).data("audio")+'.mp3');
		});
		glossary.find("p").html(definition);
		//trap focus on the glossary panel to prevent keyboard navigation away when still active
		glossary.ariaFadeIn({complete:function(){
			glossary.attr("tabindex","-1").focus();
			glossary.on("keydown.glossary",function(e){
				if(e.keyCode === 27) return glossaryClose.bind(button)();
				if(e.keyCode === 9) 
				{
					e.preventDefault();
					e.stopImmediatePropagation();
					glossary.find("button").focus();
				}
			});
			glossary.find("button").on("click.glossary-exit",glossaryClose.bind(button));

		}});	

		quest.update(quest.PROGRAM_LINKS,{});	
	}

	function glossaryClose(event)
	{
		quest.audio.close();
		glossary.find("button").off("click.glossary-exit");
		glossary.off("keydown.glossary");
		glossary.ariaFadeOut();
		this.focus();
	}
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
	
}(quest,quest.wardrobe = quest.wardrobe || {}));
quest.wheel = (function(quest,self){
	
	var trace = quest.trace;
	var configured = false;
	var spinning = false;
	var interval, increment, lights, total, spins, pick, currentActivityType, currentActivityID, currentActivityTarget;
	var activitySource = ["collage-9","collage-1","collage-7","collage-8","collage-4","collage-5","collage-6",
							"collage-3",
							"prompt-2","prompt-5","prompt-10","prompt-1","prompt-11","prompt-12","prompt-13","prompt-14","prompt-7","prompt-3"];
	var activities = [];

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.WHEEL_PAGE) configure();
	}

	function configure()
	{
		$("#wheel-avatar").attr("class",quest.settings.avatar);
		$("#wheel-mate").attr("class",quest.settings.mate);
		if(configured) return;
		configured = true;
		lights = $("#wheel-activity-spinner").find(".light");
		total = lights.length;
		increment = spins = 0;
		pick = -1;

		$("#wheel-activity-spin").click(spin);
		$("#wheel-activity-go").click(go);

		activities = activitySource.concat();
	}
	var node;
	function renderPrompt(increment)
	{
		var light = lights.eq(increment);
		//currentActivityType = light.attr("data-type");
		//currentActivityID = light.attr("data-activity-id");

		if(!activities.length) activities = activitySource.concat();

		var index = Math.floor(Math.random()* activities.length);
		var activity = activities[index];
		activities.splice(index,1);

		var content = $("#"+activity);
		currentActivityID = activity;
		currentActivityType = activity.match(/prompt/gim) ? "prompt" : "collage";

		node = $(quest.xml).find("screen#"+ currentActivityType).find("#"+ currentActivityID);
		currentActivityTarget = node.attr("data-target");

		quest.audio.playClip("audio/"+activity+"-title");

		$("#wheel-activity-prompt").html(node.find("title").text());
   	    $("#wheel-activity").fadeIn();
	}

	function go()
	{
		switch(currentActivityType)
		{
			case "collage":
				quest.collage.spawnGeneric = false;
				quest.collage.requestedTitle = node.find("abbrev").text();
				quest.collage.location = currentActivityTarget;
				quest.collage.requestedCollage = currentActivityID;
				quest.loadScreen(quest.settings.COLLAGE_PAGE);
			break;
			case "prompt":
				quest.prompt.spawnGeneric = false;
				quest.prompt.requestedTitle = node.find("abbrev").text();
				quest.prompt.location = currentActivityTarget;
				quest.prompt.requestedPrompt= currentActivityID;
				quest.loadScreen(quest.settings.PROMPT_PAGE);

			break;
			default:
		}
	}

	function hidePrompt()
	{
		$("#wheel-activity").fadeOut();
	}

	function spin()
	{
		if(spinning) return;
		$("#wheel-popup").hide();
		spinning = true;
		lights.removeClass("lit").removeClass("active");
		interval = setInterval(incrementPosition,100);
		$("#wheel-activity").fadeOut();
		hidePrompt();
	}

	function incrementPosition()
	{
		if(increment >= total)
		{
			spins ++;
			increment = 0;
		}
		if(spins == 3)
		{
			if(pick == -1) pick = Math.floor(Math.random() * total);
			if(increment == pick)
			{
				clearInterval(interval);
				lights.removeClass("lit");
				lights.eq(increment).addClass("lit").addClass("active");
				renderPrompt(increment);
				spinning = false;
				increment = (increment+1) >= total ? 0 : (increment + 1);
				spins = 0;
				pick = -1;
				
				return;
			}
		}



		lights.removeClass("lit");
		lights.eq(increment).addClass("lit");
		increment ++;
	}

	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.wheel = quest.wheel || {}))

quest.teacherLanding = (function(quest,self){
	
	var trace = quest.trace;
	var configured = false;
	
	self.loadIsland = function(){
		$("#ui-map").click();
	};
	self.adminStudents = function(){
		window.location.href = "/toolkit/teacher-control-panel";
	};
	self.sendMessage = function(){
		$("#header-messages").click();
	};
	self.studentPortfolios = function(){
		window.location.href = "/toolkit/teacher/administrator";
	};

	self.teacherResources = function(){
		$("div#teachDrop > h4.closer").click();
	};
	self.teachingToolkit = function(){
		window.location.href = "/toolkit";
	};

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.TEACHER_LANDING_PAGE) configure();
	}
	function configure()
	{
		var container = $("#"+quest.settings.TEACHER_LANDING_PAGE);
		if(!configured) return;
		configured = true;
	}
	
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.teacherLanding = quest.teacherLanding || {}));
quest.studentLanding = (function(quest,self){
	
	var trace = quest.trace;
	var configured = false;
	var index = 0;
	var frames,container;

	function onApplicationUpdate(pType,pData)
	{
		if(pType == quest.PAGE_LOAD && pData.id == quest.settings.STUDENT_LANDING_PAGE) configure();
	}
	function configure()
	{
		container = $("#"+quest.settings.STUDENT_LANDING_PAGE);
		if(configured){
			index = 0;
			container.find(".slide:lt("+index+")").removeClass("center").addClass("left");
			container.find(".slide:gt("+index+")").removeClass("center").addClass("right");
			container.find(".slide").eq(index).removeClass("left right").addClass("center");
			container.attr("data-slide",index);

			return;
		}
		configured = true;
		frames = container.find(".slide");
		container.attr("data-slide",index);
	}

	self.advanceFrame = function(){
		if(index < frames.length - 1){
			index++;
			container.find(".slide:lt("+index+")").removeClass("center").addClass("left");
			container.find(".slide:gt("+index+")").removeClass("center").addClass("right");
			container.find(".slide").eq(index).removeClass("left right").addClass("center");
			container.attr("data-slide",index);
		}
		else{
			quest.loadScreen(quest.settings.PORT_PAGE);
		}
	};
	self.rewindFrame = function(){
		if(index > 0){
			index--;
			container.find(".slide:lt("+index+")").removeClass("center").addClass("left");
			container.find(".slide:gt("+index+")").removeClass("center").addClass("right");
			container.find(".slide").eq(index).removeClass("left right").addClass("center");
			container.attr("data-slide",index);
		}
		else{
		}
	};

	
	
	quest.registerEventListener(onApplicationUpdate);
	
	return self;
}(quest,quest.teacherLanding = quest.teacherLanding || {}));
(function () {'use strict';}());
var fqiadmin = (function(self){

	angular.module('fqi', []).config(function($sceProvider){
		$sceProvider.enabled(false);
	});
	
	angular.trace = function (){
	    for(var i = 0, count = arguments.length; i < count; i++)
	    {
	      try {console.log(arguments[i]);}
	      catch (error){}
	    }
	  };


	return self;
}(fqiadmin = fqiadmin || {}));
(function () {'use strict';}());

angular.module('fqi')
  .controller('FQIController', function ($scope,$timeout,FQIService) {
  	var trace = angular.trace;

  	$scope.PAGE_STUDENT_WORK = 0;
    $scope.PAGE_UNIT_OVERVIEW = 1;
    $scope.PAGE_STUDENT_LIST = 2;
    $scope.PAGE_HELP = 3;
    $scope.PAGE_TOOLS = 4;

  	$scope.username = null;
  	$scope.yearList = [];
  	$scope.currentYear = null;
  	$scope.currentClasses = null;
  	$scope.currentClass = null;
  	$scope.currentStudent = null;
  	$scope.currentWork = null;
  	$scope.currentPage = -1;

    $scope.currentUnit = null;
    $scope.currentAcivity = null;

    $scope.ACTIVITY_TAB_COVE = "cove";
    $scope.ACTIVITY_TAB_SANCTUARY = "sanctuary";
    $scope.ACTIVITY_TAB_MOUNTAIN = "mountain";
    $scope.ACTIVITY_TAB_EXTRAS = "extras";
    $scope.ACTIVITY_TAB_PASSPORT = "passport";

  	$scope.selectionData = {selectedClass:null};
    $scope.currentActivityRating = {value:0};
  	$scope.processing = false;

    $scope.ratingInfo = {};

    $scope.deletions = [];

    quest.registerEventListener(onApplicationUpdate);

    $scope.getCurrentPage = function(){
    	return $scope.currentPage;
    };

    $scope.setCurrentPage = function(page,preserve){
      trace("setting current page: " + page);
      $scope.currentUnit = $scope.currentActivity = null;
      if(page === $scope.currentPage) return;
      if(page === $scope.PAGE_UNIT_OVERVIEW) {
        FQIService.fetchUnitOverview().then(function(){
          $scope.units = FQIService.unitOverview;
          $scope.currentPage = page;
          if($scope.requestedActivity) $timeout(function(){
            $scope.requestActivityPage($scope.requestedActivity)
          },0);
          
        });
      }
      else {
        $scope.currentPage = page;
        trace("req: " + $scope.requestedActivity);
         if($scope.requestedActivity) $timeout(function(){
            $scope.requestActivityPage($scope.requestedActivity)
          },100);
      }

      
    	
    };

    $scope.requestActivityPage = function(url){
      var units = $scope.units;
      trace("unset");
      $scope.requestedActivity = null;
      if(!units) return;
      for(var i = 0, count = units.length; i < count; i++) {
        var activities = units[i].listing;
        for(var j = 0, numAct = activities.length; j < numAct; j++){
          var activity = activities[j];
          if(activity.url === url) {
            $scope.currentUnit = units[i];
            $scope.selectActivity(activity);
            return;
          }
        }
      }
    };

    $scope.requestActivityOnPage = function(url,page){
      trace("requesting activity: " + url);
      $scope.currentPage = null;
      $scope.requestedActivity = url;
      $scope.setCurrentPage(page);
    };

    $scope.selectClass = function(){
    	$scope.processing = true;
    	$timeout(fetchClass,500);
    };

    $scope.selectClass = function(){
      $scope.processing = true;
      $timeout(fetchClass,500);
    };

    $scope.setCurrentClass = function(value){
      $scope.currentClass = null;
      $scope.currentStudent = null;
      $scope.currentWork = null;
    };

    $scope.setSelectedActivityTab = function(tab){
      $scope.selectedActivityTab = tab;
    };

    $scope.setCurrentAssignment = function(assignment){
      $scope.currentAssignment = assignment;
    };

    $scope.setCurrentPageHeader = function(header) {
      $scope.currentPageHeader = header;
    };

    $scope.hideDetailView = function(){
      $scope.currentUnit = $scope.currentAssignment = null;
    };


    $scope.viewStudentWork = function($event,assignment){
      $event.stopImmediatePropagation();
      assignment.update = $scope.$apply.bind(this);
      quest.loadScreen("portfolio");
      quest.portfolio.viewStudentWork(assignment);
    };

    $scope.rateUnit = function(event,unit){
      event.preventDefault();
      event.stopImmediatePropagation();
      $scope.currentBackup = angular.copy(unit.userInfo);
      $scope.currentRatedObject = unit;
    };

    $scope.commitRating = function(){
      FQIService.commitUserInfo($scope.currentRatedObject.userInfo).then(function(){
        $scope.currentRatedObject  = null;
      });
    };

    $scope.commitCompletionChange = function() {
      FQIService.commitUserInfo($scope.currentActivity.userInfo);
    };

    $scope.clearChanges = function() {
      $scope.currentRatedObject.userInfo = $scope.currentBackup;
      $scope.currentRatedObject = null;
    };

    $scope.selectUnit = function(unit){
      $scope.currentUnit = unit;
      if($scope.currentUnit) $scope.currentActivity = unit.listing[0];
    };

    $scope.showRating = function(activity){
      $scope.currentRatedObject = activity;
    };

    $scope.sendMessage = function() {
      quest.presetMessage = $(".preset-message").html();
      if(!quest.presetMessage || !quest.presetMessage.length) quest.presetMessage = "No Instructions";
      $("#header-messages").click();
    };

    $scope.selectActivity = function(activity){
      $scope.transitioning = true;
      $timeout(function(){
        $scope.currentActivity = null
        $timeout(function(){
          $scope.currentActivity = activity;
          $timeout(function(){
             $scope.transitioning = false;
          },0);
        },0)
      },250);
      //$scope.currentActivity = $scope.currentUnit.activities[index];
    };

    $scope.updateStudentPassword = function(student,password) {
      FQIService.updateStudentPassword(student.id,password);
    };
    $scope.hideStudent = function(student) {
      $scope.deletions.push(student.id);
      $scope.currentClass.students.splice($scope.currentClass.students.indexOf(student),1);
      FQIService.hideStudent(student.id);
    };



    function onApplicationUpdate(type,data){
    	if(type === "login") $scope.$apply(loginHandler);
      if(type === "page-load" && data.id === "teacher-administration-container"){
        $scope.currentUnit = $scope.currentActivity = null;
        $scope.$apply(function(){
          var page = isNaN(quest.subpage) ? $scope.PAGE_STUDENT_WORK : quest.subpage;
          $scope.setCurrentPage(page);
        });
      }
    }

    function loginHandler(data){
    	var login = quest.login;
    	if(!login) return;
    	login.yearList.sort(sortYears);
    	$scope.username = login.username;
    	$scope.yearList = login.yearList;
    	$scope.currentYear = $scope.yearList[0];
      //$scope.setCurrentPage($scope.PAGE_UNIT_OVERVIEW);
    }

    function fetchClass(){
    	$scope.currentClass = $scope.selectionData.selectedClass;
    	FQIService.fetchActivitiesForClass(getStudentIds()).then(onFetchActivities);
    }

    function getStudentIds(){
    	var ids = [];
    	for(var i = 0, count = $scope.currentClass.students.length; i < count; i++){
    		var student = $scope.currentClass.students[i];
    		ids.push(student.id);
    	}
    	return ids.join(",");
    }

    function onFetchActivities(){
    	$scope.activitiesTable = FQIService.activities;
    	$scope.selectedActivityTab = $scope.ACTIVITY_TAB_SANCTUARY;
    	$timeout(restoreView,500);
    }

    function restoreView(){
    	$scope.processing = false;
    }

    function sortYears(a,b){
    	if(a.name > b.name) return -1;
    	if(a.name < b.name) return 1;
    	return 0;
    }

  });

(function () {'use strict';}());
angular.module('fqi').service('FQIService', function($http, $filter)
{
	var trace = angular.trace;
	var self = {};

	self.activities = {};

	self.fetchActivitiesForClass = function(studentIds){
		return $http.post("php/FQIAdministrationService.php",{request:"fetchActivitiesForClass",ids:studentIds}).then(synthesizeActivityTable);
	};

	self.fetchUnitOverview = function() {
		return $http.post("php/FQIAdministrationService.php",{request:"fetchUnitsAndActivities"}).then(synthesizeUnitOverview);
	};

	self.commitUserInfo = function(info) {
		return $http.post("php/FQIAdministrationService.php",{request:"commitUserInfo",info:info});
	};

	self.updateStudentPassword = function(id,password) {
		return $http.post("php/FQIAdministrationService.php",{request:"updateStudentPassword",id:id,password:password});
	};
	self.hideStudent = function(id,password) {
		return $http.post("php/FQIAdministrationService.php",{request:"hideStudent",id:id});
	};

	function synthesizeUnitOverview(result){
		var status = result.data.status;
		self.unitOverview = result.data.units;
		for(var i = 0, count = self.unitOverview.length; i < count; i++){
			var unit = self.unitOverview[i];
			var activities = unit.activities;
			unit.userInfo = status.units[unit.id] || {id:unit.id,type:"units",status:"incomplete",rating:null,comments:null};

			for(var j = 0, numActivities = activities.length; j < numActivities; j++){
				var activity = activities[j];
				activity.userInfo = status.activities[activity.id] || {id:activity.id,type:"activities",status:"incomplete",rating:null,comments:null};
			}
			unit.listing = [unit].concat(activities);
			//unit.listing.sort(sortActivities);
		}
	}

	function sortActivities(a,b){
		if(a.orderIndex > b.orderIndex) return 1;
		if(a.orderIndex < b.orderIndex) return -1;
		return 0;
	}

	function synthesizeActivityTable(result){
		var headers = {sanctuary:[],mountain:[],cove:[],extras:[],passport:[]};
		var location,activity,info,type,name,i,count,stored,users,user,completions,row,source;
		var results = result.data.rows;
		var wheel = ["collage-9","collage-1","collage-7","collage-8","collage-4","collage-5","collage-6","collage-15",
    						"prompt-2","prompt-5","prompt-6","prompt-1","prompt-11","prompt-12","prompt-13","prompt-14"];
    	var passport = ["organizer-1","organizer-2","organizer-4","organizer-5","collage-11","collage-12","prompt-9","collage-13","collage-14","collage-8","prompt-6"];
    	var xml = $(quest.xml);
    	self.activities = {};
		$("#chest-popup .link-container").find("a").each(function(){
			activity = $(this);
			info = activity.attr("class").split(" ");
			type = info[1];
			name = activity.data(type);
			location = info[0];

			if(type === "plan") return;
			stored = headers[location].filter(filterLocation,type);
			if(!self.activities[location]) self.activities[location] = [];
			headers[location].push({index:stored.length + 1, label: name, location: location, type: type, status: "incomplete", coins: 0, comment: null});
		});

		for(i = 0, count = wheel.length; i < count; i++){
			name = wheel[i];
			source = xml.find("#"+name);
			location = source.attr("data-target");
			type = name.replace(/-\d{1,2}/gim,"");
			stored = headers[location].filter(filterLocation,type);
			headers[location].push({index:stored.length + 1,label:name,location:location,type:type,status:"incomplete",coins:0,comment:null});
		}

		self.activities.passport = [];
		self.activities.extras = [];

		for(i = 0, count = passport.length; i < count; i++){
			name = passport[i];
			source = xml.find("#"+name);
			location = "passport";
			type = name.replace(/-\d{1,2}/gim,"");
			stored = headers[location].filter(filterLocation,type);
			headers[location].push({index:stored.length + 1,label:name,location:location,type:type,status:"incomplete",coins:0,comment:null});
		}

		users = results.filter(filterDistinctUsers,[]).map(mapUserId);
		var skipped = [];
		for(location in headers){
			//if(location == "extras") continue;
			info = headers[location];
			info.sort(sortLocation);

			for(i = 0, count = users.length; i < count; i++){
				user = users[i];

				if(location == "passport") completions = results.filter(filterResultsForUserAndActivities,{user:user.id,activities:passport});
				else completions = results.filter(filterResultsForUserAndLocation,{user:user.id,location:location});
				
				/*if(!completions.length) {
					row = location == "extras" ? generateRowForUser(completions,info,skipped);
					row[0].name = user.name;
					self.activities[location].push(row);
					continue;
				}*/

				if(location == "extras"){
					row = completions;
					row.forEach(completeActivity);
				}
				else {
					row = generateRowForUser(completions,info,skipped);
				}

				if(!row[0]) {
					self.activities[location].push(row);
					continue;
				}

				row[0].name = user.name;
				self.activities[location].push(row);
			}
		}

		self.activities.extras.sort(sortByMostResponses)
	}

	function sortByMostResponses(a,b){
		if(a.length > b.length) return -1;
		if(a.length < b.length) return 1;
		return 0;
	}

	function generateRowForUser(completions,info,skipped){

		var copy = angular.copy(info);
		var lookup = {};
		var i,count,row,template;

		for(i = 0, count = copy.length; i < count; i++){
			row = copy[i];
			lookup[row.label] = row;
		}

		for(i = 0, count = completions.length; i < count; i++){
			row = completions[i];
			template = lookup[row.screen];
			if(!template){
				if(skipped.indexOf(row.screen) === -1) skipped.push(row.screen);
				continue;
			}
			template.coins = row.coins_earned;
			template.comment = row.currentComment;
			template.status = "complete";
			template.userid = row.userID;
			template.updated = row.updated;
			template.title = row.activity_title;
			template.name = row.name;
			template.activityID = row.id;
			template.data = row.data;
			template.commentText = row.commentText;
			template.rating = row.rating;
		}

		return copy;
	}

	function completeActivity(element,index){
		element.status = "complete";
		element.coins = element.coins_earned;
		element.comment = element.currentComment;
		element.userid = element.userID;
		element.title = element.activity_title;
		element.activityID = element.id;
		element.index = index+1;
	}

	function sortLocation(a,b){
		var order = ["prompt","collage","organizer","wardrobe"];
		if(order.indexOf(a.type) > order.indexOf(b.type)) return 1;
		if(order.indexOf(a.type) < order.indexOf(b.type)) return -1;
		if(a.index > b.index) return 1;
		if(a.index < b.index) return -1;
		return 0;
	}

	function filterDistinctUsers(element){
		if(this.indexOf(element.userID) !== -1) return false;
		this.push(element.userID);
		return true;
	}

	function mapUserId(element){
		return {id:element.userID,name: element.name};
	}

	function filterResultsForUserAndLocation(element){
		if(element.userID == this.user && element.location == this.location) return true;
		return false;
	}
	function filterResultsForUserAndActivities(element){
		if(element.userID == this.user && this.activities.indexOf(element.screen) != -1) return true;
		return false;
	}
	//,{user:user.id,activities:passport}

	function filterLocation(element){
		if(element.type == this) return true;
		return false;
	}

	return self;
});
(function () {'use strict';}());
angular.module("fqi").directive('studentWork', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'administration/views/student-work.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.getCoinsLabel = function(assignment) {
        	if(assignment.rating === null) return '0/6';
        	return (assignment.coins) + '/6';
        }
      }  
    };
  });
(function () {'use strict';}());
angular.module("fqi").directive('unitOverview', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'administration/views/unit-overview.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        /*$scope.units = [ { id: 1, title: 'Getting Started', filename: 'unit1-1', completions: [], activities: [] }, { id: 2, title: 'Pre Surveys', filename: 'unit2-1', completions: [], activities: [] }, { id: 3, title: 'Future Forecast', filename: 'unit3-1', completions: [], activities: [ 'activity3-1', 'activity3-2', 'activity3-3' ] }, { id: 4, title: 'About Me', filename: 'unit4-1', completions: [], activities: [ 'activity4-1', 'activity4-2', 'activity4-3', 'activity4-4', 'activity4-5', 'activity4-6', 'activity4-7' ] }, { id: 5, title: 'Career Exploration', filename: 'unit5-1', completions: [], activities: [ 'activity-5-1', 'activity-5-2', 'activity-5-3', 'activity-5-4', 'activity-5-5', 'activity-5-6', 'activity-5-7' ] }, { id: 6, title: 'College Cove', filename: 'unit6-1', completions: [], activities: [ 'activity6-1', 'activity6-2', 'activity6-3', 'activity6-4', 'activity6-5', 'activity6-6', 'activity6-7', 'activity6-clam', 'activity6-crab', 'activity6-seagull' ] }, { id: 7, title: 'Social Sanctuary', filename: 'unit7-1', completions: [], activities: [ 'activity7-1', 'activity7-2', 'activity7-3', 'activity7-4' ] }, { id: 8, title: 'E Portfolio &amp; ILP', filename: 'unit8-1', completions: [], activities: [] } ];
        $scope.units.forEach(function(element){
          element.activities = [element.filename].concat(element.activities);
        }); */

        $scope.getUnitCompletions = function(unit) {
          var activities = unit.activities;
          var completed = 0;
          if(!activities.length) return "--";
          for(var i = 0, count = activities.length; i < count; i++) {
            if(activities[i].userInfo.status == "complete" || activities[i].userInfo.status == "skipped") completed ++;
          }
          return completed + "/" + activities.length + " Complete";
        };

        $scope.unitRatable = function(unit) {
          var activities = unit.activities;
          var completed = 0;

          if(!activities.length) return unit.userInfo.status === "complete";

          for(var i = 0, count = activities.length; i < count; i++) {
            var activity = activities[i];
            var title = activity.shortTitle || "";
            if(title.match(/do now/gi) || title.match(/extension/gi)) completed ++;
            else if(activities[i].userInfo.status == "complete" || activities[i].userInfo.status == "skipped") completed ++;
          }
          return completed === activities.length;
        };
      }  
    };
  });
(function () {'use strict';}());
angular.module("fqi").directive('unitView', function($document,$timeout,$compile,$templateRequest) {
	    var trace = angular.trace;

	    var linker = function($scope, element, attrs){
	    	 $templateRequest("administration/units/"+attrs.page).then(function(html){
		      var template = $(html).children();
		      var header = $(html).find("h1").text();
		      element.append(template);
		      $compile(template)($scope);
		      $scope.setCurrentPageHeader(header);
		   });
	    };

	    return {
	        restrict: "A",
	        replace: true,
	        link: linker
	    };
 });
(function () {'use strict';}());
angular.module("fqi").directive('studentList', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'administration/views/student-list.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.showPasswordReset = false;
        $scope.showStudentDelete = false;
        $scope.selectedStudent = null;

        $scope.password = {text:null};

        $scope.togglePasswordReset = function(student) {
        	$scope.showPasswordReset = !$scope.showPasswordReset;
        	$scope.selectedStudent = student;
          $scope.password = {text:null};
        };

        $scope.toggleStudentDelete = function(student) {
        	$scope.showStudentDelete = !$scope.showStudentDelete;
        	$scope.selectedStudent = student;
        };


      }  
    };
  });
(function () {'use strict';}());
angular.module("fqi").directive('helpView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'administration/views/help-view.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.helpListing = [
        	{url:"help-1.html",title:"Getting Started"},
        	{url:"help-2.html",title:"Teaching Units & Activities"},
        	{url:"help-3.html",title:"Student Activities"},
        	{url:"help-4.html",title:"Island Activities and Key Terms"},
        	{url:"help-5.html",title:"Accessibility and Universal Design with Technology Features"},
        	{url:"help-6.html",title:"Troubleshooting"}
        ];

        if($scope.requestedActivity) {
          $scope.selectActivity(fetch($scope.requestedActivity));
        } else {
          $scope.selectActivity($scope.helpListing[0]);
        }

        $scope.$watch("requestedActivity",function(val){
          if(!val) return;
          $scope.selectActivity(fetch($scope.requestedActivity));
        });


        function fetch(url){
          for(var i = 0, count = $scope.helpListing.length; i < count; i++){
            var item = $scope.helpListing[i];
            if(item.url === url) return item;
          }
          return null;
        }
      }  
    };
  });
(function () {'use strict';}());
angular.module("fqi").directive('toolView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'administration/views/tools-view.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.toolListing = [
        	{url:"aboutFQI.html",title:"About Future Quest Island"},
          {url:"unit-games-activities.html", title:"Games & Activities"},
          {url:"studentGuide.html", title:"Student Guide: Getting Started"},
          {url:"postsecondaryEd.html", title:"Postsecondary Education for Students with Intellectual Disabilities"},
          {url:"keyTerms.html", title:"Key Terms"},
          {url:"projectDescription.html", title:"Project Description"},
          {url:"FacilitatorGuide.html", title:"Future Quest Island Facilitator Guide"},
          {url:"anytimeActivities.html", title:"Anytime Activities"}
        ];

        trace("loading tool view",$scope.requestedActivity);

        if($scope.requestedActivity) {
          $scope.selectActivity(fetch($scope.requestedActivity));
        } else {
          $scope.selectActivity($scope.toolListing[0]);
        }

        $scope.$watch("requestedActivity",function(val){
          if(!val) return;
          $scope.selectActivity(fetch($scope.requestedActivity));
        });


        function fetch(url){
          for(var i = 0, count = $scope.toolListing.length; i < count; i++){
            var item = $scope.toolListing[i];
            if(item.url === url) return item;
          }
          return null;
        }
       
      }  
    };
  });
angular.module('fqi').filter('deletions', function() {
    return function(listing,deletions) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

    	for(var i = 0, count = listing.length; i < count; i++) {
    		var info = listing[i];
    		var user = info[0];
    		if(!user || deletions.indexOf(user.userid) !== -1) continue;
    		results.push(info);
    	}

    	return results;
    };
});
//# sourceMappingURL=fqi.js.map